// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: `${string}://${string}` | (string & {});
};

export const Scope = {
    ADMIN: 'admin',
    PREMIUM: 'premium',
    PUBLIC: 'public'
} as const;

export type Scope = typeof Scope[keyof typeof Scope];

export const AutoblogArticleType = { GUTENBERG: 'gutenberg', NON_GUTENBERG: 'non-gutenberg' } as const;

export type AutoblogArticleType = typeof AutoblogArticleType[keyof typeof AutoblogArticleType];

export type News = {
    newsID: number;
    domainID: number;
    platform?: string;
    newsTitle?: string;
    status?: NewsStatus;
    newsSubTitle?: string;
    newsBold?: string;
    newsText?: string;
    contentShort?: string;
    contentSearchable?: string;
    host?: string;
    path?: string;
    metaTitle?: string;
    metaDescription?: string;
    newsDate: string;
    newsDateUpdate?: string;
    newsPublishDate?: string;
    notificationIsPushed?: boolean;
    originalID?: string;
    pushBody?: string;
    /**
     * Deprecated: Use `authorIDs` instead.
     *
     * @deprecated
     */
    authorUserID?: number;
    authorIDs?: Array<number>;
    userID: number;
    /**
     * @deprecated
     */
    mainTagSlug?: string;
    adsEnabled?: boolean;
    featured?: boolean;
    titleIsBold?: boolean;
    showHome?: boolean;
    sticky?: boolean;
    readTime?: number;
    commentCount?: number;
    experiment?: NewsExperiment;
    matchID?: string;
    newsCommentsEnabled?: boolean;
    imageTitle?: string;
    imageCredit?: string;
    imageCopyright?: string;
    category?: NewsCategory;
    videofeed?: NewsVideofeed;
    creator?: Author;
    author?: Author;
    authors?: Array<Author>;
    videofeedItem?: VideofeedItemPublicScope;
    /**
     * imageUrl
     *
     * Path to the images, make sure to replace the {size} placeholder with a value from ImageSizeEnum
     *
     * @deprecated
     */
    imageUrl?: string;
    /**
     * image
     *
     * The image URL.
     */
    image?: string;
    newsVideo?: string;
    /**
     * @deprecated
     */
    newsVideoImage?: string;
    newsVideoAddDate?: string;
    tags?: Array<PartialTag>;
    binaryPoll?: BinaryPoll;
    readMore?: Array<NewsReadMoreBlock>;
    alternateLinks?: Array<NewsAlternateLink>;
    socialTitle?: string;
    socialDescription?: string;
    accessLevel?: ArticleAccessLevel;
    content?: Array<ArticleBlock>;
};

export type AccessWallBlock = {
    type: ArticleBlockType;
    paywallType: AccessWallType;
};

export const AccessWallType = {
    CLUB: 'CLUB',
    IOS: 'IOS',
    LIMIT_REACHED: 'LIMIT_REACHED',
    NON_PRO: 'NON_PRO',
    NOT_AUTHENTICATED: 'NOT_AUTHENTICATED',
    SUSPENDED: 'SUSPENDED'
} as const;

export type AccessWallType = typeof AccessWallType[keyof typeof AccessWallType];

export const ArticleBlockType = {
    ACCESS_WALL_BLOCK: 'accessWallBlock',
    EMBED_BLOCK: 'embedBlock',
    EXTERNAL_SNIPPET_BLOCK: 'externalSnippetBlock',
    FRAME_BLOCK: 'frameBlock',
    GALLERY_BLOCK: 'galleryBlock',
    HTML_BLOCK: 'htmlBlock',
    IFRAME_BLOCK: 'iframeBlock',
    IMAGE_BLOCK: 'imageBlock',
    INSTAGRAM_BLOCK: 'instagramBlock',
    JOBS_OVERVIEW_BLOCK: 'jobsOverviewBlock',
    LISTICLE_BLOCK: 'listicleBlock',
    LIST_ITEM_BLOCK: 'listItemBlock',
    MATCH_DETAIL_SECTION_BLOCK: 'matchDetailSectionBlock',
    MATCH_LIST_BLOCK: 'matchListBlock',
    MATCH_PREDICTION_BLOCK: 'matchPredictionBlock',
    MEDIA_BLOCK: 'mediaBlock',
    OVERVIEW_MATCHES_BLOCK: 'overviewMatchesBlock',
    PAYWALL_BLOCK: 'paywallBlock',
    PLAYER_BLOCK: 'playerBlock',
    PLAYER_GRADES_BLOCK: 'playerGradesBlock',
    POLL_BLOCK: 'pollBlock',
    POULE_BLOCK: 'pouleBlock',
    QUOTE_BLOCK: 'quoteBlock',
    RECIPE_BLOCK: 'recipeBlock',
    RELATED_BLOCK: 'relatedBlock',
    RICH_TEXT_BLOCK: 'richTextBlock',
    STANDINGS_BLOCK: 'standingsBlock',
    STREAMER_BLOCK: 'streamerBlock',
    TABLE_BLOCK: 'tableBlock',
    TIKTOK_BLOCK: 'tiktokBlock',
    X_POST_BLOCK: 'xPostBlock',
    WATT_WIZARD_BLOCK: 'wattWizardBlock',
    YOUTUBE_BLOCK: 'youtubeBlock'
} as const;

export type ArticleBlockType = typeof ArticleBlockType[keyof typeof ArticleBlockType];

export type EmbedBlock = {
    type: ArticleBlockType;
    embedBlock: string;
};

export type ExternalSnippetBlock = {
    type: ArticleBlockType;
    targetingID?: string | null;
    customTitle?: string | null;
    content?: string | null;
};

export type FrameBlock = {
    type: ArticleBlockType;
    image?: string;
    title?: string;
    text?: string;
    blocks?: Array<ArticleBlock>;
};

export type ArticleBlock = ({
    type: 'accessWallBlock';
} & AccessWallBlock) | ({
    type: 'embedBlock';
} & EmbedBlock) | ({
    type: 'externalSnippetBlock';
} & ExternalSnippetBlock) | ({
    type: 'frameBlock';
} & FrameBlock) | ({
    type: 'galleryBlock';
} & GalleryBlock) | ({
    type: 'htmlBlock';
} & HtmlBlock) | ({
    type: 'iframeBlock';
} & IframeBlock) | ({
    type: 'imageBlock';
} & ImageBlock) | ({
    type: 'instagramBlock';
} & InstagramBlock) | ({
    type: 'jobsOverviewBlock';
} & JobsOverviewBlock) | ({
    type: 'listItemBlock';
} & ListItemBlock) | ({
    type: 'listicleBlock';
} & ListicleBlock) | ({
    type: 'matchDetailSectionBlock';
} & MatchDetailSectionBlock) | ({
    type: 'matchListBlock';
} & MatchListBlock) | ({
    type: 'matchPredictionBlock';
} & MatchPredictionBlock) | ({
    type: 'mediaBlock';
} & MediaBlock) | ({
    type: 'overviewMatchesBlock';
} & OverviewMatchesBlock) | ({
    type: 'paywallBlock';
} & PaywallBlock) | ({
    type: 'playerBlock';
} & PlayerBlock) | ({
    type: 'playerGradesBlock';
} & PlayerGradesBlock) | ({
    type: 'pollBlock';
} & PollBlock) | ({
    type: 'pouleBlock';
} & PouleBlock) | ({
    type: 'quoteBlock';
} & QuoteBlock) | ({
    type: 'recipeBlock';
} & RecipeBlock) | ({
    type: 'relatedBlock';
} & RelatedBlock) | ({
    type: 'richTextBlock';
} & RichTextBlock) | ({
    type: 'standingsBlock';
} & StandingsBlock) | ({
    type: 'streamerBlock';
} & StreamerBlock) | ({
    type: 'tableBlock';
} & TableBlock) | ({
    type: 'tiktokBlock';
} & TikTokBlock) | ({
    type: 'xPostBlock';
} & XPostBlock) | ({
    type: 'wattWizardBlock';
} & WattWizardBlock) | ({
    type: 'youtubeBlock';
} & YoutubeBlock);

export type GalleryBlock = {
    type: ArticleBlockType;
    layout?: GalleryBlockLayout;
    images: Array<ImageBlock>;
};

export const GalleryBlockLayout = {
    COLUMNS_DEFAULT: 'columns-default',
    COLUMNS_1: 'columns-1',
    COLUMNS_2: 'columns-2',
    COLUMNS_3: 'columns-3',
    COLUMNS_4: 'columns-4',
    CAROUSEL: 'carousel'
} as const;

export type GalleryBlockLayout = typeof GalleryBlockLayout[keyof typeof GalleryBlockLayout];

export type ImageBlock = {
    type: ArticleBlockType;
    credit?: string;
    url: string;
    path?: string;
    caption?: string;
    animated?: boolean;
    width?: number;
    height?: number;
    alternativeText?: string;
    layout?: ImageBlockLayout;
};

export const ImageBlockLayout = {
    DEFAULT: 'default',
    FLOAT_LEFT: 'float-left',
    FLOAT_RIGHT: 'float-right'
} as const;

export type ImageBlockLayout = typeof ImageBlockLayout[keyof typeof ImageBlockLayout];

export type HtmlBlock = {
    type: ArticleBlockType;
    htmlAndScript: string;
    margin?: boolean;
};

export type IframeBlock = {
    type: ArticleBlockType;
    url: string;
    embedBlock?: string;
};

export type InstagramBlock = {
    type: ArticleBlockType;
    postID: string;
    url: string;
    embedBlock?: string;
};

export type JobsOverviewBlock = {
    type: ArticleBlockType;
};

export type ListItemBlock = {
    type: ArticleBlockType;
    xml: {
        [key: string]: unknown;
    };
};

export type ListicleBlock = {
    type: ArticleBlockType;
    enumerator: string;
    title?: string;
    image?: ImageBlockPatch;
    text?: string;
    align?: 'left' | 'right';
    callToAction?: ListicleCTA;
};

export type ImageBlockPatch = {
    type: ArticleBlockType;
    credit?: string;
    /**
     * When creating a new ImageBlock for User Generated Content, set the `url` to the value returned by the `/file-upload` endpoint.
     */
    url: string;
    path?: string;
    caption?: string;
    animated?: boolean;
    width?: number;
    height?: number;
    alternativeText?: string;
    layout?: ImageBlockLayout;
};

export type ListicleCTA = {
    target: string;
    title: string;
};

export type MatchDetailSectionBlock = {
    type: ArticleBlockType;
    matchID?: string;
    showOdds?: boolean;
    match?: Match;
};

export type Match = {
    id: string;
    homeScore?: number;
    awayScore?: number;
    status?: MatchStatus;
    phase?: MatchPhase;
    period?: MatchPeriod;
    startOfCurrentPeriod?: string;
    week?: number;
    kickOff: string;
    lastUpdated?: string;
    slug?: string;
    kickOffSlug?: string;
    relatedMatchID?: string;
    relatedMatchHomeScore?: number;
    relatedMatchAwayScore?: number;
    penaltyHomeScore?: number;
    penaltyAwayScore?: number;
    stageName?: string;
    winnerNextMatchID?: string;
    /**
     * optaID of the winner, either by aggregation or by penalties
     */
    winnerID?: string;
    odds?: Array<ThreeWayOdds>;
    matchID?: number;
    competitionSlug?: string;
    originalSlug?: string;
    tournamentCalendarID?: string;
    relevant?: boolean;
    timeUnknown?: boolean;
    humanReadableDate?: string;
    home?: Team;
    away?: Team;
    staticData?: boolean;
    /**
     * Deprecated: use winnerID instead
     *
     * @deprecated
     */
    aggregateWinnerID?: string;
    aggregateHomeScore?: number;
    aggregateAwayScore?: number;
    minute?: string;
    duration?: number;
    competition?: Competition;
    details?: MatchDetails;
    url?: string;
    /**
     * For debugging.
     */
    cachedAt?: string;
    /**
     * For debugging.
     */
    cachedFor?: number;
    homeExpectedGoals?: number;
    awayExpectedGoals?: number;
    report?: MatchReport;
    nextMatchLoserID?: string;
    curated?: boolean;
    resultsHome?: Array<Match>;
    resultsAway?: Array<Match>;
    headToHead?: HeadToHeadHistory;
    headToHeadAnyComp?: HeadToHeadHistory;
};

export type Team = {
    id: string;
    name: string;
    shortName?: string;
    countryName?: string;
    countryCode?: string;
    teamType?: string;
    competitionID?: string;
    tournamentID?: string;
    stageID?: string;
    tag?: Tag;
    shirt?: Shirt;
};

export type Tag = {
    title: string;
    tagSlug: string;
    shortTitle?: string;
    tagOverview?: boolean;
    tagType: TagTypeAsString;
    tagTypeSlug?: string;
    tagTemplateID?: number;
    path?: string;
    optaID?: string;
    kambiIDs?: Array<number>;
    totoIDs?: Array<number>;
    sportmonksID?: number;
    originalID?: string;
    tagRedirect?: string;
    background?: string;
    thumbnail?: string;
    flag?: string;
    color?: string;
    tagDescription?: string;
    tagMetaTitle?: string;
    tagMetaDescription?: string;
    tagIntro?: string;
    newsCount?: number;
    showArticle?: boolean;
    showFooter?: boolean;
    showOnRssIndex?: boolean;
    showHome?: boolean;
    showOverview?: boolean;
    hasOverviewTab?: boolean;
    ordering?: number;
    isHidden?: boolean;
    isTopLevel?: boolean;
    isCurated?: boolean;
    moderationStatus?: TagModerationStatus;
    structuredData?: TagStructuredData;
    partner?: Bookmaker;
    parentTagSlug?: string;
    tagID: number;
    alternateLinks?: Array<AlternateLink>;
    /**
     * Some tags have been redirected to other tags, if this boolean is true we have found another tag that now represents this tagSlug and you probably need to redirect.
     */
    isRedirected?: boolean;
};

export type AlternateLink = {
    locale: LocaleID;
    isOriginal?: boolean;
    host: string;
    path: string;
};

export const LocaleID = {
    DE: 'de',
    EN: 'en',
    ES: 'es',
    FR: 'fr',
    IT: 'it',
    NL_BE: 'nl_BE',
    NL_NL: 'nl_NL',
    PT_BR: 'pt_BR'
} as const;

export type LocaleID = typeof LocaleID[keyof typeof LocaleID];

export const TagTypeAsString = {
    CAR_BRAND: 'car_brand',
    CAR_MODEL: 'car_model',
    CLUB: 'club',
    COMPETITION: 'competition',
    COMPETITION_TOURNAMENT: 'competition_tournament',
    DOSSIER: 'dossier',
    EVENT: 'event',
    LICENSE_PLATE: 'license_plate',
    LOCATION: 'location',
    ORGANIZATION: 'organization',
    PERSON: 'person',
    PLAYER: 'player',
    TOPIC: 'topic',
    CYCLING_COMPETITION: 'cycling_competition'
} as const;

export type TagTypeAsString = typeof TagTypeAsString[keyof typeof TagTypeAsString];

export const TagModerationStatus = {
    PENDING: 'pending',
    APPROVED: 'approved',
    REJECTED: 'rejected'
} as const;

export type TagModerationStatus = typeof TagModerationStatus[keyof typeof TagModerationStatus];

export type TagStructuredData = {
    sameAs?: Array<string>;
};

export type Bookmaker = {
    name: string;
    lightBackgroundIcon: string;
    darkBackgroundIcon: string;
    url: string;
    deepLinkUrlTemplate?: string;
    provider?: OddsProvider;
    backgroundColor?: string;
    largeIcon?: string | null;
    id: number;
};

export const OddsProvider = {
    /**
     * UNIBET
     */
    UNIBET: 'unibet',
    /**
     * JACKS
     */
    JACKS: 'jacks',
    /**
     * TOTO
     */
    TOTO: 'toto',
    /**
     * BETCITY
     */
    BETCITY: 'betcity',
    /**
     * DUMMY
     */
    DUMMY: 'dummy'
} as const;

export type OddsProvider = typeof OddsProvider[keyof typeof OddsProvider];

export type Shirt = {
    pattern: string;
    rotation?: number;
    primary: string;
    secondary?: string;
    tertiary?: string;
    ribbing?: string;
    badge?: string;
    variant?: ShirtVariant;
    goalkeeper?: 'yellow' | 'black';
    teamName?: string;
};

export const ShirtVariant = { CHECKERED: 'checkered' } as const;

export type ShirtVariant = typeof ShirtVariant[keyof typeof ShirtVariant];

export type Competition = {
    id: string;
    name?: string;
    country?: string;
    countrySlug?: string;
    type?: CompetitionType;
    tournaments?: Array<Tournament>;
    feeds?: Array<string>;
    tag?: Tag;
};

export const CompetitionType = {
    UNKNOWN: 'unknown',
    DOMESTIC_LEAGUE: 'domestic-league',
    DOMESTIC_CUP: 'domestic-cup',
    DOMESTIC_SUPER_CUP: 'domestic-super-cup',
    INTERNATIONAL_CUP: 'international-cup',
    INTERNATIONAL_SUPER_CUP: 'international-super-cup'
} as const;

export type CompetitionType = typeof CompetitionType[keyof typeof CompetitionType];

export type Tournament = {
    id?: string;
    name?: string;
    slug?: string;
    active?: boolean;
    tagID?: number;
};

export type MatchDetails = {
    statistics?: Array<MatchStatistic>;
    homeFormation?: string;
    awayFormation?: string;
    venueName: string;
    attendance?: string;
    refereeName?: string;
    refereeID?: string;
    homeStartingPlayers?: Array<Player>;
    awayStartingPlayers?: Array<Player>;
    homeBenchPlayers?: Array<Player>;
    awayBenchPlayers?: Array<Player>;
    homeInjuredPlayers?: Array<Player>;
    awayInjuredPlayers?: Array<Player>;
    homeSuspendedPlayers?: Array<Player>;
    awaySuspendedPlayers?: Array<Player>;
    homeCoach?: Player;
    awayCoach?: Player;
    events?: Array<MatchEvent>;
};

export type MatchStatistic = {
    type: StatType;
    homeValue: number;
    awayValue: number;
};

export const StatType = {
    TOTAL_SHOTS: 'total-shots',
    SHOTS_ON_GOAL: 'shots-on-goal',
    FOULS: 'fouls',
    CORNERS: 'corners',
    OFFSIDES: 'offsides',
    POSSESSION_PERCENTAGE: 'possession-percentage',
    EXPECTED_GOALS: 'expected-goals',
    HEAD_TO_HEAD_WINNERS: 'head-to-head-winners',
    HEAD_TO_HEAD_DRAWS: 'head-to-head-draws',
    HEAD_TO_HEAD_GOALS: 'head-to-head-goals'
} as const;

export type StatType = typeof StatType[keyof typeof StatType];

export type Player = {
    teamName?: string;
    weight?: string;
    type?: string;
    birthDate?: string;
    nationality?: string;
    stats?: PlayerStats;
    id: string;
    teamID?: string;
    countryCodeIsoAlpha2?: string;
    name: string;
    lastName?: string;
    fullName?: string;
    shirtNumber?: number;
    countryCode?: string;
    position?: PlayerPosition;
    role?: PlayerRole;
    height?: string;
    injury?: PlayerInjuryType;
    suspension?: PlayerSuspensionType;
    tag?: Tag;
    teamTag?: Tag;
};

export type PlayerStats = {
    appearances: number;
    assists: number;
    yellowCards: number;
    goals: number;
    redCards: number;
};

export const PlayerPosition = {
    UNKNOWN: 'unknown',
    ATTACKER: 'attacker',
    MIDFIELDER: 'midfielder',
    DEFENDER: 'defender',
    GOALKEEPER: 'goalkeeper'
} as const;

export type PlayerPosition = typeof PlayerPosition[keyof typeof PlayerPosition];

export const PlayerRole = {
    PLAYER: 'player',
    COACH: 'coach',
    ASSISTANT_COACH: 'assistant-coach',
    STAFF: 'staff'
} as const;

export type PlayerRole = typeof PlayerRole[keyof typeof PlayerRole];

export const PlayerInjuryType = {
    ABDOMINAL: 'abdominal',
    ACHILLES: 'achilles',
    ACHILLES_TENDON_RUPTURE: 'achilles-tendon-rupture',
    ACL_KNEE: 'acl-knee',
    ANKLE: 'ankle',
    BACK: 'back',
    BROKEN_ARM: 'broken-arm',
    BROKEN_LEG: 'broken-leg',
    CALF: 'calf',
    FACIAL: 'facial',
    FOOT: 'foot',
    GROIN: 'groin',
    HAMSTRING: 'hamstring',
    HEAD: 'head',
    HIP: 'hip',
    ILLNESS: 'illness',
    KNEE: 'knee',
    KNOCK: 'knock',
    LEG: 'leg',
    MCL_KNEE: 'mcl-knee',
    MUSCLE: 'muscle',
    RIB: 'rib',
    SHOULDER: 'shoulder',
    THIGH: 'thigh',
    UNKNOWN: 'unknown'
} as const;

export type PlayerInjuryType = typeof PlayerInjuryType[keyof typeof PlayerInjuryType];

export const PlayerSuspensionType = {
    RED_CARD: 'red-card',
    SENDING_OFF: 'sending-off',
    UNKNOWN: 'unknown',
    YELLOW_CARD_ACCUMULATION: 'yellow-card-accumulation'
} as const;

export type PlayerSuspensionType = typeof PlayerSuspensionType[keyof typeof PlayerSuspensionType];

export type Card = {
    id: string;
    eventType: EventType;
    period?: MatchPeriod;
    minute: number;
    formattedTime?: MatchTime;
    timeSec?: number;
    severity?: CardSeverity;
    teamID?: string;
    playerID?: string;
    name?: string;
    disapproved?: boolean;
};

export const CardSeverity = {
    YELLOW_CARD: 'yellow-card',
    SECOND_YELLOW_CARD: 'second-yellow-card',
    RED_CARD: 'red-card'
} as const;

export type CardSeverity = typeof CardSeverity[keyof typeof CardSeverity];

export const EventType = {
    GOAL: 'goal',
    SUBSTITUTION: 'substitution',
    PENALTY_MISSED: 'penalty-missed',
    CARD: 'card',
    PERIOD: 'period',
    SHOOTOUT_PENALTY: 'shootout-penalty'
} as const;

export type EventType = typeof EventType[keyof typeof EventType];

export const MatchPeriod = {
    FIRST_HALF: 'first-half',
    SECOND_HALF: 'second-half',
    EXTRA_TIME_FIRST_HALF: 'extra-time-first-half',
    EXTRA_TIME_SECOND_HALF: 'extra-time-second-half',
    PENALTIES: 'penalties',
    FIRST_BREAK: 'first-break',
    SECOND_BREAK: 'second-break',
    THIRD_BREAK: 'third-break',
    FOURTH_BREAK: 'fourth-break',
    FINISHED: 'finished',
    NOT_STARTED: 'not-started'
} as const;

export type MatchPeriod = typeof MatchPeriod[keyof typeof MatchPeriod];

export type MatchTime = {
    minutes: number;
    overtime: number;
};

export type Goal = {
    id: string;
    eventType: EventType;
    period?: MatchPeriod;
    minute: number;
    formattedTime?: MatchTime;
    timeSec?: number;
    goalType?: GoalType;
    teamID?: string;
    playerID?: string;
    assistID?: string;
    playerName?: string;
    homeScore?: number;
    awayScore?: number;
    disapproved?: boolean;
};

export const GoalType = {
    GOAL: 'goal',
    OWN_GOAL: 'own-goal',
    PENALTY_GOAL: 'penalty-goal',
    NO_GOAL: 'no-goal'
} as const;

export type GoalType = typeof GoalType[keyof typeof GoalType];

export type PenaltyMissed = {
    id: string;
    eventType: EventType;
    period?: MatchPeriod;
    minute: number;
    formattedTime?: MatchTime;
    timeSec?: number;
    teamID?: string;
    playerID?: string;
};

export type Period = {
    id: string;
    eventType: EventType;
    period: MatchPeriod;
    minute: number;
    formattedTime?: MatchTime;
    timeSec?: number;
    startOfCurrentPeriod?: string;
    periodEventType: PeriodEventType;
};

export const PeriodEventType = { START: 'start', END: 'end' } as const;

export type PeriodEventType = typeof PeriodEventType[keyof typeof PeriodEventType];

export type ShootoutPenalty = {
    id: string;
    eventType: EventType;
    period?: MatchPeriod;
    minute: number;
    formattedTime?: MatchTime;
    timeSec?: number;
    playerID?: string;
    playerName?: string;
    teamID?: string;
    scored?: boolean;
    teamPenaltyNumber?: number;
};

export type Substitution = {
    id: string;
    eventType: EventType;
    period?: MatchPeriod;
    minute: number;
    formattedTime?: MatchTime;
    timeSec?: number;
    teamID?: string;
    ingoingPlayerID?: string;
    ingoingPlayerName?: string;
    outgoingPlayerID?: string;
    outgoingPlayerName?: string;
};

export type MatchEvent = ({
    eventType: 'card';
} & Card) | ({
    eventType: 'goal';
} & Goal) | ({
    eventType: 'penalty-missed';
} & PenaltyMissed) | ({
    eventType: 'period';
} & Period) | ({
    eventType: 'shootout-penalty';
} & ShootoutPenalty) | ({
    eventType: 'substitution';
} & Substitution);

export type MatchReport = {
    matchID: string;
    title?: string;
    content?: string;
    generatedAt?: string;
};

export type HeadToHeadHistory = {
    statistics?: Array<MatchStatistic>;
    matches?: Array<Match>;
};

export const MatchStatus = {
    ALL: 'all',
    FIXTURE: 'fixture',
    PLAYED: 'played',
    PLAYING: 'playing',
    CANCELLED: 'cancelled',
    POSTPONED: 'postponed',
    SUSPENDED: 'suspended'
} as const;

export type MatchStatus = typeof MatchStatus[keyof typeof MatchStatus];

export const MatchPhase = {
    N_A: 'n-a',
    CALLED_OFF: 'called-off',
    STOPPED_DURING_GAME: 'stopped-during-game',
    DELAYED: 'delayed',
    PENALTIES: 'penalties',
    HALF_TIME: 'half-time',
    AFTER_PENALTIES: 'after-penalties',
    AFTER_EXTRA_TIME: 'after-extra-time',
    FULL_TIME: 'full-time'
} as const;

export type MatchPhase = typeof MatchPhase[keyof typeof MatchPhase];

export type ThreeWayOdds = {
    id: number;
    home: number;
    away: number;
    draw: number;
    deepLinkUrl?: string;
    url: string;
    isPrimaryBookmaker?: boolean;
    bookmaker?: Bookmaker;
};

export type MatchListBlock = {
    type: ArticleBlockType;
    matches: Array<Match>;
    showCompact?: boolean;
    showDate?: boolean;
    url?: string;
    deepLink?: DeepLink;
    urlTitle?: string;
};

export type DeepLink = {
    type?: string;
    value?: string;
};

export type MatchPredictionBlock = {
    type: ArticleBlockType;
    matchID: string;
    match?: Match;
    prediction?: UserMatchPredictionMatch;
};

export type UserMatchPredictionMatch = {
    tournamentID: string;
    /**
     * @deprecated
     */
    matchID: number;
    optaID: string;
    votes: UserMatchPredictionMatchResults;
    vote?: 'home' | 'away' | 'draw';
};

export type UserMatchPredictionMatchResults = {
    home: number;
    away: number;
    draw: number;
};

export type MediaBlock = {
    type: ArticleBlockType;
    url: string;
    autoPlay?: boolean;
    showAsCarousel?: boolean;
    carouselPlaylist?: Hypermedia;
    duration?: number;
    title?: string;
    thumbnail?: string;
    vendor?: VideofeedVendor;
    videofeedItemID?: number;
};

export type Hypermedia = {
    href?: string;
};

export const VideofeedVendor = {
    CUSTOM: 'custom',
    BB: 'bb',
    FOXSPORT: 'foxsport',
    OMNISPORT: 'omnisport',
    ESPN: 'espn',
    KNVB: 'knvb',
    VIRAL: 'viral',
    ADVERTORIAL: 'advertorial',
    ADS_DISABLED: 'ads-disabled'
} as const;

export type VideofeedVendor = typeof VideofeedVendor[keyof typeof VideofeedVendor];

export type OverviewMatchesBlock = {
    type: ArticleBlockType;
    title?: string;
    overviewType: OverviewMatchesBlockType;
    matches: Array<Match>;
    teamID?: string;
    competitionID?: string;
};

export const OverviewMatchesBlockType = {
    DEFAULT: 'default',
    SCHEDULED: 'scheduled',
    PLAYED: 'played'
} as const;

export type OverviewMatchesBlockType = typeof OverviewMatchesBlockType[keyof typeof OverviewMatchesBlockType];

export type PaywallBlock = {
    type: ArticleBlockType;
    paywallType: PaywallType;
    fallback?: PayWallContent;
};

export const PaywallType = {
    NON_PRO: 'NON_PRO',
    CLUB: 'CLUB',
    LIMIT_REACHED: 'LIMIT_REACHED',
    SUSPENDED: 'SUSPENDED',
    IOS: 'IOS'
} as const;

export type PaywallType = typeof PaywallType[keyof typeof PaywallType];

export type PayWallContent = {
    title?: string;
    textInTeaser?: string;
    link?: string;
    deepLink?: DeepLink;
    prefix?: string;
    oldPrice?: string;
    oldPriceSuffix?: string;
    newPrice?: string;
    textSubscribeButton?: string;
    registerLoginTitle?: string;
    showCurrentArticleTitle?: boolean;
    registerButtonText?: string;
    loginText?: string;
};

export type PlayerBlock = {
    type: ArticleBlockType;
    player: Player;
    title: string;
    linkText: string;
    image?: string;
    showLink?: boolean;
    showNationalTeam?: boolean;
};

export type PlayerGradesBlock = {
    type: ArticleBlockType;
    optaID?: string;
    homeTeam?: SportDataTeamGrades;
    awayTeam?: SportDataTeamGrades;
    referee?: SportDataPlayerGrade;
    manOfTheMatch?: SportDataPlayerGrade;
    matchGrade?: number;
};

export type SportDataTeamGrades = {
    id: string;
    name: string;
    country: string;
    coach: SportDataPlayerGrade;
    players: Array<SportDataPlayerGrade>;
    tag?: Tag;
};

export type SportDataPlayerGrade = {
    name: string;
    playerID: string;
    shirtNumber?: number;
    grade?: number;
    substituteName?: string;
    substitutePlayerID?: string;
    substituteGrade?: number;
    substituteMinute?: number;
};

export type PollBlock = {
    type: ArticleBlockType;
    pollID: string;
    /**
     * @deprecated
     */
    title?: string;
    headline?: string;
    /**
     * @deprecated
     */
    question?: string;
    /**
     * @deprecated
     */
    answers?: Array<Answer>;
    /**
     * @deprecated
     */
    buttonText?: string;
    /**
     * @deprecated
     */
    closed?: boolean;
    /**
     * @deprecated
     */
    ctaText?: string;
    /**
     * @deprecated
     */
    ctaLink?: string;
    result?: PollVoteResponse;
    poll?: Poll;
};

export type Answer = {
    /**
     * @deprecated
     */
    answerId: string;
    /**
     * @deprecated
     */
    answer: string;
};

export type PollVoteResponse = {
    /**
     * @deprecated
     */
    message?: string;
    /**
     * @deprecated
     */
    resultsSize?: number;
    /**
     * @deprecated
     */
    results?: Array<PollVoteResult>;
    /**
     * @deprecated
     */
    quizAnswerId?: string;
};

export type PollVoteResult = {
    /**
     * @deprecated
     */
    pollId?: string;
    /**
     * @deprecated
     */
    optionId?: string;
    /**
     * @deprecated
     */
    count?: number;
    /**
     * @deprecated
     */
    percentage?: number;
    /**
     * @deprecated
     */
    winner?: boolean;
};

export type Poll = {
    id: number;
    contextID: number;
    title: string;
    description?: string;
    creationDate: string;
    closeDate?: string;
    isArchived?: boolean;
    matchID?: string;
    answers?: Array<PollAnswer>;
};

export type PollAnswer = {
    id: number;
    questionID: number;
    isCorrect?: boolean;
    title: string;
    votes?: number;
};

export type PouleBlock = {
    type: ArticleBlockType;
    title?: string;
    tournamentCalendarID?: string;
    isLive?: boolean;
    standings?: Array<TeamStanding>;
};

export type TeamStanding = {
    team: Team;
    rank: number;
    lastRank?: number;
    statistics: TeamStatistics;
    isLive?: boolean;
};

export type TeamStatistics = {
    matchesPlayed: number;
    matchesWon?: number;
    matchesDrawn?: number;
    matchesLost?: number;
    goalsDiff?: number;
    goalsFor?: number;
    goalsAgainst?: number;
    points: number;
};

export type QuoteBlock = {
    type: ArticleBlockType;
    alignment?: AlignmentType;
    text: string;
    source?: string;
    behalf?: string;
};

export const AlignmentType = {
    REGULAR: 'regular',
    FULLWIDTH: 'fullwidth',
    LEFT: 'left',
    RIGHT: 'right'
} as const;

export type AlignmentType = typeof AlignmentType[keyof typeof AlignmentType];

export type RecipeBlock = {
    type: ArticleBlockType;
    xml: {
        [key: string]: unknown;
    };
};

export type RelatedBlock = {
    type: ArticleBlockType;
    title: string;
    items: Array<RelatedNewsItem>;
};

export type RelatedNewsItem = {
    /**
     * newsID
     */
    id: number;
    url: string;
    deepLink?: DeepLink;
    title: string;
    /**
     * Deprecated: Use `newsSubTitle` instead.
     *
     * @deprecated
     */
    subTitle?: string;
    newsSubTitle?: string;
    imageUrl?: string;
    type?: string;
    category: NewsCategory;
    newsCat?: NewsCategory;
    label?: string;
    duration?: number;
};

export type NewsCategory = {
    name: string;
    slug: string;
    isMedia: boolean;
    showAsTag?: boolean;
    functionality?: NewsCategoryFunctionality;
    image?: string;
    icon?: string;
    id: number;
    alternateLinks?: Array<AlternateLink>;
};

export const NewsCategoryFunctionality = {
    ADVERTORIAL: 'advertorial',
    AFFILIATE: 'affiliate',
    BETTING: 'betting',
    BREAKING: 'breaking',
    DONE_DEAL: 'done-deal',
    EXCLUSIVE: 'exclusive',
    HOME_REFEREE: 'home-referee',
    INTERVIEW: 'interview',
    LIVE: 'live',
    NK_FIFA: 'nk-fifa',
    PODCAST: 'podcast',
    PREMIUM: 'premium',
    QUIZ: 'quiz',
    REVIEW: 'review',
    TRANSFERNEWS: 'transfernews',
    TRANSFERRUMORS: 'transferrumors',
    TV_GUIDE: 'tv-guide',
    USER_GENERATED_CONTENT: 'user-generated-content'
} as const;

export type NewsCategoryFunctionality = typeof NewsCategoryFunctionality[keyof typeof NewsCategoryFunctionality];

export type RichTextBlock = {
    type: ArticleBlockType;
    text: string;
};

export type StandingsBlock = {
    type: ArticleBlockType;
    standing?: TournamentStandings;
    firstPosition?: number;
    lastPosition?: number;
    title?: string;
    /**
     * @deprecated
     */
    teamID?: string;
    highlightedTeams?: Array<string>;
    competitionID?: string;
    countryName?: string;
    deepLink?: DeepLink;
    followTeam?: boolean;
    freezeStandings?: boolean;
};

export type TournamentStandings = {
    id: string;
    groups?: Array<TournamentStage>;
    tag?: Tag;
    name?: string;
};

export type TournamentStage = {
    title?: string;
    isLive?: boolean;
    standings?: Array<TeamStanding>;
};

export type StreamerBlock = {
    type: ArticleBlockType;
    alignment: AlignmentType;
    text: string;
};

export type TableBlock = {
    type: ArticleBlockType;
    rows: Array<TableRow>;
    headerRow: boolean;
};

export type TableRow = {
    cells?: Array<string>;
    htmlCells?: Array<string>;
};

export type TikTokBlock = {
    type: ArticleBlockType;
    postURL: string;
    isPortrait?: boolean;
};

export type XPostBlock = {
    type: ArticleBlockType;
    postID: string;
    postURL: string;
    embedBlock?: string;
};

export type WattWizardBlock = {
    type: ArticleBlockType;
};

export type YoutubeBlock = {
    type: ArticleBlockType;
    videoID: string;
    timestamp?: string;
    isPortrait?: boolean;
    embedBlock?: string;
};

export const NewsStatus = {
    PUBLISHED: 'published',
    SCHEDULED: 'scheduled',
    DRAFT: 'draft'
} as const;

export type NewsStatus = typeof NewsStatus[keyof typeof NewsStatus];

export type NewsExperiment = {
    experimentID: number;
    experimentTitle: string;
    domainID: number;
};

export type NewsVideofeed = {
    videofeedID: number;
    position: number;
};

export type Author = {
    id: number;
    userID: number;
    userName: string;
    fullName?: string;
    registrationDate?: string;
    /**
     * image
     *
     * The image URL.
     */
    image?: string;
    editionID: number;
    function?: string;
    bio?: string;
    website?: string;
    twitter?: string;
    linkedin?: string;
    instagram?: string;
    facebook?: string;
    youtube?: string;
    customSlug: string;
    order?: number;
    showOnHome?: boolean;
    shortName?: string;
};

export type VideofeedItemPublicScope = {
    id: number;
    title: string;
    url?: string;
    thumbnail?: string;
    preview?: string;
    vendor: VideofeedVendor;
    subject?: SubjectID;
    duration?: number;
    domainTitle?: string;
    experimentID?: number;
    experimentTitle?: string;
    acceptationDate?: string;
    position?: number;
    isMain?: boolean;
    status: VideofeedStatus;
    path?: string;
};

export const SubjectID = {
    AUTOMOTIVE: 'automotive',
    FOOTBALL: 'football',
    LIFESTYLE: 'lifestyle',
    TECH: 'tech',
    CYCLING: 'cycling'
} as const;

export type SubjectID = typeof SubjectID[keyof typeof SubjectID];

export const VideofeedStatus = {
    NEW: 'new',
    ACTIVE: 'active',
    ACCEPTED: 'accepted',
    REJECTED: 'rejected'
} as const;

export type VideofeedStatus = typeof VideofeedStatus[keyof typeof VideofeedStatus];

export type PartialTag = {
    tagID?: number;
    title?: string;
    tagSlug?: string;
    tagType?: TagTypeAsString;
    tagTypeSlug?: string;
    path?: string;
    optaID?: string;
    flag?: string;
    hasOverviewTab?: boolean;
    parentTagSlug?: string;
};

export type BinaryPoll = {
    up: number;
    down: number;
};

export type NewsReadMoreBlock = {
    position: number;
    articles: Array<NewsReadMoreArticle>;
};

export type NewsReadMoreArticle = {
    newsID: number;
    newsTitle?: string;
    newsCatMedia?: boolean;
    host?: string;
    path?: string;
    image?: string;
};

export type NewsAlternateLink = {
    locale: LocaleID;
    isOriginal: boolean;
    host: string;
    path: string;
    newsID: number;
    isSource: boolean;
};

export const ArticleAccessLevel = {
    PUBLIC: 'public',
    AUTHENTICATED: 'authenticated',
    SUBSCRIPTION: 'subscription'
} as const;

export type ArticleAccessLevel = typeof ArticleAccessLevel[keyof typeof ArticleAccessLevel];

export type AutoblogMigrateSpotsResult = {
    duration: number;
    amountImported: number;
    amountFailed: number;
    /**
     * The failures are sorted by the failure amount descending.
     */
    failed: Array<AutoblogMigrateSpotFailure>;
};

export type AutoblogMigrateSpotFailure = {
    errorMessage: string;
    amount: number;
};

export type TooManyRequests = {
    /**
     * The error name
     */
    name: string;
    /**
     * An error message
     */
    message: string;
    /**
     * The status code of the exception
     */
    status: number;
    /**
     * A list of related errors
     */
    errors?: Array<GenericError>;
    /**
     * The stack trace (only in development mode)
     */
    stack?: string;
};

export type GenericError = {
    /**
     * The error name
     */
    name: string;
    /**
     * An error message
     */
    message: string;
    [key: string]: unknown;
};

export type Unauthorized = {
    /**
     * The error name
     */
    name: string;
    /**
     * An error message
     */
    message: string;
    /**
     * The status code of the exception
     */
    status: number;
    /**
     * A list of related errors
     */
    errors?: Array<GenericError>;
    /**
     * The stack trace (only in development mode)
     */
    stack?: string;
};

export type Forbidden = {
    /**
     * The error name
     */
    name: string;
    /**
     * An error message
     */
    message: string;
    /**
     * The status code of the exception
     */
    status: number;
    /**
     * A list of related errors
     */
    errors?: Array<GenericError>;
    /**
     * The stack trace (only in development mode)
     */
    stack?: string;
};

export type AutoblogMigrateImagesBatchResult = {
    amountSuccessfulArticles: number;
    amountFailedArticles: number;
    amountImported: number;
    amountFailed: number;
    amountTotal: number;
};

export type AutoblogMigrateReplaceLinksResult = {
    replaced?: {
        [key: string]: Array<AutoblogMigrateReplaceLinkResult>;
    };
};

export type AutoblogMigrateReplaceLinkResult = {
    oldUrl: string;
    newUrl: string;
};

export type AutoblogMigrateUsersBatchResult = {
    amountImported: number;
    amountFailed: number;
    amountTotal: number;
};

export const ABUserType = { EDITOR: 'editor', SPOTTER: 'spotter' } as const;

export type ABUserType = typeof ABUserType[keyof typeof ABUserType];

export type AutoblogDeleteCorruptedUsersResult = {
    notCompletedABUserIDs: Array<Integer>;
    notFoundABUserIDs: Array<Integer>;
    corruptedUsers: Array<AutoblogCorruptedUser>;
};

export type Integer = {
    [key: string]: unknown;
};

export type AutoblogCorruptedUser = {
    abUserID: number;
    email?: string;
    stUserExists: boolean;
};

export type AutoblogMigrateCarTagsResult = {
    problematicTermPosts: Array<AutoblogTermPosts>;
    skippedPostIDs: Array<Integer>;
};

export type AutoblogTermPosts = {
    term_id: number;
    term_name?: string;
    alternativeTerm?: AutoblogTermIDAndName;
    postIDAndTitles: Array<AutoblogPostIDAndTitle>;
};

export type AutoblogTermIDAndName = {
    term_id: number;
    name: string;
};

export type AutoblogPostIDAndTitle = {
    ID: number;
    title: string;
};

export type AutoblogMigrateTermsResult = {
    amountCompleted: number;
    amountFailed: number;
};

export const AutoblogTermMigrationTagType = {
    CAR_BRAND: 'car_brand',
    CAR_MODEL: 'car_model',
    DOSSIER: 'dossier',
    EVENT: 'event',
    ORGANIZATION: 'organization',
    PERSON: 'person',
    TOPIC: 'topic'
} as const;

export type AutoblogTermMigrationTagType = typeof AutoblogTermMigrationTagType[keyof typeof AutoblogTermMigrationTagType];

export type AutoblogImportOriginalRedirectsResult = {
    affectedRows: number;
};

export type KambiOddsImportResult = {
    matches: number;
    competitions: number;
    betOffersFound: number;
    matchOddsUpserted: number;
};

export type Pagination = {
    page?: number;
    perPage?: number;
    totalItems?: number;
    lastPage?: number;
    hasNextPage?: boolean;
};

export type BlockedDomain = {
    id?: number;
    domain: string;
    blockedSince?: string;
    user?: BlockedDomainUser;
};

export type BlockedDomainUser = {
    id: number;
    userName: string;
};

export type BlockedDomainActionCreate = {
    domain: string;
};

export type BlockedIp = {
    ip: string;
    createdOn?: string;
    user?: BlockedIpUser;
};

export type BlockedIpUser = {
    id: number;
    userName: string;
};

export type NotFound = {
    /**
     * The error name
     */
    name: string;
    /**
     * An error message
     */
    message: string;
    /**
     * The status code of the exception
     */
    status: number;
    /**
     * A list of related errors
     */
    errors?: Array<GenericError>;
    /**
     * The stack trace (only in development mode)
     */
    stack?: string;
};

export type BookmakerBase = {
    name: string;
    lightBackgroundIcon: string;
    darkBackgroundIcon: string;
    url: string;
    deepLinkUrlTemplate?: string;
    provider?: OddsProvider;
    backgroundColor?: string;
    largeIcon?: string | null;
};

export type BookmakerActionPatch = {
    name?: string;
    lightBackgroundIcon?: string;
    darkBackgroundIcon?: string;
    url?: string;
    deepLinkUrlTemplate?: string | null;
    provider?: OddsProvider;
    backgroundColor?: string | null;
    largeIcon?: string | null;
};

export type Banner = {
    id?: number;
    domainID: number;
    placementName: string;
    placementID: number;
    script?: string;
    hideDesktop: boolean;
    hideMobile: boolean;
    withContainer: boolean;
};

export type BannerActionCreate = {
    placementName: string;
    placementID: number;
    script?: string;
    hideDesktop: boolean;
    hideMobile: boolean;
    withContainer: boolean;
};

export type BannerActionUpdate = {
    placementName: string;
    placementID: number;
    script?: string;
    hideDesktop: boolean;
    hideMobile: boolean;
    withContainer: boolean;
};

export type NewsThumb = {
    id?: number;
    newsID?: number;
    up?: number;
    down?: number;
    userID?: number;
    newsCommentID?: number;
    date?: string;
};

export const BinaryPollVote = { UP: 'up', DOWN: 'down' } as const;

export type BinaryPollVote = typeof BinaryPollVote[keyof typeof BinaryPollVote];

export type CommentFull = {
    id: number;
    domainID: number;
    newsID: number;
    replyID?: number;
    captchaScore?: number;
    reactionTxt: string;
    likeCount?: number;
    flagCount?: number;
    link?: string;
    newsTitle?: string;
    isShadowBanned?: boolean;
    userWasShadowBanned: boolean;
    isLocked?: boolean;
    commentDate: string;
    readerName?: string;
    readerUserID?: number;
    updaterName?: string;
    updaterUserID?: number;
    deleterName?: string;
    deleterUserID?: number;
    replies?: Array<Comment>;
    user: CommentUser;
};

export type Comment = {
    id: number;
    domainID: number;
    newsID: number;
    replyID?: number;
    reactionTxt: string;
    likeCount?: number;
    link?: string;
    newsTitle?: string;
    isShadowBanned?: boolean;
    isLocked?: boolean;
    commentDate: string;
    updaterUserID?: number;
    deleterUserID?: number;
    replies?: Array<Comment>;
    user: CommentUser;
};

export type CommentUser = {
    id: number;
    userName: string;
    /**
     * The image URL.
     */
    image?: string;
    role: UserRole;
    likeCount?: number;
    hasActiveSubscription?: boolean;
    isPremiumSubscriber?: boolean;
};

export const UserRole = {
    USER_NOT_VALIDATED: 'user-not-validated',
    USER: 'user',
    MODERATOR: 'moderator',
    EDITOR: 'editor',
    ADMIN: 'admin',
    USER_BANNED: 'user-banned'
} as const;

export type UserRole = typeof UserRole[keyof typeof UserRole];

/**
 *
 * | Name                  | PlatformID |
 * |-----------------------|------------|
 * | Autoblog              | ab         |
 * | Bicycling             | bi         |
 * | Bright                | br         |
 * | Men's Health          | mh         |
 * | Runner's World        | rw         |
 * | Voetbal International | vi         |
 * | VoetbalNieuws         | vn         |
 * | VoetbalPrimeur        | vp         |
 * | Women's Health        | wh         |
 *
 */
export const PlatformID = {
    AB: 'ab',
    BI: 'bi',
    BR: 'br',
    MH: 'mh',
    RW: 'rw',
    VI: 'vi',
    VN: 'vn',
    VP: 'vp',
    WH: 'wh'
} as const;

/**
 *
 * | Name                  | PlatformID |
 * |-----------------------|------------|
 * | Autoblog              | ab         |
 * | Bicycling             | bi         |
 * | Bright                | br         |
 * | Men's Health          | mh         |
 * | Runner's World        | rw         |
 * | Voetbal International | vi         |
 * | VoetbalNieuws         | vn         |
 * | VoetbalPrimeur        | vp         |
 * | Women's Health        | wh         |
 *
 */
export type PlatformID = typeof PlatformID[keyof typeof PlatformID];

export const CommentStatusFilter = {
    ALL: 'all',
    SHADOW: 'shadow',
    UNREAD: 'unread',
    SUSPECT: 'suspect',
    FLAG: 'flag'
} as const;

export type CommentStatusFilter = typeof CommentStatusFilter[keyof typeof CommentStatusFilter];

export const CommentOrderByOption = { COMMENT_DATE: 'commentDate', COMMENT_LIKE_COUNT: 'commentLikeCount' } as const;

export type CommentOrderByOption = typeof CommentOrderByOption[keyof typeof CommentOrderByOption];

export const Order = { ASC: 'asc', DESC: 'desc' } as const;

export type Order = typeof Order[keyof typeof Order];

export type CommentScopePublic = {
    id: number;
    domainID: number;
    newsID: number;
    replyID?: number;
    reactionTxt: string;
    likeCount?: number;
    link?: string;
    newsTitle?: string;
    isShadowBanned?: boolean;
    isLocked?: boolean;
    commentDate: string;
    updaterUserID?: number;
    deleterUserID?: number;
    replies?: Array<Comment>;
    user: CommentUser;
};

export const Client = {
    WEB: 'web',
    IOS: 'ios',
    ANDROID: 'android'
} as const;

export type Client = typeof Client[keyof typeof Client];

export type CommentActionCreate = {
    newsID: number;
    replyID?: number;
    reactionTxt: string;
    link?: string;
    newsTitle?: string;
    captchaToken: string;
};

export type CommentActionPatch = {
    reactionTxt?: string;
    isLocked?: boolean | null;
    deletedBy?: number | null;
};

export type CommentUpdateListResponse = {
    affectedRows: number;
    updatedComments: Array<Comment>;
};

export type CommentUpdateList = {
    idList?: Array<number>;
    action: string;
};

export type FlaggedComment = {
    /**
     * id
     */
    id: number;
    /**
     * ipAddress
     */
    ipAddress: string;
    /**
     * commentID
     */
    commentID: number;
    /**
     * userID
     */
    userID: number;
    /**
     * creationDate
     */
    creationDate: string;
    /**
     * notificationIsPushed
     */
    notificationIsPushed: boolean;
};

export type FeaturedCarousel = {
    contextID?: number;
    layout?: FeaturedCarouselLayout;
    items?: Array<FeaturedItem>;
};

export const FeaturedCarouselLayout = {
    EXPANDED_SIDE: 'expandedSide',
    MINIFIED_SIDE: 'minifiedSide',
    TWIN_MAINS: 'twinMains',
    EXPANDED_FOOTER: 'expandedFooter',
    SINGLE_MAIN: 'singleMain',
    HALF_HALF_ROW: 'halfHalfRow',
    EIGHTS_HALF_GRID: 'eightsHalfGrid',
    QUARTERS_HALF_GRID: 'quartersHalfGrid',
    THIRDS_ROW: 'thirdsRow',
    QUARTERS_ROW: 'quartersRow',
    THIRDS_MASONRY: 'thirdsMasonry',
    QUARTERS_MASONRY: 'quartersMasonry'
} as const;

export type FeaturedCarouselLayout = typeof FeaturedCarouselLayout[keyof typeof FeaturedCarouselLayout];

export type FeaturedItem = {
    title?: string;
    fontSize: FeaturedCarouselFontSize;
    index?: number;
    newsItem: NewsItemBase;
};

export type NewsItemBase = {
    newsID: number;
    domainID: number;
    platform?: string;
    newsTitle?: string;
    status?: NewsStatus;
    newsSubTitle?: string;
    newsBold?: string;
    newsText?: string;
    contentShort?: string;
    contentSearchable?: string;
    host?: string;
    path?: string;
    metaTitle?: string;
    metaDescription?: string;
    newsDate: string;
    newsDateUpdate?: string;
    newsPublishDate?: string;
    notificationIsPushed?: boolean;
    originalID?: string;
    pushBody?: string;
    /**
     * Deprecated: Use `authorIDs` instead.
     *
     * @deprecated
     */
    authorUserID?: number;
    authorIDs?: Array<number>;
    userID: number;
    /**
     * @deprecated
     */
    mainTagSlug?: string;
    adsEnabled?: boolean;
    featured?: boolean;
    titleIsBold?: boolean;
    showHome?: boolean;
    sticky?: boolean;
    readTime?: number;
    commentCount?: number;
    experiment?: NewsExperiment;
    matchID?: string;
    newsCommentsEnabled?: boolean;
    imageTitle?: string;
    imageCredit?: string;
    imageCopyright?: string;
    category?: NewsCategory;
    videofeed?: NewsVideofeed;
    creator?: Author;
    author?: Author;
    authors?: Array<Author>;
    videofeedItem?: VideofeedItemPublicScope;
    /**
     * imageUrl
     *
     * Path to the images, make sure to replace the {size} placeholder with a value from ImageSizeEnum
     *
     * @deprecated
     */
    imageUrl?: string;
    /**
     * image
     *
     * The image URL.
     */
    image?: string;
    newsVideo?: string;
    /**
     * @deprecated
     */
    newsVideoImage?: string;
    newsVideoAddDate?: string;
    tags?: Array<PartialTag>;
    binaryPoll?: BinaryPoll;
    readMore?: Array<NewsReadMoreBlock>;
    alternateLinks?: Array<NewsAlternateLink>;
    socialTitle?: string;
    socialDescription?: string;
    accessLevel?: ArticleAccessLevel;
};

export const FeaturedCarouselFontSize = {
    S: 's',
    M: 'm',
    L: 'l',
    XL: 'xl',
    XXL: 'xxl',
    XXXL: 'xxxl'
} as const;

export type FeaturedCarouselFontSize = typeof FeaturedCarouselFontSize[keyof typeof FeaturedCarouselFontSize];

export type MatchTickerItem = {
    domainID: number;
    matchID: string;
    position: number;
};

export const MatchTickerOrderByOption = { POSITION: 'position' } as const;

export type MatchTickerOrderByOption = typeof MatchTickerOrderByOption[keyof typeof MatchTickerOrderByOption];

export type MatchTickerItemActionCreate = {
    matchID: string;
    position: number;
};

export type MatchTickerItemActionPatch = {
    position?: number;
};

export type ModuleScheduleItem = {
    /**
     * platform
     */
    platform?: string;
    /**
     * locale
     */
    locale?: string;
    /**
     * domainID
     *
     * domainID of the domain this module schedule item will be shown on. If domainID is NULL this module schedule item will be shown on every domain for the attached platform and locale
     */
    domainID?: number;
    module: ModuleScheduleSection;
    /**
     * text
     *
     * The title of a module schedule item.
     */
    text?: string;
    /**
     * tag
     *
     * The amount of the odds for a module schedule item
     */
    tag?: string;
    /**
     * frequency
     *
     * Defines by how many comments a module schedule item is shown
     */
    frequency?: number;
    /**
     * url
     *
     * If no url is filled in, the url will be set with a fallback url. Otherwise the editor choose his own url, and the user will be redirected to that url when clicking on the module schedule item.
     */
    url?: string;
    /**
     * startTime
     *
     * Defines the starttime before a module schedule item will be shown.
     */
    startTime: string;
    /**
     * endTime
     *
     * Defines the endTime when a module schedule item will no longer be shown.
     */
    endTime?: string;
    /**
     * duration
     *
     * Shows how long the module schedule item will be shown in minutes.
     */
    duration?: number;
    /**
     * tagID
     *
     * When a module schedule item is used in the section 'tagNewsList' this property will indicate on which tag page it should be shown. If 'tagID' is NULL, the module schedule item will be shown in every news list on every tag page.
     */
    tagID?: number;
    bookmaker?: Bookmaker;
    secondaryBookmaker?: Bookmaker;
    /**
     * id
     */
    id: number;
};

export const ModuleScheduleSection = {
    ARTICLE_MATCHES: 'articleMatches',
    BETTING_PAGE: 'bettingPage',
    COMMENTS: 'comments',
    LIVESTREAM: 'livestream',
    NATIONAL_THEME: 'nationalTheme',
    ODDS_DOSSIER_HOME: 'oddsDossierHome',
    ODDS_MATCH_TICKER: 'oddsMatchTicker',
    ODDS_MATCHES: 'oddsMatches',
    ODDS_POLLS: 'oddsPolls',
    PROMO_ELEMENT_BELOW_ARTICLE: 'promoElementBelowArticle',
    PROMO_ELEMENT_BELOW_VIDEO_CAROUSEL: 'promoElementBelowVideoCarousel',
    PROMOTED_ARTICLE: 'promotedArticle',
    TAG_NEWS_LIST: 'tagNewsList',
    TAG_SPONSORSHIP: 'tagSponsorship'
} as const;

export type ModuleScheduleSection = typeof ModuleScheduleSection[keyof typeof ModuleScheduleSection];

export const ModuleScheduleOrderByOptions = {
    START_TIME: 'startTime',
    END_TIME: 'endTime',
    DURATION: 'duration',
    MODULE: 'module',
    PARTNER_ID: 'partnerID'
} as const;

export type ModuleScheduleOrderByOptions = typeof ModuleScheduleOrderByOptions[keyof typeof ModuleScheduleOrderByOptions];

export const ModuleScheduleStatus = {
    ACTIVE: 'active',
    EXPIRED: 'expired',
    FUTURE: 'future'
} as const;

export type ModuleScheduleStatus = typeof ModuleScheduleStatus[keyof typeof ModuleScheduleStatus];

export type ModuleScheduleItemActionCreateActionCreate = {
    module: ModuleScheduleSection;
    /**
     * text
     *
     * The title of a module schedule item.
     */
    text?: string;
    /**
     * tag
     *
     * The amount of the odds for a module schedule item
     */
    tag?: string;
    /**
     * frequency
     *
     * Defines by how many comments a module schedule item is shown
     */
    frequency?: number;
    /**
     * url
     *
     * If no url is filled in, the url will be set with a fallback url. Otherwise the editor choose his own url, and the user will be redirected to that url when clicking on the module schedule item.
     */
    url?: string;
    /**
     * startTime
     *
     * Defines the starttime before a module schedule item will be shown.
     */
    startTime: string;
    /**
     * duration
     *
     * Shows how long the module schedule item will be shown in minutes.
     */
    duration?: number;
    /**
     * tagID
     *
     * When a module schedule item is used in the section 'tagNewsList' this property will indicate on which tag page it should be shown. If 'tagID' is NULL, the module schedule item will be shown in every news list on every tag page.
     */
    tagID?: number;
    bookmaker?: BookmakerActionCreate;
    secondaryBookmaker?: BookmakerActionCreate;
    bookmakerID?: number | null;
    bookmakerUrl?: string | null;
    secondaryBookmakerID?: number | null;
    secondaryBookmakerUrl?: string | null;
};

export type BookmakerActionCreate = {
    name: string;
    lightBackgroundIcon: string;
    darkBackgroundIcon: string;
    url: string;
    deepLinkUrlTemplate?: string;
    provider?: OddsProvider;
    backgroundColor?: string;
    largeIcon?: string | null;
    id: number;
};

export type ModuleScheduleItemActionPatch = {
    module?: ModuleScheduleSection;
    startTime?: string;
    duration?: number | null;
    url?: string | null;
    text?: string | null;
    frequency?: number | null;
    tag?: string | null;
    tagID?: number | null;
    bookmakerID?: number | null;
    bookmakerUrl?: string | null;
    secondaryBookmakerID?: number | null;
    secondaryBookmakerUrl?: string | null;
};

export type NavItem = {
    id?: number;
    contextID: number;
    name: string;
    url: string;
    class?: string;
    parentID?: number;
    order?: number;
    isMain?: boolean;
    children?: Array<NavItem>;
};

export type NavItemActionCreate = {
    name: string;
    url: string;
    class?: string;
    parentID?: number;
    order?: number;
    isMain?: boolean;
};

export type NavItemActionPatch = {
    name?: string;
    url?: string;
    class?: string | null;
    parentID?: number | null;
    order?: number | null;
    isMain?: boolean | null;
};

export type NewsCategoryActionPatch = {
    name?: string;
    showAsTag?: boolean;
};

export const ExperimentGroupOrRobots = {
    A: 'a',
    B: 'b',
    ROBOTS: 'robots'
} as const;

export type ExperimentGroupOrRobots = typeof ExperimentGroupOrRobots[keyof typeof ExperimentGroupOrRobots];

export type NewsHasTagResult = {
    hasTag: boolean;
};

export type NewsItemActionCreate = {
    platform?: string;
    newsTitle?: string;
    status?: NewsStatus;
    newsSubTitle?: string;
    newsBold?: string;
    newsText?: string;
    contentShort?: string;
    contentSearchable?: string;
    host?: string;
    path?: string;
    metaTitle?: string;
    metaDescription?: string;
    newsDateUpdate?: string;
    newsPublishDate?: string;
    notificationIsPushed?: boolean;
    originalID?: string;
    pushToAll?: boolean;
    pushBody?: string;
    /**
     * Deprecated: Use `authorIDs` instead.
     *
     * @deprecated
     */
    authorUserID?: number;
    authorIDs?: Array<number>;
    adsEnabled?: boolean;
    featured?: boolean;
    titleIsBold?: boolean;
    showHome?: boolean;
    sticky?: boolean;
    readTime?: number;
    commentCount?: number;
    visitCount?: number;
    experiment?: NewsExperiment;
    matchID?: string;
    newsCommentsEnabled?: boolean;
    imageTitle?: string;
    imageCredit?: string;
    imageCopyright?: string;
    categoryID?: number;
    videofeed?: NewsVideofeed;
    creator?: Author;
    author?: Author;
    authors?: Array<Author>;
    videofeedItem?: VideofeedItemPublicScope;
    newsVideo?: string;
    /**
     * @deprecated
     */
    newsVideoImage?: string;
    newsVideoAddDate?: string;
    tags?: Array<PartialTag>;
    binaryPoll?: BinaryPoll;
    readMore?: Array<NewsReadMoreBlock>;
    alternateLinks?: Array<NewsAlternateLink>;
    socialTitle?: string;
    socialDescription?: string;
    previewHash?: string;
    content?: Array<ArticleBlockPatch>;
    tagIDs?: Array<number>;
};

export type AccessWallBlockPatch = {
    type: ArticleBlockType;
    paywallType: AccessWallType;
};

export type EmbedBlockPatch = {
    type: ArticleBlockType;
    embedBlock: string;
};

export type ExternalSnippetBlockPatch = {
    type: ArticleBlockType;
    targetingID?: string | null;
    customTitle?: string | null;
    content?: string | null;
};

export type FrameBlockPatch = {
    type: ArticleBlockType;
    image?: string;
    title?: string;
    text?: string;
    blocks?: Array<ArticleBlockPatch>;
};

export type ArticleBlockPatch = ({
    type: 'accessWallBlock';
} & AccessWallBlockPatch) | ({
    type: 'embedBlock';
} & EmbedBlockPatch) | ({
    type: 'externalSnippetBlock';
} & ExternalSnippetBlockPatch) | ({
    type: 'frameBlock';
} & FrameBlockPatch) | ({
    type: 'galleryBlock';
} & GalleryBlockPatch) | ({
    type: 'htmlBlock';
} & HtmlBlockPatch) | ({
    type: 'iframeBlock';
} & IframeBlockPatch) | ({
    type: 'imageBlock';
} & ImageBlockPatch) | ({
    type: 'instagramBlock';
} & InstagramBlockPatch) | ({
    type: 'jobsOverviewBlock';
} & JobsOverviewBlockPatch) | ({
    type: 'listicleBlock';
} & ListicleBlockPatch) | ({
    type: 'listItemBlock';
} & ListItemBlockPatch) | ({
    type: 'matchDetailSectionBlock';
} & MatchDetailSectionBlockPatch) | ({
    type: 'matchListBlock';
} & MatchListBlockPatch) | ({
    type: 'matchPredictionBlock';
} & MatchPredictionBlockPatch) | ({
    type: 'mediaBlock';
} & MediaBlockPatch) | ({
    type: 'overviewMatchesBlock';
} & OverviewMatchesBlockPatch) | ({
    type: 'paywallBlock';
} & PaywallBlockPatch) | ({
    type: 'playerBlock';
} & PlayerBlockPatch) | ({
    type: 'playerGradesBlock';
} & PlayerGradesBlockPatch) | ({
    type: 'pollBlock';
} & PollBlockPatch) | ({
    type: 'pouleBlock';
} & PouleBlockPatch) | ({
    type: 'quoteBlock';
} & QuoteBlockPatch) | ({
    type: 'recipeBlock';
} & RecipeBlockPatch) | ({
    type: 'relatedBlock';
} & RelatedBlockPatch) | ({
    type: 'richTextBlock';
} & RichTextBlockPatch) | ({
    type: 'standingsBlock';
} & StandingsBlockPatch) | ({
    type: 'streamerBlock';
} & StreamerBlockPatch) | ({
    type: 'tableBlock';
} & TableBlockPatch) | ({
    type: 'tiktokBlock';
} & TikTokBlockPatch) | ({
    type: 'xPostBlock';
} & XPostBlockPatch) | ({
    type: 'wattWizardBlock';
} & WattWizardBlockPatch) | ({
    type: 'youtubeBlock';
} & YoutubeBlockPatch);

export type GalleryBlockPatch = {
    type: ArticleBlockType;
    layout?: GalleryBlockLayout;
    images: Array<ImageBlockPatch>;
};

export type HtmlBlockPatch = {
    type: ArticleBlockType;
    htmlAndScript: string;
    margin?: boolean;
};

export type IframeBlockPatch = {
    type: ArticleBlockType;
    url: string;
    embedBlock?: string;
};

export type InstagramBlockPatch = {
    type: ArticleBlockType;
    postID: string;
    url: string;
    embedBlock?: string;
};

export type JobsOverviewBlockPatch = {
    type: ArticleBlockType;
};

export type ListicleBlockPatch = {
    type: ArticleBlockType;
    enumerator: string;
    title?: string;
    image?: ImageBlockPatch;
    text?: string;
    align?: 'left' | 'right';
    callToAction?: ListicleCTA;
};

export type ListItemBlockPatch = {
    type: ArticleBlockType;
    xml: {
        [key: string]: unknown;
    };
};

export type MatchDetailSectionBlockPatch = {
    type: ArticleBlockType;
    matchID?: string;
    showOdds?: boolean;
};

export type MatchListBlockPatch = {
    type: ArticleBlockType;
    matches: Array<MatchListBlockPatchMatch>;
    showCompact?: boolean;
    showDate?: boolean;
    url?: string;
    deepLink?: DeepLink;
    urlTitle?: string;
};

export type MatchListBlockPatchMatch = {
    /**
     * optaID
     */
    id: string;
};

export type MatchPredictionBlockPatch = {
    type: ArticleBlockType;
    matchID?: string;
};

export type MediaBlockPatch = {
    type: ArticleBlockType;
    url?: string;
    autoPlay?: boolean;
    showAsCarousel?: boolean;
    carouselPlaylist?: Hypermedia;
    duration?: number;
    title?: string;
    thumbnail?: string;
    vendor?: VideofeedVendor;
    videofeedItemID?: number;
};

export type OverviewMatchesBlockPatch = {
    type: ArticleBlockType;
    title?: string;
    overviewType: OverviewMatchesBlockType;
    teamID?: string;
    competitionID?: string;
};

export type PaywallBlockPatch = {
    type: ArticleBlockType;
    paywallType: PaywallType;
    fallback?: PayWallContent;
};

export type PlayerBlockPatch = {
    type: ArticleBlockType;
    player: Player;
    title: string;
    linkText: string;
    image?: string;
    showLink?: boolean;
    showNationalTeam?: boolean;
};

export type PlayerGradesBlockPatch = {
    type: ArticleBlockType;
    optaID?: string;
    homeTeam?: SportDataTeamGrades;
    awayTeam?: SportDataTeamGrades;
    referee?: SportDataPlayerGrade;
    manOfTheMatch?: SportDataPlayerGrade;
    matchGrade?: number;
};

export type PollBlockPatch = {
    type: ArticleBlockType;
    pollID: string;
    /**
     * @deprecated
     */
    title?: string;
    headline?: string;
    /**
     * @deprecated
     */
    question?: string;
    /**
     * @deprecated
     */
    answers?: Array<Answer>;
    poll?: Poll;
    /**
     * @deprecated
     */
    buttonText?: string;
    closed?: boolean;
    /**
     * @deprecated
     */
    ctaText?: string;
    /**
     * @deprecated
     */
    ctaLink?: string;
    result?: PollVoteResponse;
};

export type PouleBlockPatch = {
    type: ArticleBlockType;
    title?: string;
    tournamentCalendarID?: string;
    isLive?: boolean;
    standings?: Array<TeamStanding>;
};

export type QuoteBlockPatch = {
    type: ArticleBlockType;
    alignment?: AlignmentType;
    text: string;
    source?: string;
    behalf?: string;
};

export type RecipeBlockPatch = {
    type: ArticleBlockType;
    xml: {
        [key: string]: unknown;
    };
};

export type RelatedBlockPatch = {
    type: ArticleBlockType;
    title: string;
    items: Array<RelatedNewsItemPatch>;
};

export type RelatedNewsItemPatch = {
    /**
     * newsID or originalID
     */
    id: string;
};

export type RichTextBlockPatch = {
    type: ArticleBlockType;
    /**
     * When creating a RichTextBlock for User Generated Content, the `text` property can have at most 10000 characters.
     */
    text: string;
};

export type StandingsBlockPatch = {
    type: ArticleBlockType;
    standing?: TournamentStandings;
    firstPosition?: number;
    lastPosition?: number;
    title?: string;
    /**
     * @deprecated
     */
    teamID?: string;
    highlightedTeams?: Array<string>;
    competitionID?: string;
    countryName?: string;
    deepLink?: DeepLink;
    followTeam?: boolean;
    freezeStandings?: boolean;
};

export type StreamerBlockPatch = {
    type: ArticleBlockType;
    alignment: AlignmentType;
    text: string;
};

export type TableBlockPatch = {
    type: ArticleBlockType;
    rows: Array<TableRow>;
    headerRow: boolean;
};

export type TikTokBlockPatch = {
    type: ArticleBlockType;
    postURL: string;
    isPortrait?: boolean;
};

export type XPostBlockPatch = {
    type: ArticleBlockType;
    postID: string;
    postURL: string;
    embedBlock?: string;
};

export type WattWizardBlockPatch = {
    type: ArticleBlockType;
};

export type YoutubeBlockPatch = {
    type: ArticleBlockType;
    videoID: string;
    timestamp?: string;
    isPortrait?: boolean;
    embedBlock?: string;
};

export type BadRequest = {
    /**
     * The error name
     */
    name: string;
    /**
     * An error message
     */
    message: string;
    /**
     * The status code of the exception
     */
    status: number;
    /**
     * A list of related errors
     */
    errors?: Array<GenericError>;
    /**
     * The stack trace (only in development mode)
     */
    stack?: string;
};

export type NewsItemActionPatch = {
    newsTitle?: string;
    newsSubTitle?: string | null;
    categoryID?: number;
    status?: NewsStatus;
    newsCommentsEnabled?: boolean | null;
    newsText?: string;
    newsBold?: string;
    titleIsBold?: boolean | null;
    newsDate?: string;
    newsDateUpdate?: string | null;
    newsPublishDate?: string;
    newsFP?: boolean | null;
    push?: boolean | null;
    adsEnabled?: boolean | null;
    pushBody?: string | null;
    authors?: Array<Author>;
    sticky?: boolean | null;
    featured?: boolean | null;
    /**
     * Content as String
     *
     * Content as String, used while we still patch news from PHP
     */
    contentAsString?: string;
    content?: Array<ArticleBlockPatch>;
    showHome?: boolean;
    accessLevel?: ArticleAccessLevel;
    matchID?: string | null;
};

export type Image = {
    size: ImageSize;
};

export const ImageSize = {
    V2_FEATURED: 'v2_featured',
    V2_LARGE: 'v2_large',
    XL: 'xl',
    LARGE: 'large',
    QUATTRO: 'quattro',
    WC: 'wc',
    THUMB: 'thumb',
    VID: 'vid',
    VID_LARGE: 'vid_large',
    SOCIAL: 'social'
} as const;

export type ImageSize = typeof ImageSize[keyof typeof ImageSize];

export const ExperimentGroup = { A: 'a', B: 'b' } as const;

export type ExperimentGroup = typeof ExperimentGroup[keyof typeof ExperimentGroup];

export type LinkCleanupResult = {
    dryRun: boolean;
    enforceHttps: boolean;
    normalizeInternalLinks: boolean;
    host?: string;
    articles: number;
    replacements: Array<NewsLinkReplacement>;
};

export type NewsLinkReplacement = {
    editionID: number;
    oldUrl: string;
    newUrl?: string;
    action: NewsLinkAction;
};

export const NewsLinkAction = { REPLACE: 'replace' } as const;

export type NewsLinkAction = typeof NewsLinkAction[keyof typeof NewsLinkAction];

export type SendNewsPushNotificationsResult = {
    /**
     * If there is no config, then no push notification can be sent.
     */
    hasConfig: boolean;
    amountNewsItems?: number;
    amountClubNewsItems?: number;
    successfullySent?: Array<SuccessfulNewsPushNotification>;
    failedToSend?: Array<FailedNewsPushNotification>;
};

export type SuccessfulNewsPushNotification = {
    newsID?: number;
    message: {
        [key: string]: unknown;
    };
};

export type FailedNewsPushNotification = {
    newsID?: number;
    error: string;
    message: {
        [key: string]: unknown;
    };
};

export type SearchableCronResult = {
    amount: number;
};

export type NewsMarketingBlock = {
    contextID: number;
    beforeContent?: string;
    afterContent?: string;
    switchDateTime?: string;
};

export type NotificationBar = {
    /**
     * id
     */
    id: number;
    /**
     * platform
     */
    platform: string;
    /**
     * locale
     */
    locale: string;
    /**
     * domainID
     *
     * domainID of the domain this notification bar will be shown on. If domainID is NULL this notification bar will be shown on every domain for the attached platform and locale
     */
    domainID?: number;
    /**
     * newsID
     */
    newsID?: number;
    /**
     * title
     *
     * The title of a notification bar.
     */
    title?: string;
    category: NotificationBarCategory;
    /**
     * url
     *
     * If no url is filled in, the url will be set by the client's built-up url. Otherwise the editor chooses his own url, and the user will be redirected to that url when clicking on the notification bar.
     */
    url?: string;
    /**
     * priority
     *
     * The order of the notification bars.
     */
    priority: number;
    /**
     * tag
     *
     * Will be used as a sub-title or text which will be shown beside the notification bar title
     */
    tag?: string;
    /**
     * startTime
     *
     * Defines the start time before a notification bar will be shown.
     */
    startTime: string;
    /**
     * duration
     *
     * Shows how long the notification bar will be shown in minutes.
     */
    duration: number;
    /**
     * showOnArticles
     *
     * Checkbox if the notification bar will be shown on article pages.
     */
    showOnArticles: boolean;
    bookmaker?: Bookmaker;
};

export const NotificationBarCategory = {
    REGULAR: 'regular',
    BETTING: 'betting',
    BREAKING: 'breaking',
    PODCAST: 'podcast',
    LIVE: 'live',
    COUNTDOWN: 'countdown'
} as const;

export type NotificationBarCategory = typeof NotificationBarCategory[keyof typeof NotificationBarCategory];

export const NotificationBarOrderByOption = { PRIORITY: 'priority', START_TIME: 'startTime' } as const;

export type NotificationBarOrderByOption = typeof NotificationBarOrderByOption[keyof typeof NotificationBarOrderByOption];

export type NotificationBarActionCreateActionCreate = {
    /**
     * newsID
     */
    newsID?: number;
    /**
     * title
     *
     * The title of a notification bar.
     */
    title?: string;
    category: NotificationBarCategory;
    /**
     * url
     *
     * If no url is filled in, the url will be set by the client's built-up url. Otherwise the editor chooses his own url, and the user will be redirected to that url when clicking on the notification bar.
     */
    url?: string;
    /**
     * priority
     *
     * The order of the notification bars.
     */
    priority: number;
    /**
     * tag
     *
     * Will be used as a sub-title or text which will be shown beside the notification bar title
     */
    tag?: string;
    /**
     * startTime
     *
     * Defines the start time before a notification bar will be shown.
     */
    startTime: string;
    /**
     * duration
     *
     * Shows how long the notification bar will be shown in minutes.
     */
    duration: number;
    /**
     * showOnArticles
     *
     * Checkbox if the notification bar will be shown on article pages.
     */
    showOnArticles: boolean;
    bookmakerID?: number | null;
    bookmaker?: BookmakerActionCreate;
};

export type NotificationBarActionPatch = {
    newsID?: number | null;
    title?: string | null;
    category?: NotificationBarCategory;
    url?: string | null;
    priority?: number;
    tag?: string | null;
    startTime?: string;
    duration?: number;
    showOnArticles?: boolean;
    bookmakerID?: number | null;
};

export type Notification = {
    id: number;
    type: NotificationType;
    toUser?: number;
    fromUser?: number;
    userName?: string;
    userAvatar?: string;
    commentID?: number;
    newsThumbsID?: number;
    comment?: string;
    newsTitle?: string;
    link?: string;
    clicked?: boolean;
    /**
     * Duration in milliseconds.
     */
    duration?: number;
};

export const NotificationType = {
    NEWS_COMMENT: 'newsComment',
    NEWS_THUMBS: 'newsThumbs',
    FILTERED_COMMENT: 'filteredComment',
    USER_TEMP_BAN: 'userTempBan'
} as const;

export type NotificationType = typeof NotificationType[keyof typeof NotificationType];

export type NotificationUpdateListResponse = {
    affectedRows: number;
    updatedNotifications: Array<Notification>;
};

export type NotificationUpdateList = {
    idList?: Array<number>;
};

export type NotificationCountContainer = {
    count: number;
};

export type PollActionCreate = {
    title: string;
    description?: string;
    closeDate?: string;
    isArchived?: boolean;
    matchID?: string;
    answers?: Array<PollAnswerActionCreate>;
};

export type PollAnswerActionCreate = {
    isCorrect?: boolean;
    title: string;
};

export type PollActionPatch = {
    title?: string;
    description?: string | null;
    closeDate?: string;
    matchID?: string | null;
    answers?: Array<PollActionPatchAnswer>;
};

export type PollActionPatchAnswer = {
    id: number;
    title: string;
    isCorrect?: boolean | null;
};

export type Conflict = {
    /**
     * The error name
     */
    name: string;
    /**
     * An error message
     */
    message: string;
    /**
     * The status code of the exception
     */
    status: number;
    /**
     * A list of related errors
     */
    errors?: Array<GenericError>;
    /**
     * The stack trace (only in development mode)
     */
    stack?: string;
};

export type UserAccuracy = {
    grandTotal?: number;
    votedTotal?: number;
    votedCorrect?: number;
};

export type UserScore = {
    score?: number;
};

export type SitemapEntry = {
    loc: string;
    image?: string;
    lastmod?: string;
    changefreq: string;
    priority: number;
};

export type SitemapIndexEntry = {
    loc: string;
    lastmod: string;
};

export type SitemapGoogleEntry = {
    loc: string;
    name: string;
    language: string;
    lastmod?: string;
    pubDate: string;
    title: string;
};

export type TagMergeResult = {
    dryRun: boolean;
    potentialIssues?: Array<string>;
    before: TagMerge;
    after: TagMerge;
};

export type TagMerge = {
    oldTag?: {
        [key: string]: unknown;
    };
    oldTagNewsCount: number;
    targetTag?: {
        [key: string]: unknown;
    };
    targetTagNewsCount: number;
    updatedNewsTags?: number;
    deletedNewsTags?: number;
};

export type TagType = {
    tagTypeID: number;
    name: string;
    slug: string;
    allowMultipleParents: boolean;
};

export type VideofeedConfig = {
    /**
     * domainID
     *
     * The ID of the domain this videofeed config is attached to.
     */
    domainID?: number;
    /**
     * adSchedule
     *
     * Defines the schedule when an ad should be shown before the video starts.
     */
    adSchedule?: Array<boolean>;
    /**
     * minSeconds
     *
     * Defines the minimum amount of seconds a video should have to get ads
     */
    minSeconds?: number;
    vastTags?: VideofeedVendorConfig;
    gtags?: VideofeedVendorConfig;
    xandrIDs?: VideofeedVendorConfig;
    gpsIDs?: VideofeedVendorConfig;
};

export type VideofeedVendorConfig = {
    default: string;
    custom?: string;
    bb?: string;
    foxsport?: string;
    omnisport?: string;
    espn?: string;
    knvb?: string;
    viral?: string;
    advertorial?: string;
};

export const VideofeedConfigClient = {
    DEFAULT: 'default',
    ANDROID: 'android',
    IOS: 'ios'
} as const;

export type VideofeedConfigClient = typeof VideofeedConfigClient[keyof typeof VideofeedConfigClient];

export const VideofeedType = { DEFAULT: 'default', VERTICAL: 'vertical' } as const;

export type VideofeedType = typeof VideofeedType[keyof typeof VideofeedType];

export type VideofeedItem = {
    id: number;
    title: string;
    url?: string;
    thumbnail?: string;
    preview?: string;
    vendor: VideofeedVendor;
    subject?: SubjectID;
    duration?: number;
    domainTitle?: string;
    experimentID?: number;
    experimentTitle?: string;
    acceptationDate?: string;
    position?: number;
    isMain?: boolean;
    status: VideofeedStatus;
    path?: string;
    vendorID: string;
    platform?: PlatformID;
    rejectionDate?: string;
    feedType?: VideofeedType;
    creationDate: string;
    updateDate: string;
    domainID?: number;
    originalThumbnailUrl?: string;
};

export const VideofeedOrderBy = { POSITION: 'position' } as const;

export type VideofeedOrderBy = typeof VideofeedOrderBy[keyof typeof VideofeedOrderBy];

export type VideofeedItemActionCreateResponseScopeAdmin = {
    id: number;
    title: string;
    url?: string;
    thumbnail?: string;
    preview?: string;
    vendor: VideofeedVendor;
    subject?: SubjectID;
    duration?: number;
    domainTitle?: string;
    experimentID?: number;
    experimentTitle?: string;
    acceptationDate?: string;
    position?: number;
    isMain?: boolean;
    status: VideofeedStatus;
    path?: string;
    vendorID: string;
    platform?: PlatformID;
    rejectionDate?: string;
    feedType?: VideofeedType;
    creationDate: string;
    updateDate: string;
    domainID?: number;
    newsID?: number;
    originalThumbnailUrl?: string;
};

export type VideofeedItemActionCreate = {
    id?: number;
    title: string;
    url?: string;
    thumbnail?: string;
    preview?: string;
    vendor: VideofeedVendor;
    duration?: number;
    domainTitle?: string;
    experimentID?: number;
    experimentTitle?: string;
    acceptationDate?: string;
    position?: number;
    isMain?: boolean;
    path?: string;
    vendorID: string;
    rejectionDate?: string;
    feedType?: VideofeedType;
    videoFile?: string;
    imageFile?: string;
    createMediaArticle?: boolean;
    availableAllPlatforms?: boolean;
};

export type VideofeedItemActionUpdateResponseScopeAdmin = {
    id: number;
    title: string;
    url?: string;
    thumbnail?: string;
    preview?: string;
    vendor: VideofeedVendor;
    subject?: SubjectID;
    duration?: number;
    domainTitle?: string;
    experimentID?: number;
    experimentTitle?: string;
    acceptationDate?: string;
    position?: number;
    isMain?: boolean;
    status: VideofeedStatus;
    path?: string;
    vendorID: string;
    platform?: PlatformID;
    rejectionDate?: string;
    feedType?: VideofeedType;
    creationDate: string;
    updateDate: string;
    domainID?: number;
    newsID?: number;
    originalThumbnailUrl?: string;
};

export type VideofeedItemActionPatch = {
    title?: string;
    url?: string;
    thumbnail?: string;
    preview?: string;
    feedType?: string;
    videoFile?: string | null;
    imageFile?: string | null;
    createMediaArticle?: boolean;
    vendor?: VideofeedVendor;
    vendorID?: string;
    availableAllPlatforms?: boolean;
    duration?: number | null;
    domainTitle?: string | null;
    experimentTitle?: string | null;
    position?: number | null;
    status?: VideofeedStatusPatch;
};

export const VideofeedStatusPatch = { ACCEPTED: 'accepted', REJECTED: 'rejected' } as const;

export type VideofeedStatusPatch = typeof VideofeedStatusPatch[keyof typeof VideofeedStatusPatch];

export type ContactForm = {
    /**
     * The name of the user who filled out the form.
     */
    senderName: string;
    /**
     * The email address of the user who filled out the form.
     */
    senderEmailAddress: string;
    textBody: string;
    department: Department;
    captchaToken: string;
};

export const Department = {
    SALES: 'sales',
    EDITORIAL: 'editorial',
    MODERATORS: 'moderators',
    SUPPORT: 'support',
    VI_KIDS: 'vi-kids'
} as const;

export type Department = typeof Department[keyof typeof Department];

export type DepartmentsByEdition = {
    1: Edition1Departments;
    2: Edition2Departments;
    200: Edition200Departments;
    300: Edition300Departments;
    400: Edition400Departments;
};

export type Edition1Departments = {
    editorial: boolean;
};

export type Edition2Departments = {
    editorial: boolean;
};

export type Edition200Departments = {
    editorial: boolean;
    'vi-kids': boolean;
    support: boolean;
};

export type Edition300Departments = {
    sales: boolean;
    editorial: boolean;
    moderators: boolean;
};

export type Edition400Departments = {
    editorial: boolean;
};

export type Curation = {
    editionID: number;
    layout: FeaturedCarouselLayout;
    numberOfHeadlines: number;
    items?: Array<CuratedItem>;
    sections?: Array<CurationSection>;
};

export type CuratedExternalSnippet = {
    id: number;
    editionID: number;
    position: number;
    type: CuratedItemType;
    scope?: Scope | null;
    title?: string;
    unpublishAt?: string;
    isPinned?: boolean;
    targetingID?: string;
    content?: string;
};

export const CuratedItemType = {
    EXTERNAL_SNIPPET: 'externalSnippet',
    MARKETING_BLOCK: 'marketingBlock',
    MATCH: 'match',
    NEWS_ITEM: 'newsItem'
} as const;

export type CuratedItemType = typeof CuratedItemType[keyof typeof CuratedItemType];

export type CuratedMarketingItem = {
    id: number;
    editionID: number;
    position: number;
    type: CuratedItemType;
    scope?: Scope | null;
    title?: string;
    unpublishAt?: string;
    isPinned?: boolean;
    subtitle?: string;
    url?: string;
    image?: string;
    buttonText?: string;
    altButtonText?: string;
};

export type CuratedMatch = {
    id: number;
    editionID: number;
    position: number;
    type: CuratedItemType;
    scope?: Scope | null;
    title?: string;
    unpublishAt?: string;
    isPinned?: boolean;
    showMatchBlock: boolean;
    /**
     * url
     *
     * URL to be used for the title of the match block
     */
    url?: string;
    matches?: Array<Match>;
};

export type CuratedNewsItem = {
    id: number;
    editionID: number;
    position: number;
    type: CuratedItemType;
    scope?: Scope | null;
    title?: string;
    unpublishAt?: string;
    isPinned?: boolean;
    fontSize?: CuratedNewsFontSize;
    newsID: number;
    newsItem: News;
};

export const CuratedNewsFontSize = {
    S: 's',
    M: 'm',
    L: 'l',
    XL: 'xl',
    XXL: 'xxl',
    XXXL: 'xxxl'
} as const;

export type CuratedNewsFontSize = typeof CuratedNewsFontSize[keyof typeof CuratedNewsFontSize];

export type CuratedItem = ({
    type: 'externalSnippet';
} & CuratedExternalSnippet) | ({
    type: 'marketingBlock';
} & CuratedMarketingItem) | ({
    type: 'match';
} & CuratedMatch) | ({
    type: 'newsItem';
} & CuratedNewsItem);

export type CurationSection = {
    layout: FeaturedCarouselLayout;
    items: Array<({
        type: 'externalSnippet';
    } & CuratedExternalSnippet) | ({
        type: 'marketingBlock';
    } & CuratedMarketingItem) | ({
        type: 'match';
    } & CuratedMatch) | ({
        type: 'newsItem';
    } & CuratedNewsItem)>;
};

export type CurationPatchActionCreate = {
    layout: FeaturedCarouselLayout;
};

export type CurationPatchActionUpdate = {
    layout: FeaturedCarouselLayout;
};

export type CuratedItemBulkUpdateResponse = {
    items?: Array<CuratedItemBulk>;
};

export type CuratedNewsItemBase = {
    id: number;
    editionID: number;
    position: number;
    type: CuratedItemType;
    scope?: Scope | null;
    title?: string;
    unpublishAt?: string;
    isPinned?: boolean;
    fontSize?: CuratedNewsFontSize;
    newsID: number;
};

export type CuratedItemBulk = ({
    type: 'externalSnippet';
} & CuratedExternalSnippet) | ({
    type: 'marketingBlock';
} & CuratedMarketingItem) | ({
    type: 'newsItem';
} & CuratedNewsItemBase);

export type CuratedItemBulkBodyActionCreate = {
    items: Array<CuratedItemBulk>;
};

export type CuratedItemBulkBodyActionUpdate = {
    items: Array<CuratedItemBulk>;
};

export type CurationScheduleCronResult = {
    unscheduled: number;
    scheduled: number;
};

export type CuratedExternalSnippetActionCreate = {
    position: number;
    type: CuratedItemType;
    scope?: Scope | null;
    title?: string;
    unpublishAt?: string;
    isPinned?: boolean;
    targetingID?: string;
    content?: string;
};

export type CuratedExternalSnippetActionUpdate = {
    id: number;
    position: number;
    type: CuratedItemType;
    scope?: Scope | null;
    title?: string;
    unpublishAt?: string;
    isPinned?: boolean;
    targetingID?: string;
    content?: string;
};

export type CuratedMarketingItemActionCreate = {
    position: number;
    type: CuratedItemType;
    scope?: Scope | null;
    title?: string;
    unpublishAt?: string;
    isPinned?: boolean;
    subtitle?: string;
    url?: string;
    image?: string;
    buttonText?: string;
    altButtonText?: string;
};

export type CuratedMarketingItemActionUpdate = {
    id: number;
    position: number;
    type: CuratedItemType;
    scope?: Scope | null;
    title?: string;
    unpublishAt?: string;
    isPinned?: boolean;
    subtitle?: string;
    url?: string;
    image?: string;
    buttonText?: string;
    altButtonText?: string;
};

export type CuratedMatchPatchActionUpdate = {
    id: number;
    position: number;
    type: CuratedItemType;
    scope?: Scope | null;
    title?: string;
    unpublishAt?: string;
    isPinned?: boolean;
    showMatchBlock: boolean;
    /**
     * url
     *
     * URL to be used for the title of the match block
     */
    url?: string;
    matchID1?: string | null;
    matchID2?: string | null;
    matchID3?: string | null;
    matchID4?: string | null;
};

export type CuratedNewsItemBaseActionCreate = {
    position: number;
    type: CuratedItemType;
    scope?: Scope | null;
    title?: string;
    unpublishAt?: string;
    isPinned?: boolean;
    fontSize?: CuratedNewsFontSize;
    newsID: number;
};

export type CuratedNewsItemBaseActionUpdate = {
    id: number;
    position: number;
    type: CuratedItemType;
    scope?: Scope | null;
    title?: string;
    unpublishAt?: string;
    isPinned?: boolean;
    fontSize?: CuratedNewsFontSize;
    newsID: number;
};

export type EmbedHtml = {
    /**
     * Embed Html
     */
    embedHtml: string;
};

export type CapiEvent = {
    eventName: CapiEventName;
    actionSource: CapiActionSource;
    sourceUrl: string;
    queryParams?: {
        [key: string]: string;
    };
    payload?: CapiEventPayload;
};

export const CapiEventName = {
    VIEW_CONTENT: 'ViewContent',
    ADD_TO_CART: 'AddToCart',
    INITIATE_CHECKOUT: 'InitiateCheckout',
    PURCHASE: 'Purchase',
    PAGE_VIEW: 'PageView',
    SUBSCRIBE: 'Subscribe'
} as const;

export type CapiEventName = typeof CapiEventName[keyof typeof CapiEventName];

export const CapiActionSource = { WEBSITE: 'website', OTHER: 'other' } as const;

export type CapiActionSource = typeof CapiActionSource[keyof typeof CapiActionSource];

export type CapiEventPayload = {
    /**
     * Resolved in the API: userID of the current user
     */
    user_id?: number;
    /**
     * Resolved in the API: boolean indicating if a user is logged in
     */
    logged_in?: boolean;
    /**
     * Resolved in the API: boolean indicating if a user is a premium user
     */
    is_premium?: boolean;
    /**
     * Author of the current News article
     */
    author?: string;
    /**
     * NewsID of the current News article
     */
    newsID?: number;
    /**
     * News subtitle of the current News article
     */
    newsSubTitle?: string;
};

export type CapiBatchResult = {
    success: boolean;
    events: number;
};

export type CapiSetTestCodeResult = {
    code: {
        [key: string]: unknown;
    };
};

export type FaqCategory = {
    faqCategoryID?: number;
    editionID?: number;
    title: string;
};

export type FaqCategoryActionCreate = {
    title: string;
};

export type FaqCategoryActionPatch = {
    faqCategoryID?: number;
    title?: string;
};

export type Faq = {
    faqID?: number;
    faqCategoryID: number;
    title: string;
    content?: string;
    faqCategory?: FaqCategory;
};

export type FaqActionCreate = {
    faqCategoryID: number;
    title: string;
    content?: string;
};

export type FaqActionPatch = {
    faqID?: number;
    faqCategoryID?: number;
    title?: string;
    content?: string;
};

export type FeatureFlag = {
    flag: string;
    value: boolean;
    description?: string;
};

export type ReformatResult = {
    succeeded: Array<number>;
    failure: Array<number>;
};

export type MenuItem = {
    title: string;
    href: string;
    children?: Array<MenuItem>;
};

export type MobileConfig = {
    forceUpdate: ForceUpdateConfig;
    /**
     * Note: Property will be removed after migration, so default to true
     */
    disableMagnolia?: boolean;
    betting: BettingConfig;
};

export type ForceUpdateConfig = {
    /**
     * Note: is validated to adhere with https://semver.org/
     */
    minimalTargetOSVersion: string;
    /**
     * Note: is validated to adhere with https://semver.org/
     */
    minimalSupportedAppVersion: string;
    isMandatory: boolean;
    updateTitle: string;
    updateDescription: string;
    updateButtonTitle: string;
    skipButtonTitle: string;
};

export type BettingConfig = {
    isDisabled: boolean;
    ageGate: AgeGateConfig;
};

export type AgeGateConfig = {
    info: string;
    btnOver: string;
    btnUnder: string;
    disclaimer: string;
};

export const MobileConfigClient = { ANDROID: 'android', IOS: 'ios' } as const;

export type MobileConfigClient = typeof MobileConfigClient[keyof typeof MobileConfigClient];

export type ExternalSnippet = {
    contextID?: number;
    placement: ExternalSnippetPlacement;
    client?: ExternalSnippetClient;
    isEnabled?: boolean;
    isVisibleToAll?: boolean;
    hasWrapper?: boolean;
    wrapperSize?: ExternalSnippetWrapperSize;
    targetingID?: string;
    customTitle?: string;
    content?: string;
};

export const ExternalSnippetPlacement = {
    ALL_BEFORE_BODY_CLOSURE: 'all-before-body-closure',
    ALL_HEAD: 'all-head',
    ADS_DISABLED_HEAD: 'ads-disabled-head',
    HOME_AFTER_MENU: 'home-after-menu',
    HOME_AFTER_CAROUSEL: 'home-after-carousel',
    HOME_BEFORE_CONTENT: 'home-before-content',
    HOME_BEFORE_NEWS_LIST: 'home-before-news-list',
    HOME_AFTER_ARTICLE_10: 'home-after-article-10',
    HOME_AFTER_ARTICLE_20: 'home-after-article-20',
    HOME_AFTER_ARTICLE_30: 'home-after-article-30',
    HOME_AFTER_ARTICLE_40: 'home-after-article-40',
    HOME_AFTER_ARTICLE_50: 'home-after-article-50',
    HOME_AFTER_ARTICLE_60: 'home-after-article-60',
    HOME_AFTER_PLAYER: 'home-after-player',
    HOME_AFTER_PLAYER_AFTER_ARTICLE_5: 'home-after-player-after-article-5',
    HOME_CURATION_EXTERNAL_SNIPPET: 'home-curation-external-snippet',
    HOME_SIDEBAR_TOP: 'home-sidebar-top',
    HOME_SIDEBAR_AFTER_SECTION_1: 'home-sidebar-after-section-1',
    HOME_SIDEBAR_BEFORE_SECTION_2: 'home-sidebar-before-section-2',
    HOME_SIDEBAR_AFTER_SECTION_2: 'home-sidebar-after-section-2',
    HOME_SIDEBAR_BEFORE_SECTION_3: 'home-sidebar-before-section-3',
    PREMIUM_HOME_BEFORE_CONTENT: 'premium-home-before-content',
    NON_HOME_AFTER_MENU: 'non-home-after-menu',
    NON_HOME_BEFORE_CONTENT: 'non-home-before-content',
    NON_HOME_AFTER_ARTICLE_5: 'non-home-after-article-5',
    NON_HOME_AFTER_SECTION_1: 'non-home-after-section-1',
    NON_HOME_BEFORE_SECTION_2: 'non-home-before-section-2',
    NON_HOME_AFTER_SECTION_2: 'non-home-after-section-2',
    NON_HOME_BEFORE_SECTION_3: 'non-home-before-section-3',
    NON_HOME_SIDEBAR_TOP: 'non-home-sidebar-top',
    NON_HOME_SIDEBAR_AFTER_SECTION_1: 'non-home-sidebar-after-section-1',
    NON_HOME_SIDEBAR_BEFORE_SECTION_2: 'non-home-sidebar-before-section-2',
    NON_HOME_SIDEBAR_AFTER_SECTION_2: 'non-home-sidebar-after-section-2',
    NON_HOME_SIDEBAR_BEFORE_SECTION_3: 'non-home-sidebar-before-section-3',
    ARTICLE_AFTER_PARAGRAPH_1: 'article-after-paragraph-1',
    ARTICLE_BEFORE_PARAGRAPH_2: 'article-before-paragraph-2',
    ARTICLE_AFTER_PARAGRAPH_2: 'article-after-paragraph-2',
    ARTICLE_BEFORE_PARAGRAPH_3: 'article-before-paragraph-3',
    ARTICLE_AFTER_PARAGRAPH_3: 'article-after-paragraph-3',
    ARTICLE_BEFORE_PARAGRAPH_4: 'article-before-paragraph-4',
    ARTICLE_AFTER_PARAGRAPH_4: 'article-after-paragraph-4',
    ARTICLE_BEFORE_PARAGRAPH_5: 'article-before-paragraph-5',
    ARTICLE_AFTER_PARAGRAPH_7: 'article-after-paragraph-7',
    ARTICLE_BEFORE_PARAGRAPH_8: 'article-before-paragraph-8',
    ARTICLE_AFTER_PARAGRAPH_10: 'article-after-paragraph-10',
    ARTICLE_BEFORE_PARAGRAPH_11: 'article-before-paragraph-11',
    ARTICLE_AFTER_PARAGRAPH_13: 'article-after-paragraph-13',
    ARTICLE_BEFORE_PARAGRAPH_14: 'article-before-paragraph-14',
    ARTICLE_AFTER_CONTENT: 'article-after-content',
    ARTICLE_BEFORE_READMORE: 'article-before-readmore',
    ARTICLE_BEFORE_TAGS: 'article-before-tags',
    ARTICLE_AFTER_TAGS: 'article-after-tags',
    ARTICLE_BEFORE_COMMENTS: 'article-before-comments',
    ARTICLE_BLOCK_EXTERNAL_SNIPPET: 'article-block-external-snippet',
    ARTICLE_AFTER_COMMENT_5: 'article-after-comment-5',
    ARTICLE_AFTER_COMMENT_10: 'article-after-comment-10',
    ARTICLE_AFTER_COMMENT_15: 'article-after-comment-15',
    ARTICLE_AFTER_COMMENT_20: 'article-after-comment-20',
    ARTICLE_AFTER_COMMENT_25: 'article-after-comment-25',
    COMPETITION_DETAIL_SCHEDULE_AFTER_GROUP_1: 'competition-detail-schedule-after-group-1',
    CLUB_DETAIL_SCHEDULE_AFTER_GROUP_1: 'club-detail-schedule-after-group-1',
    MATCH_OVERVIEW_AFTER_COMPETITION_1: 'match-overview-after-competition-1'
} as const;

export type ExternalSnippetPlacement = typeof ExternalSnippetPlacement[keyof typeof ExternalSnippetPlacement];

export const ExternalSnippetClient = {
    MOBILE: 'mobile',
    DESKTOP: 'desktop',
    NULL: 'null'
} as const;

export type ExternalSnippetClient = typeof ExternalSnippetClient[keyof typeof ExternalSnippetClient];

export const ExternalSnippetWrapperSize = {
    H90: 'h90',
    H250: 'h250',
    H370: 'h370',
    H480: 'h480',
    H600: 'h600',
    NULL: 'null'
} as const;

export type ExternalSnippetWrapperSize = typeof ExternalSnippetWrapperSize[keyof typeof ExternalSnippetWrapperSize];

export type PlacementList = {
    externalSnippetsByPlacement: {
        'all-before-body-closure'?: Array<ExternalSnippet>;
        'all-head'?: Array<ExternalSnippet>;
        'ads-disabled-head'?: Array<ExternalSnippet>;
        'home-after-menu'?: Array<ExternalSnippet>;
        'home-after-carousel'?: Array<ExternalSnippet>;
        'home-before-content'?: Array<ExternalSnippet>;
        'home-before-news-list'?: Array<ExternalSnippet>;
        'home-after-article-10'?: Array<ExternalSnippet>;
        'home-after-article-20'?: Array<ExternalSnippet>;
        'home-after-article-30'?: Array<ExternalSnippet>;
        'home-after-article-40'?: Array<ExternalSnippet>;
        'home-after-article-50'?: Array<ExternalSnippet>;
        'home-after-article-60'?: Array<ExternalSnippet>;
        'home-after-player'?: Array<ExternalSnippet>;
        'home-after-player-after-article-5'?: Array<ExternalSnippet>;
        'home-curation-external-snippet'?: Array<ExternalSnippet>;
        'home-sidebar-top'?: Array<ExternalSnippet>;
        'home-sidebar-after-section-1'?: Array<ExternalSnippet>;
        'home-sidebar-before-section-2'?: Array<ExternalSnippet>;
        'home-sidebar-after-section-2'?: Array<ExternalSnippet>;
        'home-sidebar-before-section-3'?: Array<ExternalSnippet>;
        'premium-home-before-content'?: Array<ExternalSnippet>;
        'non-home-after-menu'?: Array<ExternalSnippet>;
        'non-home-before-content'?: Array<ExternalSnippet>;
        'non-home-after-article-5'?: Array<ExternalSnippet>;
        'non-home-after-section-1'?: Array<ExternalSnippet>;
        'non-home-before-section-2'?: Array<ExternalSnippet>;
        'non-home-after-section-2'?: Array<ExternalSnippet>;
        'non-home-before-section-3'?: Array<ExternalSnippet>;
        'non-home-sidebar-top'?: Array<ExternalSnippet>;
        'non-home-sidebar-after-section-1'?: Array<ExternalSnippet>;
        'non-home-sidebar-before-section-2'?: Array<ExternalSnippet>;
        'non-home-sidebar-after-section-2'?: Array<ExternalSnippet>;
        'non-home-sidebar-before-section-3'?: Array<ExternalSnippet>;
        'article-after-paragraph-1'?: Array<ExternalSnippet>;
        'article-before-paragraph-2'?: Array<ExternalSnippet>;
        'article-after-paragraph-2'?: Array<ExternalSnippet>;
        'article-before-paragraph-3'?: Array<ExternalSnippet>;
        'article-after-paragraph-3'?: Array<ExternalSnippet>;
        'article-before-paragraph-4'?: Array<ExternalSnippet>;
        'article-after-paragraph-4'?: Array<ExternalSnippet>;
        'article-before-paragraph-5'?: Array<ExternalSnippet>;
        'article-after-paragraph-7'?: Array<ExternalSnippet>;
        'article-before-paragraph-8'?: Array<ExternalSnippet>;
        'article-after-paragraph-10'?: Array<ExternalSnippet>;
        'article-before-paragraph-11'?: Array<ExternalSnippet>;
        'article-after-paragraph-13'?: Array<ExternalSnippet>;
        'article-before-paragraph-14'?: Array<ExternalSnippet>;
        'article-after-content'?: Array<ExternalSnippet>;
        'article-before-readmore'?: Array<ExternalSnippet>;
        'article-before-tags'?: Array<ExternalSnippet>;
        'article-after-tags'?: Array<ExternalSnippet>;
        'article-before-comments'?: Array<ExternalSnippet>;
        'article-block-external-snippet'?: Array<ExternalSnippet>;
        'article-after-comment-5'?: Array<ExternalSnippet>;
        'article-after-comment-10'?: Array<ExternalSnippet>;
        'article-after-comment-15'?: Array<ExternalSnippet>;
        'article-after-comment-20'?: Array<ExternalSnippet>;
        'article-after-comment-25'?: Array<ExternalSnippet>;
        'competition-detail-schedule-after-group-1'?: Array<ExternalSnippet>;
        'club-detail-schedule-after-group-1'?: Array<ExternalSnippet>;
        'match-overview-after-competition-1'?: Array<ExternalSnippet>;
    };
};

export type ExternalSnippetActionPatch = {
    client?: ExternalSnippetClient | null;
    isEnabled?: boolean | null;
    isVisibleToAll?: boolean | null;
    hasWrapper?: boolean | null;
    wrapperSize?: ExternalSnippetWrapperSize | null;
    targetingID?: string | null;
    customTitle?: string | null;
    content?: string | null;
};

export type OriginalRedirect = {
    editionID: number;
    pageType: RedirectPageType;
    sourceDomain: string;
    sourcePath: string;
    newPath: string;
};

export const RedirectPageType = {
    ARTICLE: 'article',
    AUTHOR: 'author',
    HOMEPAGE: 'homepage',
    NEWS_CATEGORY: 'newsCategory',
    PAGE: 'page',
    SITEMAP: 'sitemap',
    TAG: 'tag'
} as const;

export type RedirectPageType = typeof RedirectPageType[keyof typeof RedirectPageType];

export type Page = {
    /**
     * Id
     */
    id?: number;
    /**
     * Title
     */
    title: string;
    /**
     * Title slug
     */
    titleSlug: string;
    /**
     * Path
     */
    path: string;
    /**
     * Text
     */
    text?: string;
    content?: Array<ArticleBlock>;
    /**
     * Meta description
     */
    metaDescription?: string | null;
    /**
     * Meta keywords
     */
    metaKeywords?: string | null;
    /**
     * Ads enabled
     */
    adsEnabled?: boolean | null;
    /**
     * Show page in sitemap
     */
    showInSitemap?: boolean | null;
    /**
     * Domain id
     */
    contextID?: number;
};

export type PageCreateActionCreate = {
    /**
     * Title
     */
    title: string;
    /**
     * Title slug
     */
    titleSlug: string;
    /**
     * Path
     */
    path: string;
    /**
     * Text
     */
    text?: string;
    /**
     * Content
     */
    content?: Array<ArticleBlock>;
    /**
     * Meta description
     */
    metaDescription?: string | null;
    /**
     * Meta keywords
     */
    metaKeywords?: string | null;
    /**
     * Ads enabled
     */
    adsEnabled?: boolean | null;
    /**
     * Show page in sitemap
     */
    showInSitemap?: boolean | null;
};

export type PagePatchActionPatch = {
    /**
     * Id
     */
    id?: number;
    /**
     * Title
     */
    title?: string;
    /**
     * Title slug
     */
    titleSlug?: string;
    /**
     * Full path
     */
    path?: string;
    /**
     * Text
     */
    text?: string;
    /**
     * Content
     */
    content?: Array<ArticleBlock>;
    /**
     * Meta description
     */
    metaDescription?: string | null;
    /**
     * Meta keywords
     */
    metaKeywords?: string | null;
    /**
     * Ads enabled
     */
    adsEnabled?: boolean | null;
    /**
     * Show page in sitemap
     */
    showInSitemap?: boolean | null;
};

export type PlayerRating = {
    optaMatchID: string;
    playerID: string;
    teamID?: string;
    editionID: number;
    competitionID: string;
    tournamentID: string;
    ratingType: RatingType;
    week?: number;
    grade?: number;
    optaGrade?: number;
    forAvg: boolean;
};

export const RatingType = {
    PLAYER: 'player',
    MOTM: 'motm',
    COACH: 'coach',
    REFEREE: 'referee',
    MATCHGRADE: 'matchgrade'
} as const;

export type RatingType = typeof RatingType[keyof typeof RatingType];

export type PlayerRatingPatch = {
    optaMatchID: string;
    playerID: string;
    teamID?: string;
    ratingType: RatingType;
    optaGrade?: number;
    grade?: number;
    forAvg?: boolean;
};

export type PrenlyErrorResponse = {
    code: string;
    message: string;
};

export type UserIdentification = {
    uid: string;
    token: string;
};

export type AuthenticateWithUsernameAndPasswordBody = {
    sharedKey: string;
    username: string;
    password: string;
};

export type UserSummary = {
    uid: string;
    email?: string;
    givenName?: string;
    familyName?: string;
    productCodes?: Array<string>;
};

export type GetUserBody = {
    sharedKey: string;
    uid: string;
    token: string;
};

export type Proposition = {
    propositionCode?: string;
    propositionTitle?: string;
    priceNet?: string;
    priceTaxPercentage?: string;
    incassoDiscount?: string;
    subscriptionPeriodType?: string;
    subscriptionPeriodAmount?: number;
    category?: string;
    typeOfProlonging?: string;
    propositionID: number;
    tierID: number;
    zenoPropositionID?: string;
    appPropositionID?: string;
    discountGroupID?: string;
    active: boolean;
    includesGift: boolean;
    isDefault: boolean;
    position: number;
    requiresAddress: boolean;
    title: string;
    description?: string;
    highlight?: string;
    priceBold?: string;
    price?: string;
    pricePostfix?: string;
    marketingTerm?: string;
    ecommerceValue?: number;
    voucherAvailable: boolean;
    campaignID?: string;
    tagID?: number | null;
    tag?: Tag;
};

export type SubscriptionDetails = {
    subscriptionNumber?: number;
    subscriptionPaymentMethod?: number;
    propositionId?: string;
    subscriptionCategory?: 'AUB' | 'VI' | 'VOE' | 'PRO' | 'WOM' | 'MEN' | 'RUW' | 'BCY' | 'BRI' | 'VOP';
    iban?: string;
    address?: AddressResponse;
    subscriptionStatus?: 'ACTIVE' | 'SUSPENDED_DELIVERY' | 'SUSPENDED_INVOICE_DELIVERY' | 'INCOMPLETE' | 'DELINQUENT_PAYEE' | 'INCOMPLETE_EXPIRED' | 'ARCHIVED';
    voucherCode?: string;
    freeFields?: FreeFields;
    endDate?: string;
    subscriptionStartDate?: string;
    startDate?: string;
};

export type AddressResponse = {
    street?: string;
    houseNumber: number;
    houseNumberAddition?: string;
    postalCode: string;
    city?: string;
};

export type FreeFields = {
    referrer?: FreeField;
    freeField6?: FreeField;
    freeField7?: FreeField;
    freeField8?: FreeField;
};

export type FreeField = {
    label?: string;
    value?: string;
};

export type PaymentMethod = {
    id: string;
    name: string;
    emandate: boolean;
};

export type SubscriptionUpdate = {
    subscriptionGroups?: Array<SubscriptionGroup>;
};

export type SubscriptionGroup = {
    subscriptionGroup: 'AUB' | 'VI' | 'VOE' | 'PRO' | 'WOM' | 'MEN' | 'RUW' | 'BCY' | 'BRI' | 'VOP';
    subscriptionTypes?: Array<string>;
    subscriptionStartDate?: string;
    subscriptionEndDate?: string;
    subscriptionIsSuspended?: boolean;
};

export type ShouldSwitchResponse = {
    shouldSwitch: boolean;
};

export type ZenoResponse = {
    status?: number;
    message?: string;
    redirect?: string;
    subscriptionNumber?: number;
};

export type CreateRelationRequest = {
    firstName?: string;
    lastName?: string;
    postalCode?: string;
    houseNumber?: number;
    houseNumberAddition?: string;
    city?: string;
};

export type UpdateRelationAddressRequest = {
    postalCode: string;
    houseNumber: number;
    houseNumberAddition?: string;
};

export type PaymentLinkRequest = {
    subscriptionNumber: number;
};

export type PartialAddSubscriptionRequest = {
    gift?: string;
    campaignID?: string;
    lastVisitedNewsID?: number;
    voucherCode?: string;
};

export type RedirectsResponse = {
    successRedirectUrl: string;
    errorRedirectUrl: string;
};

export type RedirectsRequest = {
    propositionCode?: string;
};

export type CheckVoucherCodeResponse = {
    [key: string]: unknown;
};

export type CheckVoucherCodeRequest = {
    voucherCode: string;
    requestTag?: string;
    subscriptionTypeCode?: string;
};

export type Gift = {
    giftID?: number;
    editionID?: number;
    title: string;
    key: string;
    active: boolean;
    image?: string;
};

export type GiftActionCreate = {
    title: string;
    key: string;
    active: boolean;
    image?: string;
};

export type CreateProposition = {
    tierID: number;
    zenoPropositionID?: string;
    appPropositionID?: string;
    discountGroupID?: string;
    active?: boolean;
    includesGift: boolean;
    isDefault?: boolean;
    requiresAddress: boolean;
    title: string;
    description?: string;
    highlight?: string;
    position?: number;
    priceBold?: string;
    price?: string;
    pricePostfix?: string;
    marketingTerm?: string;
    ecommerceValue?: number;
    voucherAvailable?: boolean;
    campaignID?: string;
    tagID?: number | null;
};

export type PatchProposition = {
    tierID?: number;
    zenoPropositionID?: string | null;
    appPropositionID?: string | null;
    discountGroupID?: string;
    active?: boolean;
    includesGift?: boolean;
    isDefault?: boolean;
    requiresAddress?: boolean;
    title?: string;
    description?: string;
    highlight?: string;
    position?: number;
    priceBold?: string;
    price?: string;
    pricePostfix?: string;
    marketingTerm?: string;
    ecommerceValue?: number;
    voucherAvailable?: boolean;
    campaignID?: string;
    tagID?: number | null;
};

export type Tier = {
    tierID: number;
    tierGroupID: number;
    active: boolean;
    title: string;
    slug: string;
    isFavorite: boolean;
    description: string;
    highlight?: string;
    position: number;
    image?: string;
    startingPricePrefix: string;
    startingPrice: string;
    startingPricePostfix: string;
    buttonLabel: string;
    uspHeader: string;
    propositions?: Array<Proposition>;
    successTitle?: string;
    successMessage?: string;
    successButton?: string;
    successPath?: string;
    paywallTitle?: string;
    usps?: Array<USP>;
};

export type USP = {
    uspID: number;
    tierID: number;
    text: string;
    bold: boolean;
    position: number;
};

export type CreateTier = {
    tierGroupID: number;
    active?: boolean;
    title: string;
    slug: string;
    isFavorite?: boolean;
    description: string;
    highlight?: string;
    image?: string;
    startingPricePrefix: string;
    startingPrice: string;
    startingPricePostfix: string;
    buttonLabel: string;
    uspHeader: string;
    successTitle?: string;
    successMessage?: string;
    successButton?: string;
    successPath?: string;
    paywallTitle?: string;
    usps?: Array<CreateUSP>;
};

export type CreateUSP = {
    text: string;
    bold?: boolean;
    position?: number;
};

export type PatchTier = {
    tierGroupID?: number;
    active?: boolean;
    title?: string;
    slug?: string;
    isFavorite?: boolean;
    description?: string;
    highlight?: string;
    image?: string;
    startingPricePrefix?: string;
    startingPrice?: string;
    startingPricePostfix?: string;
    buttonLabel?: string;
    uspHeader?: string;
    publishedAt?: string;
    successTitle?: string;
    successMessage?: string;
    successButton?: string;
    successPath?: string;
    paywallTitle?: string;
    usps?: Array<PatchUSP>;
    position?: number;
};

export type PatchUSP = {
    uspID?: number;
    tierID?: number;
    text?: string;
    bold?: boolean;
    position?: number;
};

export type TierGroup = {
    tierGroupID: number;
    editionID: number;
    active: boolean;
    slug?: string;
    title: string;
    tiers?: Array<Tier>;
    faqCategoryID?: number;
};

export type CreateTierGroup = {
    active?: boolean;
    slug?: string;
    title: string;
    faqCategoryID?: number;
};

export type PatchTierGroup = {
    active?: boolean;
    slug?: string | null;
    title?: string;
    faqCategoryID?: number;
};

export type TagTab = {
    tagTemplateTabID: number;
    type: TagTabType;
    title: string;
    show: boolean;
    slug?: string;
    content?: Array<ArticleBlock>;
    functionality?: NewsCategoryFunctionality;
    isMedia?: boolean;
};

export const TagTabType = {
    CHILD_TAGS: 'child-tags',
    CONTENT_BLOCKS: 'content-blocks',
    NEWS: 'news',
    OPTA_MATCHES: 'opta-matches',
    OPTA_SQUAD: 'opta-squad',
    OPTA_STANDINGS: 'opta-standings',
    OPTA_STATS: 'opta-stats',
    OVERVIEW: 'overview'
} as const;

export type TagTabType = typeof TagTabType[keyof typeof TagTabType];

export type TagTabPatch = {
    tagTemplateTabID: number;
    type: TagTabType;
    title?: string | null;
    slug?: string | null;
    content?: Array<ArticleBlock>;
};

export type TagTemplate = {
    tagTemplateID: number;
    name: string;
};

export type TagTemplateTab = {
    tagTemplateTabID: number;
    editionID: number;
    type: TagTabType;
    title: string;
    slug?: string;
    allowedBlocks?: Array<ToolbarOption>;
    functionality?: NewsCategoryFunctionality;
};

export const ToolbarOption = {
    INSERT_GALLERY: 'insertGallery',
    INSERT_IFRAME: 'insertIframe',
    INSERT_IMAGES: 'insertImages',
    INSERT_INSTAGRAM_POST: 'insertInstagramPost',
    INSERT_JOBS_OVERVIEW: 'insertJobsOverview',
    INSERT_LISTICLE_BLOCK: 'insertListicleBlock',
    INSERT_MATCH_BLOCK: 'insertMatchBlock',
    INSERT_MATCH_DETAIL_SECTION: 'insertMatchDetailSection',
    INSERT_MATCH_PREDICTION_BLOCK: 'insertMatchPredictionBlock',
    INSERT_MEDIA_BLOCK: 'insertMediaBlock',
    INSERT_OVERVIEW_MATCHES_BLOCK: 'insertOverviewMatchesBlock',
    INSERT_PAYWALL: 'insertPaywall',
    INSERT_PLAYER: 'insertPlayer',
    INSERT_POLL: 'insertPoll',
    INSERT_POULE: 'insertPoule',
    INSERT_PLAYER_GRADE: 'insertPlayerGrade',
    INSERT_POST: 'insertPost',
    INSERT_QUOTE: 'insertQuote',
    INSERT_RELATED_BLOCK: 'insertRelatedBlock',
    INSERT_STANDING_BLOCK: 'insertStandingBlock',
    INSERT_TIK_TOK_BLOCK: 'insertTikTokBlock',
    INSERT_WATT_WIZARD_BLOCK: 'insertWattWizardBlock',
    INSERT_YOUTUBE_VIDEO: 'insertYoutubeVideo',
    INSERT_EXTERNAL_SNIPPET: 'insertExternalSnippet',
    INSERT_ACCESS_WALL: 'insertAccessWall'
} as const;

export type ToolbarOption = typeof ToolbarOption[keyof typeof ToolbarOption];

export type UserGeneratedContentValidationError = {
    /**
     * The error name
     */
    name: string;
    /**
     * An error message
     */
    message: string;
    /**
     * The status code of the exception
     */
    status: number;
    /**
     * A list of related errors
     */
    errors: Array<UserGeneratedContentAJVError>;
    /**
     * The stack trace (only in development mode)
     */
    stack?: string;
};

export type DiscriminatorAJVError = {
    keyword: 'discriminator';
    instancePath: string;
    schemaPath: string;
    /**
     * Added to validation errors of "propertyNames" keyword schema
     */
    propertyName?: string;
    /**
     * Excluded if option `messages` set to false.
     */
    message?: string;
    schema?: {
        [key: string]: unknown;
    };
    parentSchema?: {
        [key: string]: unknown;
    };
    data?: {
        [key: string]: unknown;
    };
    modelName: string;
    dataPath: string;
    requestPath?: string;
    params: DiscriminatorAJVErrorParams;
};

export type DiscriminatorAJVErrorParams = {
    error: string;
    tag: string;
    tagValue: {
        [key: string]: unknown;
    };
};

export type EnumAJVError = {
    keyword: 'enum';
    instancePath: string;
    schemaPath: string;
    /**
     * Added to validation errors of "propertyNames" keyword schema
     */
    propertyName?: string;
    /**
     * Excluded if option `messages` set to false.
     */
    message?: string;
    schema?: {
        [key: string]: unknown;
    };
    parentSchema?: {
        [key: string]: unknown;
    };
    data?: {
        [key: string]: unknown;
    };
    modelName: string;
    dataPath: string;
    requestPath?: string;
    params: EnumAJVErrorParams;
};

export type EnumAJVErrorParams = {
    allowedValues: Array<string>;
};

export type MaxItemsAJVError = {
    keyword: 'maxItems';
    instancePath: string;
    schemaPath: string;
    /**
     * Added to validation errors of "propertyNames" keyword schema
     */
    propertyName?: string;
    /**
     * Excluded if option `messages` set to false.
     */
    message?: string;
    schema?: {
        [key: string]: unknown;
    };
    parentSchema?: {
        [key: string]: unknown;
    };
    data?: {
        [key: string]: unknown;
    };
    modelName: string;
    dataPath: string;
    requestPath?: string;
    params: MaxItemsAJVErrorParams;
};

export type MaxItemsAJVErrorParams = {
    limit: number;
};

export type MaxLengthAJVError = {
    keyword: 'maxLength';
    instancePath: string;
    schemaPath: string;
    /**
     * Added to validation errors of "propertyNames" keyword schema
     */
    propertyName?: string;
    /**
     * Excluded if option `messages` set to false.
     */
    message?: string;
    schema?: {
        [key: string]: unknown;
    };
    parentSchema?: {
        [key: string]: unknown;
    };
    data?: {
        [key: string]: unknown;
    };
    modelName: string;
    dataPath: string;
    requestPath?: string;
    params: MaxLengthAJVErrorParams;
};

export type MaxLengthAJVErrorParams = {
    limit: number;
};

export type MultipleOfAJVError = {
    keyword: 'multipleOf';
    instancePath: string;
    schemaPath: string;
    /**
     * Added to validation errors of "propertyNames" keyword schema
     */
    propertyName?: string;
    /**
     * Excluded if option `messages` set to false.
     */
    message?: string;
    schema?: {
        [key: string]: unknown;
    };
    parentSchema?: {
        [key: string]: unknown;
    };
    data?: {
        [key: string]: unknown;
    };
    modelName: string;
    dataPath: string;
    requestPath?: string;
    params: MultipleOfAJVErrorParams;
};

export type MultipleOfAJVErrorParams = {
    multipleOf: number;
};

export type RequiredAJVError = {
    keyword: 'required';
    instancePath: string;
    schemaPath: string;
    /**
     * Added to validation errors of "propertyNames" keyword schema
     */
    propertyName?: string;
    /**
     * Excluded if option `messages` set to false.
     */
    message?: string;
    schema?: {
        [key: string]: unknown;
    };
    parentSchema?: {
        [key: string]: unknown;
    };
    data?: {
        [key: string]: unknown;
    };
    modelName: string;
    dataPath: string;
    requestPath?: string;
    params: RequiredAJVErrorParams;
};

export type RequiredAJVErrorParams = {
    missingProperty: string;
};

export type TypeAJVError = {
    keyword: 'type';
    instancePath: string;
    schemaPath: string;
    /**
     * Added to validation errors of "propertyNames" keyword schema
     */
    propertyName?: string;
    /**
     * Excluded if option `messages` set to false.
     */
    message?: string;
    schema?: {
        [key: string]: unknown;
    };
    parentSchema?: {
        [key: string]: unknown;
    };
    data?: {
        [key: string]: unknown;
    };
    modelName: string;
    dataPath: string;
    requestPath?: string;
    params: TypeAJVErrorParams;
};

export type TypeAJVErrorParams = {
    type: string;
};

export type InvalidPathAJVError = {
    keyword: 'invalidPath';
    instancePath: string;
    schemaPath: string;
    /**
     * Added to validation errors of "propertyNames" keyword schema
     */
    propertyName?: string;
    /**
     * Excluded if option `messages` set to false.
     */
    message?: string;
    schema?: {
        [key: string]: unknown;
    };
    parentSchema?: {
        [key: string]: unknown;
    };
    data?: {
        [key: string]: unknown;
    };
    modelName: string;
    dataPath: string;
    requestPath?: string;
    params: {
        [key: string]: unknown;
    };
};

export type NotFoundAJVError = {
    keyword: 'notFound';
    instancePath: string;
    schemaPath: string;
    /**
     * Added to validation errors of "propertyNames" keyword schema
     */
    propertyName?: string;
    /**
     * Excluded if option `messages` set to false.
     */
    message?: string;
    schema?: {
        [key: string]: unknown;
    };
    parentSchema?: {
        [key: string]: unknown;
    };
    data?: {
        [key: string]: unknown;
    };
    modelName: string;
    dataPath: string;
    requestPath?: string;
    params: {
        [key: string]: unknown;
    };
};

export type RecaptchaFailedAJVError = {
    keyword: 'recaptchaFailed';
    instancePath: string;
    schemaPath: string;
    /**
     * Added to validation errors of "propertyNames" keyword schema
     */
    propertyName?: string;
    /**
     * Excluded if option `messages` set to false.
     */
    message?: string;
    schema?: {
        [key: string]: unknown;
    };
    parentSchema?: {
        [key: string]: unknown;
    };
    data?: {
        [key: string]: unknown;
    };
    modelName: string;
    dataPath: string;
    requestPath?: string;
    params: {
        [key: string]: unknown;
    };
};

export type RecaptchaLowScoreAJVError = {
    keyword: 'recaptchaLowScore';
    instancePath: string;
    schemaPath: string;
    /**
     * Added to validation errors of "propertyNames" keyword schema
     */
    propertyName?: string;
    /**
     * Excluded if option `messages` set to false.
     */
    message?: string;
    schema?: {
        [key: string]: unknown;
    };
    parentSchema?: {
        [key: string]: unknown;
    };
    data?: {
        [key: string]: unknown;
    };
    modelName: string;
    dataPath: string;
    requestPath?: string;
    params: {
        [key: string]: unknown;
    };
};

export type UniqueAJVError = {
    keyword: 'unique';
    instancePath: string;
    schemaPath: string;
    /**
     * Added to validation errors of "propertyNames" keyword schema
     */
    propertyName?: string;
    /**
     * Excluded if option `messages` set to false.
     */
    message?: string;
    schema?: {
        [key: string]: unknown;
    };
    parentSchema?: {
        [key: string]: unknown;
    };
    data?: {
        [key: string]: unknown;
    };
    modelName: string;
    dataPath: string;
    requestPath?: string;
    params: {
        [key: string]: unknown;
    };
};

export type UnsafeHtmlAJVError = {
    keyword: 'unsafeHTML';
    instancePath: string;
    schemaPath: string;
    /**
     * Added to validation errors of "propertyNames" keyword schema
     */
    propertyName?: string;
    /**
     * Excluded if option `messages` set to false.
     */
    message?: string;
    schema?: {
        [key: string]: unknown;
    };
    parentSchema?: {
        [key: string]: unknown;
    };
    data?: {
        [key: string]: unknown;
    };
    modelName: string;
    dataPath: string;
    requestPath?: string;
    params: {
        [key: string]: unknown;
    };
};

export type UserGeneratedContentAJVError = ({
    keyword: 'discriminator';
} & DiscriminatorAJVError) | ({
    keyword: 'enum';
} & EnumAJVError) | ({
    keyword: 'maxItems';
} & MaxItemsAJVError) | ({
    keyword: 'maxLength';
} & MaxLengthAJVError) | ({
    keyword: 'multipleOf';
} & MultipleOfAJVError) | ({
    keyword: 'required';
} & RequiredAJVError) | ({
    keyword: 'type';
} & TypeAJVError) | ({
    keyword: 'invalidPath';
} & InvalidPathAJVError) | ({
    keyword: 'notFound';
} & NotFoundAJVError) | ({
    keyword: 'recaptchaFailed';
} & RecaptchaFailedAJVError) | ({
    keyword: 'recaptchaLowScore';
} & RecaptchaLowScoreAJVError) | ({
    keyword: 'unique';
} & UniqueAJVError) | ({
    keyword: 'unsafeHTML';
} & UnsafeHtmlAJVError);

export type AJVError = {
    keyword: string;
    instancePath: string;
    schemaPath: string;
    /**
     * Added to validation errors of "propertyNames" keyword schema
     */
    propertyName?: string;
    /**
     * Excluded if option `messages` set to false.
     */
    message?: string;
    schema?: {
        [key: string]: unknown;
    };
    parentSchema?: {
        [key: string]: unknown;
    };
    data?: {
        [key: string]: unknown;
    };
    modelName: string;
    dataPath: string;
    requestPath?: string;
    params: {
        [key: string]: unknown;
    };
};

export type UserGeneratedContentActionCreate = {
    captchaToken: string;
    title: string;
    categoryID: number;
    /**
     * The following validation is applied to the article blocks:
     * - The `content` property can have at most 4 blocks.
     * - The following blocks are allowed: `FrameBlockPatch`, `GalleryBlockPatch`, `RichTextBlockPatch`.
     * - The `FrameBlockPatch` is only allowed to contain `blocks` with the following types: `richTextBlock`.
     * - The `FrameBlockPatch` can have at most 4 blocks.
     * - The `GalleryBlockPatch` can have at most 10 images;
     * - The `RichTextBlockPatch` only allows HTML with specific tags and attributes:
     * - tags: `<p>`, `<strong>`, `<span>`
     * - attributes:
     */
    content: Array<UserGeneratedArticleBlockPatch>;
    tagIDs?: Array<number>;
    image?: ImageBlockPatch;
    /**
     * There can be at most 0 user generated tags.
     */
    userGeneratedTags?: Array<UserGeneratedTag>;
};

export type UserGeneratedArticleBlockPatch = ({
    type: 'frameBlock';
} & FrameBlockPatch) | ({
    type: 'galleryBlock';
} & GalleryBlockPatch) | ({
    type: 'richTextBlock';
} & RichTextBlockPatch);

/**
 * If the user generated tag corresponds to an existing tag (based on the slugified `title` and `tagType`), then that tag will be used. If not, then a tag will be created and will be marked as needing moderation.
 */
export type UserGeneratedTag = {
    title: string;
    tagType: TagTypeForUserGeneratedContent;
};

export const TagTypeForUserGeneratedContent = { LICENSE_PLATE: 'license_plate' } as const;

export type TagTypeForUserGeneratedContent = typeof TagTypeForUserGeneratedContent[keyof typeof TagTypeForUserGeneratedContent];

export type UserMatchPredictionScoreboardItem = {
    userID: number;
    position: number;
    username: string;
    score: number;
};

export type UserMatchPredictionScoreboardWithUser = {
    pagination: Pagination;
    data: Array<UserMatchPredictionScoreboardItem>;
    user: UserMatchPredictionScoreboardItem;
};

export type UserMatchPredictionListMatches = {
    data?: Array<UserMatchPredictionMatch>;
};

export type UserMatchPredictionVotesForUserResponse = {
    votes: {
        [key: string]: 'home' | 'away' | 'draw';
    };
};

export type UserMatchPredictionVote = {
    userID: number;
    tournamentID: string;
    /**
     * @deprecated
     */
    matchID: number;
    optaID: string;
    vote: string;
    editionID: number;
};

export type UserMatchPredictionVoteBody = {
    tournamentID: string;
    /**
     * @deprecated
     */
    matchID: number;
    optaID?: string;
    vote: string;
};

export type TmpFile = {
    filename: string;
    destination: string;
};

export type PlayerMembership = {
    season: string;
    team: Team;
    appearances: number;
    goals: number;
};

export type PlayerPassport = {
    id: string;
    firstName: string;
    lastName: string;
    name?: string;
    birthDate?: string;
    birthPlace: string;
    nationality: string;
    country: string;
    height: number;
    weight: number;
    clubTeam?: PlayerClubTeam;
    nationalTeam?: Team;
    tag?: Tag;
};

export type PlayerClubTeam = {
    team: Team;
    activeSince?: string;
    competition?: Competition;
    position: PlayerPosition;
    shirtNumber?: number;
};

export type TeamSelection = {
    goalkeepers: Array<Player>;
    defenders: Array<Player>;
    midfielders: Array<Player>;
    attackers: Array<Player>;
    coaches: Array<Player>;
};

export type TournamentRanking = {
    name: string;
    rankingItems?: Array<TournamentRankingPosition>;
};

export type TournamentRankingPosition = {
    player: TournamentRankingPositionPlayer;
    teamID: string;
    teamTag?: Tag;
    rank: number;
    score: number;
};

export type TournamentRankingPositionPlayer = {
    id: string;
    name: string;
    lastName?: string;
    tag?: Tag;
};

export type TournamentBracket = {
    /**
     * Display name of the stage, for example Final or Semi-final.
     */
    stageName: string;
    match: Match;
    /**
     * Previous stages feeding into this match.
     */
    previous: Array<BracketNode>;
    /**
     * Tournament ID
     */
    id: string;
    thirdPlaceFinals?: Match;
};

export type BracketNode = {
    /**
     * Display name of the stage, for example Final or Semi-final.
     */
    stageName: string;
    match: Match;
    /**
     * Previous stages feeding into this match.
     */
    previous: Array<BracketNode>;
};

export type MagazineExport = {
    data: string;
    filename: string;
};

export const ExportRankingType = { TOP_SCORERS: 'top-scorers', TOP_ASSISTS: 'top-assists' } as const;

export type ExportRankingType = typeof ExportRankingType[keyof typeof ExportRankingType];

export type AIResult = {
    id: number;
    aiPromptID: number;
    result?: string;
    usedTokens?: number;
    date: string;
};

export type AIPrompt = {
    /**
     * Prompt
     */
    prompt: string;
    /**
     * Title
     */
    title: string;
    /**
     * Type
     */
    type: string;
    /**
     * Model
     */
    model: string;
    /**
     * Temperature
     */
    temperature: number;
    /**
     * Active
     */
    active: boolean;
    /**
     * Date
     */
    date?: string;
    /**
     * User id
     */
    userID?: number;
    /**
     * User name
     */
    userName?: string;
    id: number;
};

export const AIPromptType = { TEST: 'test', MATCH_REPORT: 'match-report' } as const;

export type AIPromptType = typeof AIPromptType[keyof typeof AIPromptType];

export const AIPromptModel = {
    GPT_3_5_TURBO: 'gpt-3.5-turbo',
    GPT_4_TURBO: 'gpt-4-turbo',
    GPT_4O: 'gpt-4o'
} as const;

export type AIPromptModel = typeof AIPromptModel[keyof typeof AIPromptModel];

export type AiPromptBaseActionCreate = {
    /**
     * Prompt
     */
    prompt: string;
    /**
     * Title
     */
    title: string;
    /**
     * Type
     */
    type: string;
    /**
     * Model
     */
    model: string;
    /**
     * Temperature
     */
    temperature: number;
    /**
     * Active
     */
    active: boolean;
    /**
     * User name
     */
    userName?: string;
};

export type AiPromptActionUpdate = {
    /**
     * Prompt
     */
    prompt: string;
    /**
     * Title
     */
    title: string;
    /**
     * Type
     */
    type: string;
    /**
     * Model
     */
    model: string;
    /**
     * Temperature
     */
    temperature: number;
    /**
     * Active
     */
    active: boolean;
    /**
     * User name
     */
    userName?: string;
    id: number;
};

export type AuditLog = {
    contextID?: number;
    userID: number;
    userName: string;
    affectedUserID?: number;
    affectedUserName?: string;
    action?: AuditLogAction;
    beforeAction?: string;
    afterAction?: string;
    actionDate: string;
    entity: AuditLogEntity;
};

export const AuditLogAction = {
    CANCEL: 'CANCEL',
    CREATE: 'CREATE',
    DELETE: 'DELETE',
    DELETE_FLAG: 'DELETE_FLAG',
    EXTEND: 'EXTEND',
    SHORTEN: 'SHORTEN',
    SOFT_DELETE: 'SOFT_DELETE',
    UNDO_SOFT_DELETE: 'UNDO_SOFT_DELETE',
    UPDATE: 'UPDATE'
} as const;

export type AuditLogAction = typeof AuditLogAction[keyof typeof AuditLogAction];

export const AuditLogEntity = {
    BAN: 'ban',
    COMMENT: 'comment',
    HOMEPAGE: 'homepage',
    BLOCKED_DOMAIN: 'blocked-domain',
    USER: 'user',
    SUBSCRIPTION: 'subscription',
    DISASSOCIATE: 'disassociate'
} as const;

export type AuditLogEntity = typeof AuditLogEntity[keyof typeof AuditLogEntity];

export type Experiment = {
    experimentID: number;
    creationDateTime: string;
    originalTitle?: string;
    experimentTitle: string;
    originalVisits?: number;
    experimentVisits?: number;
    startDateTime?: string;
    duration?: number;
    newsID?: number;
    videofeedID?: number;
    domainID: number;
    isRunning?: boolean;
};

export type FilteredComment = {
    contextID: number;
    captchaScore: number;
    newsCommentText: string;
    userAgent: string;
    userID?: number;
    userName?: string;
    ip: string;
    suspicious: boolean;
    forbiddenWord: boolean;
    dateTime: string;
    id: number;
};

export type ForbiddenWord = {
    /**
     * Id
     */
    id: number;
    /**
     * Word
     */
    word: string;
    /**
     * ContextID
     */
    contextID?: number;
};

export type ForbiddenWordActionCreate = {
    /**
     * Word
     */
    word: string;
    /**
     * ContextID
     */
    contextID?: number;
};

export type ForbiddenWordActionPatch = {
    word?: string;
    contextID?: number | null;
};

export type Redirect = {
    id: number;
    origin: string;
    target: string;
    creationDate: string;
    platform: string;
    locale: string;
    userID?: number;
    userName?: string;
    type: string;
    isRegex: boolean;
};

export type RedirectCreate = {
    origin: string;
    target: string;
    type: string;
};

export type RedirectUpdate = {
    id: number;
    origin: string;
    target: string;
    type: string;
};

export type KambiSyncResult = {
    competitions: number;
    eventsItems: number;
    events: number;
    matchesFound: number;
    matchesLinked: number;
    clubsLinked: number;
};

export type Locale = {
    id: LocaleID;
};

export type LokaliseKey = {
    key: string;
    file: string;
    branch?: string;
};

export type MatchOdds = {
    matchID: string;
    provider: OddsProvider;
    home: number;
    draw: number;
    away: number;
    importedAt: string;
    url?: string;
};

export type DeprecatedMobileConfig = {
    forceUpdate: ForceUpdateConfig;
};

export type Platform = {
    id: PlatformID;
    subject: SubjectID;
    name?: string;
    assetsBaseHref?: string;
    jwplayerKey?: string;
    gaID?: string;
};

export type FullContext = {
    id: number;
    platform: PlatformID;
    locale: LocaleID;
    subject: SubjectID;
    slug?: string;
    url: string;
    pattern?: string;
    name: string;
    nameSimple: string;
    languageName?: string;
    twitter?: string;
    strava?: string;
    facebook?: string;
    facebookPixel?: string;
    instagram?: string;
    tiktok?: string;
    tiktokPixel?: string;
    youtube?: string;
    address?: string;
    gaID?: string;
    googleTagManagerID?: string;
    nextDayAppID?: string;
    nextDayWebID?: string;
    onesignalID?: string;
    iosAppUrl?: string;
    androidAppUrl?: string;
    webpHost?: string;
    cdnHost?: string;
    iosAppID?: string;
    androidAppID?: string;
    androidAppHash?: string;
};

export type AdsTxt = {
    content: string;
    platform: string;
};

export type AdsTxtPatch = {
    content: string;
};

export type WarmUpCache = {
    path: string;
    type: WarmUpCacheType;
};

export const WarmUpCacheType = {
    WEBPWIDTH: 'webpwidth',
    THUMBNAIL: 'thumbnail',
    BACKGROUND: 'background'
} as const;

export type WarmUpCacheType = typeof WarmUpCacheType[keyof typeof WarmUpCacheType];

export type OddsDossier = {
    /**
     * id
     */
    id: number;
    /**
     * platform
     */
    platform: string;
    /**
     * locale
     */
    locale: string;
    /**
     * matches
     *
     * Array of matches which are connected to a odds dossier item.
     */
    matches?: Array<OddsDossierMatch>;
    /**
     * items
     *
     * Array of items which are connected to a odds dossier item.
     */
    items: Array<OddsDossierItem>;
};

export type OddsDossierMatch = {
    /**
     * id
     *
     * The id of a match
     */
    id: number;
    /**
     * oddsDossierID
     *
     * The id of the odds dossier this match belongs it.
     */
    oddsDossierID: number;
    /**
     * matchID
     *
     * The id of the match which will be linked to a dossier.
     */
    matchID: string;
};

export type OddsDossierItem = {
    /**
     * id
     *
     * The id of a item
     */
    id: number;
    /**
     * oddsDossierID
     *
     * The id of the odds dossier this item belongs it.
     */
    oddsDossierID: number;
    bookmaker?: Bookmaker;
    /**
     * title
     *
     * The title of a odds dossier item.
     */
    title?: string;
    /**
     * url
     *
     * The url which will be filled in by a user, when a item will be linked to a existing news item the url will be the url of that news item. Otherwise the bookmakerUrl from the scheduled odds dossier module.
     */
    url?: string;
    /**
     * tag
     *
     * Will be used as a sub-title or text which will be shown per item
     */
    tag?: string;
    /**
     * newsID
     *
     * The id of a news item
     */
    newsID?: number;
    /**
     * order
     *
     * The order in which the dossier items will be shown.
     */
    order: number;
};

export type OddsDossierActionUpsert = {
    /**
     * matches
     *
     * Array of matches which are connected to a odds dossier item.
     */
    matches?: Array<OddsDossierMatchActionUpsert>;
    /**
     * items
     *
     * Array of items which are connected to a odds dossier item.
     */
    items: Array<OddsDossierItemActionUpsert>;
};

export type OddsDossierMatchActionUpsert = {
    /**
     * matchID
     *
     * The id of the match which will be linked to a dossier.
     */
    matchID: string;
};

export type OddsDossierItemActionUpsert = {
    bookmakerID?: number;
    /**
     * title
     *
     * The title of a odds dossier item.
     */
    title?: string;
    /**
     * url
     *
     * The url which will be filled in by a user, when a item will be linked to a existing news item the url will be the url of that news item. Otherwise the bookmakerUrl from the scheduled odds dossier module.
     */
    url?: string;
    /**
     * tag
     *
     * Will be used as a sub-title or text which will be shown per item
     */
    tag?: string;
    /**
     * newsID
     *
     * The id of a news item
     */
    newsID?: number;
    /**
     * order
     *
     * The order in which the dossier items will be shown.
     */
    order: number;
};

export type Config = {
    domainID?: number;
    key: ConfigKey;
    value: {
        [key: string]: unknown;
    };
    /**
     * platform
     */
    platform?: string;
};

export const ConfigKey = {
    JWPLAYER_AD_SCHEDULE: 'jwplayer-ad-schedule',
    JWPLAYER_MIN_SEC: 'jwplayer-min-sec',
    JWPLAYER_VAST_TAGS: 'jwplayer-vast-tags',
    JWPLAYER_GTAG: 'jwplayer-gtag',
    JWPLAYER_XANDR: 'jwplayer-xandr',
    JWPLAYER_GPS: 'jwplayer-gps',
    JWPLAYER_IOS_AD_SCHEDULE: 'jwplayer-ios-ad-schedule',
    JWPLAYER_IOS_MIN_SEC: 'jwplayer-ios-min-sec',
    JWPLAYER_IOS_VAST_TAGS: 'jwplayer-ios-vast-tags',
    JWPLAYER_IOS_GTAG: 'jwplayer-ios-gtag',
    JWPLAYER_IOS_XANDR: 'jwplayer-ios-xandr',
    JWPLAYER_IOS_GPS: 'jwplayer-ios-gps',
    JWPLAYER_ANDROID_AD_SCHEDULE: 'jwplayer-android-ad-schedule',
    JWPLAYER_ANDROID_MIN_SEC: 'jwplayer-android-min-sec',
    JWPLAYER_ANDROID_VAST_TAGS: 'jwplayer-android-vast-tags',
    JWPLAYER_ANDROID_GTAG: 'jwplayer-android-gtag',
    JWPLAYER_ANDROID_XANDR: 'jwplayer-android-xandr',
    JWPLAYER_ANDROID_GPS: 'jwplayer-android-gps',
    JWPLAYER_VERTICAL_AD_SCHEDULE: 'jwplayer-vertical-ad-schedule',
    JWPLAYER_VERTICAL_MIN_SEC: 'jwplayer-vertical-min-sec',
    JWPLAYER_VERTICAL_VAST_TAGS: 'jwplayer-vertical-vast-tags',
    JWPLAYER_VERTICAL_GTAG: 'jwplayer-vertical-gtag',
    JWPLAYER_VERTICAL_XANDR: 'jwplayer-vertical-xandr',
    JWPLAYER_VERTICAL_GPS: 'jwplayer-vertical-gps',
    JWPLAYER_VERTICAL_IOS_AD_SCHEDULE: 'jwplayer-vertical-ios-ad-schedule',
    JWPLAYER_VERTICAL_IOS_MIN_SEC: 'jwplayer-vertical-ios-min-sec',
    JWPLAYER_VERTICAL_IOS_VAST_TAGS: 'jwplayer-vertical-ios-vast-tags',
    JWPLAYER_VERTICAL_IOS_GTAG: 'jwplayer-vertical-ios-gtag',
    JWPLAYER_VERTICAL_IOS_XANDR: 'jwplayer-vertical-ios-xandr',
    JWPLAYER_VERTICAL_IOS_GPS: 'jwplayer-vertical-ios-gps',
    JWPLAYER_VERTICAL_ANDROID_AD_SCHEDULE: 'jwplayer-vertical-android-ad-schedule',
    JWPLAYER_VERTICAL_ANDROID_MIN_SEC: 'jwplayer-vertical-android-min-sec',
    JWPLAYER_VERTICAL_ANDROID_VAST_TAGS: 'jwplayer-vertical-android-vast-tags',
    JWPLAYER_VERTICAL_ANDROID_GTAG: 'jwplayer-vertical-android-gtag',
    JWPLAYER_VERTICAL_ANDROID_XANDR: 'jwplayer-vertical-android-xandr',
    JWPLAYER_VERTICAL_ANDROID_GPS: 'jwplayer-vertical-android-gps',
    FEATURE_VNS_ENABLED: 'feature-vns-enabled',
    MOBILE_CONFIG_ANDROID: 'mobile-config-android',
    MOBILE_CONFIG_IOS: 'mobile-config-ios',
    G_RECAPTCHA_THRESHOLD: 'g-recaptcha-threshold',
    IP_QS: 'ip-qs'
} as const;

export type ConfigKey = typeof ConfigKey[keyof typeof ConfigKey];

export type ValidationError = {
    /**
     * The error name
     */
    name: string;
    /**
     * An error message
     */
    message: string;
    /**
     * The status code of the exception
     */
    status: number;
    /**
     * A list of related errors
     */
    errors?: Array<AJVError>;
    /**
     * The stack trace (only in development mode)
     */
    stack?: string;
};

export const SupertokensAuthMode = { HEADER: 'header', COOKIE: 'cookie' } as const;

export type SupertokensAuthMode = typeof SupertokensAuthMode[keyof typeof SupertokensAuthMode];

export type SignInPassword = {
    emailOrUsername: string;
    password: string;
    termsAccepted?: boolean;
};

export type LinkAndSignInPassword = {
    emailOrUsername: string;
    password: string;
    linkedPlatforms: Array<PlatformID>;
    newsletterOptIn?: boolean;
    termsAccepted?: boolean;
};

export type SignUpPassword = {
    /**
     * The email must be unique. To improve the user experience, use the endpoint to [check if an email exists](#/User/emailExistsUser) _before_ trying to sign up.
     */
    email: string;
    /**
     * The password must have at least 8 characters and have no more than 128 characters. The password must not repeat the same character 4 or more times.
     */
    password: string;
    /**
     * The username cannot contain an `@` symbol. The username must also be unique. To improve the user experience, use the endpoint to [check if a username exists](#/User/usernameExistsUser) _before_ trying to sign up.
     */
    username: string;
    firstName: string;
    lastName: string;
    birthDate: string;
    acceptTerms: boolean;
    newsletterOptIn?: boolean;
    captchaToken: string;
};

export type DeleteSupertokensUsersNotLinkedToNextUserResult = {
    amountDeleted: number;
    isDryRun: boolean;
};

export type EmailVerify = {
    /**
     * The token the user received in the email
     */
    token: string;
};

export type PasswordReset = {
    /**
     * The token the user received in the email
     */
    token: string;
    /**
     * The new password the user has chosen.
     *
     * The password must have at least 8 characters and have no more than 128 characters. The password must not repeat the same character 4 or more times.
     */
    password: string;
};

export type PasswordUpdate = {
    /**
     * The user's current password
     */
    password: string;
    /**
     * The password must have at least 8 characters and have no more than 128 characters. The password must not repeat the same character 4 or more times.
     */
    newPassword: string;
};

/**
 * The `AccessTokenPayload` is added to the access token. Compare the `hash` with the `User.accessTokenHash` when fetching the user profile. If they differ, then the AccessTokenPayload is outdated and the access token should be refreshed.
 */
export type AccessTokenPayload = {
    /**
     * A hash of the other properties.
     */
    hash: string;
    /**
     * The user ID.
     */
    id: number;
    /**
     * The username.
     */
    name: string;
    /**
     * The avatar image.
     */
    img?: string;
    /**
     * Allow ads.
     */
    ads?: boolean;
    /**
     * Allow betting.
     */
    bet?: boolean;
    /**
     * Allow premium.
     */
    prm?: boolean;
    /**
     * Allow magazine.
     */
    mag?: boolean;
    /**
     * TagID linked to the club subscription.
     */
    sTag?: number;
};

export type TestEventRequest = {
    matchID: string;
    eventType: TestEventType;
    teamID?: string;
    minute: number;
    second: number;
    period: MatchPeriod;
};

export const TestEventType = {
    PUSH_GOAL: 'PUSH_GOAL',
    PUSH_OWN_GOAL: 'PUSH_OWN_GOAL',
    PUSH_PENALTY_GOAL: 'PUSH_PENALTY_GOAL',
    PUSH_NO_GOAL: 'PUSH_NO_GOAL',
    PUSH_YELLOW_CARD: 'PUSH_YELLOW_CARD',
    PUSH_2ND_YELLOW_CARD: 'PUSH_2ND_YELLOW_CARD',
    PUSH_RED_CARD: 'PUSH_RED_CARD',
    PUSH_PENALTY_MISSED: 'PUSH_PENALTY_MISSED',
    PUSH_PENALTY_SHOOTOUT_SCORED: 'PUSH_PENALTY_SHOOTOUT_SCORED',
    PUSH_PENALTY_SHOOTOUT_MISSED: 'PUSH_PENALTY_SHOOTOUT_MISSED',
    PUSH_SUBSTITUTION: 'PUSH_SUBSTITUTION',
    PUSH_PERIOD_START: 'PUSH_PERIOD_START',
    PUSH_PERIOD_END: 'PUSH_PERIOD_END'
} as const;

export type TestEventType = typeof TestEventType[keyof typeof TestEventType];

export type TotoSyncResult = {
    competitions: number;
    events: number;
    matchesFound: number;
    matchesLinked: number;
};

export type TotoOddsImportResult = {
    matches: number;
    matchOddsUpserted: number;
};

export type User = {
    id: number;
    userName: string;
    /**
     * image
     *
     * The image URL.
     */
    image?: string;
    bettingEnabled?: boolean;
    /**
     * The `fullName` is created by concatenating the `firstName` and `lastName`.
     */
    fullName?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    gender: Gender;
    birthDate?: string;
    location?: string;
    role: UserRole;
    shadowBan?: boolean;
    tempBan?: TempBan;
    originDomainID?: number;
    platform?: PlatformID;
    locale?: LocaleID;
    originalID?: string;
    domainName?: string;
    registrationDate?: string;
    editionsWithActiveRole?: Array<number>;
    author?: UserAuthor;
    relationID?: number;
    copernicaProfileID?: string;
    /**
     * A hash of the properties that are added to the access token. If the hash in the access token differs from this hash, then properties on the access token are out of date and the client should refresh their access token.
     */
    accessTokenHash?: string;
    userPlatform?: UserPlatform;
    extraZenoData?: ExtraZenoData;
    termsAcceptedOn?: string;
    /**
     * Boolean to indicate if a user recently completed a subscription payment, used until the Zeno update arrived
     */
    paymentRecentlySucceeded?: boolean;
};

export const Gender = {
    UNKNOWN: 'unknown',
    MALE: 'male',
    FEMALE: 'female'
} as const;

export type Gender = typeof Gender[keyof typeof Gender];

export type TempBan = {
    /**
     * Duration in milliseconds.
     */
    duration: number;
    since: string;
    reason?: string;
    by: TempBanByUser;
};

export type TempBanByUser = {
    id: number;
    userName?: string;
};

export type UserAuthor = {
    id: number;
    editionID: number;
    function?: string;
    bio?: string;
    website?: string;
    twitter?: string;
    linkedin?: string;
    instagram?: string;
    facebook?: string;
    youtube?: string;
    customSlug: string;
    order?: number;
    showOnHome?: boolean;
    shortName?: string;
};

export type UserPlatform = {
    userID: number;
    platform: string;
    subscriptionTypes?: Array<string>;
    subscriptionStartDate?: string;
    subscriptionEndDate?: string;
    subscriptionIsSuspended?: boolean;
    subscriptionTagID?: number;
    subscriptionBooleans?: SubscriptionBooleans;
    hasActiveSubscription?: boolean;
    newsletterOptIn?: string;
    premiumNewsletterOptIn?: string;
};

export type SubscriptionBooleans = {
    allowAds: boolean;
    allowPremium: boolean;
    allowMagazine: boolean;
};

export type ExtraZenoData = {
    firstName?: string;
    lastName?: string;
    companyName?: string;
    email?: string;
    address?: Address;
};

export type Address = {
    street?: string;
    houseNumber: number;
    houseNumberAddition?: string;
    postalCode: string;
    city?: string;
};

export type AdminAccessInfo = {
    id: number;
    role: UserRole;
    editionsWithActiveRole?: Array<number>;
};

export type NewsletterOptIn = {
    newsletterOptIn?: boolean;
};

export type DisassociateUserFromTenant = {
    /**
     * The user's password
     */
    password: string;
};

export type EmailOrUsernameExists = {
    exists: boolean;
    isEmail: boolean;
    platforms: Array<PlatformID>;
    termsAccepted?: boolean;
    mustResetPassword?: boolean;
};

export type ProfileActionPatch = {
    userName?: string;
    image?: string | null;
    bettingEnabled?: boolean;
    firstName?: string;
    lastName?: string;
    gender?: Gender;
    userBio?: string | null;
    userInstagram?: string | null;
    userFacebook?: string | null;
    userTwitter?: string | null;
    userLinkedin?: string | null;
    userYoutube?: string | null;
    location?: string | null;
    birthDate?: string;
    extraZenoData?: ExtraZenoData;
};

export type EmailUpdateResponse = {
    status: EmailUpdateStatus;
};

export const EmailUpdateStatus = { VERIFICATION_REQUIRED: 'VERIFICATION_REQUIRED', SUCCESS: 'SUCCESS' } as const;

export type EmailUpdateStatus = typeof EmailUpdateStatus[keyof typeof EmailUpdateStatus];

export type EmailUpdate = {
    /**
     * The user's password
     */
    password: string;
    /**
     * The new email must not already be in use. To improve the user experience, use the endpoint to [check if an email exists](#/User/emailExistsUser) _before_ calling this endpoint.
     */
    newEmail: string;
};

export type UserActionPatch = {
    userName?: string;
    image?: string | null;
    firstName?: string;
    lastName?: string;
    gender?: Gender;
    birthDate?: string;
    location?: string | null;
    role?: UserRole;
    shadowBan?: boolean;
    tempBan?: TempBanActionPatch | null;
    editionsWithActiveRole?: Array<number>;
    author?: UserAuthorActionPatch | null;
};

export type TempBanActionPatch = {
    /**
     * Duration in milliseconds.
     */
    duration: number;
    /**
     * If the user is already banned, the `since` property must stay the same.
     */
    since: string;
    reason?: string;
};

export type UserAuthorActionPatch = {
    function?: string | null;
    bio?: string | null;
    website?: string | null;
    linkedin?: string | null;
    twitter?: string | null;
    instagram?: string | null;
    facebook?: string | null;
    youtube?: string | null;
    customSlug: string;
    order?: number | null;
    showOnHome?: boolean;
    shortName?: string | null;
};

export type ProfileDelete = {
    /**
     * The user's password
     */
    password: string;
};

export type GeneratedPassword = {
    /**
     * The generated password.
     */
    password: string;
};

export type ZenoRenewalCronResult = {
    amount: number;
};

export type UserThirdPartyResponse = {
    userID: number;
    email: string;
    subscriptionTypes: Array<string>;
};

export type VIImportUsersBatchResult = {
    amountImported: number;
    amountFailed: number;
    amountTotal: number;
};

export type DeleteCorruptedUsersResult = {
    notCompletedVIUserIDs: Array<string>;
    notFoundVIUserIDs: Array<string>;
    corruptedUsers: Array<CorruptedUser>;
};

export type CorruptedUser = {
    viUserID: string;
    email?: string;
    stUserExists: boolean;
};

export type HubBody = {
    'hub.mode': HubMode;
    'hub.topic': string;
    'hub.callback': string;
    'hub.secret'?: string;
    'hub.lease_seconds'?: string;
    /**
     * @deprecated
     */
    'hub.verify_token'?: string;
};

export const HubMode = { SUBSCRIBE: 'subscribe', UNSUBSCRIBE: 'unsubscribe' } as const;

export type HubMode = typeof HubMode[keyof typeof HubMode];

export type MigrateArticlesAutoblogMigrationData = {
    body?: never;
    path?: never;
    query: {
        scope?: Scope;
        articleType: AutoblogArticleType;
    };
    url: '/autoblog-migration/article';
};

export type MigrateArticlesAutoblogMigrationResponses = {
    /**
     * Success
     */
    200: unknown;
};

export type MigrateArticleAutoblogMigrationData = {
    body?: never;
    path: {
        /**
         * The ID of the Autoblog post to migrate
         */
        id: number;
    };
    query?: {
        scope?: Scope;
    };
    url: '/autoblog-migration/article/{id}';
};

export type MigrateArticleAutoblogMigrationResponses = {
    /**
     * Success
     */
    200: News;
};

export type MigrateArticleAutoblogMigrationResponse = MigrateArticleAutoblogMigrationResponses[keyof MigrateArticleAutoblogMigrationResponses];

export type MigrateSpotAutoblogMigrationData = {
    body?: never;
    path: {
        /**
         * The ID of the Autoblog spot to migrate
         */
        id: number;
    };
    query?: {
        scope?: Scope;
    };
    url: '/autoblog-migration/spot/{id}';
};

export type MigrateSpotAutoblogMigrationResponses = {
    /**
     * Success
     */
    200: News;
};

export type MigrateSpotAutoblogMigrationResponse = MigrateSpotAutoblogMigrationResponses[keyof MigrateSpotAutoblogMigrationResponses];

export type MigrateSpotsAutoblogMigrationData = {
    body?: never;
    path?: never;
    query: {
        batchSize: number;
    };
    url: '/autoblog-migration/spot';
};

export type migrateSpotsAutoblogMigrationErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
    /**
     * Too Many Requests
     */
    429: TooManyRequests;
};

export type migrateSpotsAutoblogMigrationError = migrateSpotsAutoblogMigrationErrors[keyof migrateSpotsAutoblogMigrationErrors];

export type MigrateSpotsAutoblogMigrationResponses = {
    /**
     * Success
     */
    200: AutoblogMigrateSpotsResult;
};

export type MigrateSpotsAutoblogMigrationResponse = MigrateSpotsAutoblogMigrationResponses[keyof MigrateSpotsAutoblogMigrationResponses];

export type MigrateImagesOfSpotAutoblogMigrationData = {
    body?: never;
    path: {
        /**
         * The ID of the Autoblog spot.
         */
        id: number;
    };
    query?: {
        scope?: Scope;
        autojunkImageConcurrency?: number;
        attachmentImageConcurrency?: number;
    };
    url: '/autoblog-migration/spot/{id}/image';
};

export type MigrateImagesOfSpotAutoblogMigrationResponses = {
    /**
     * Success
     */
    200: AutoblogMigrateImagesBatchResult;
};

export type MigrateImagesOfSpotAutoblogMigrationResponse = MigrateImagesOfSpotAutoblogMigrationResponses[keyof MigrateImagesOfSpotAutoblogMigrationResponses];

export type MigrateSpotImagesAutoblogMigrationData = {
    body?: never;
    path?: never;
    query: {
        batchSize: number;
        autojunkImageConcurrency?: number;
        attachmentImageConcurrency?: number;
        /**
         * For testing purposes only. When setting this parameter to `true` you start with migrating spot images stored as attachment, as opposed to starting with the old Autojunk spot images.
         */
        orderByIDDesc?: boolean;
    };
    url: '/autoblog-migration/spot-image';
};

export type migrateSpotImagesAutoblogMigrationErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
    /**
     * Too Many Requests
     */
    429: TooManyRequests;
};

export type migrateSpotImagesAutoblogMigrationError = migrateSpotImagesAutoblogMigrationErrors[keyof migrateSpotImagesAutoblogMigrationErrors];

export type MigrateSpotImagesAutoblogMigrationResponses = {
    /**
     * Success
     */
    200: AutoblogMigrateImagesBatchResult;
};

export type MigrateSpotImagesAutoblogMigrationResponse = MigrateSpotImagesAutoblogMigrationResponses[keyof MigrateSpotImagesAutoblogMigrationResponses];

export type ReplaceLinksAutoblogMigrationData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * The ID of the Autoblog post to link/replace
         */
        id?: number;
        /**
         * Limit of the amount of articles to be replaced
         */
        limit?: number;
        /**
         * Offset of the amount of articles to be replaced
         */
        offset?: number;
        scope?: Scope;
        /**
         * Offset to start were we left off.
         */
        startOffset?: number;
    };
    url: '/autoblog-migration/replace-links';
};

export type ReplaceLinksAutoblogMigrationResponses = {
    /**
     * Success
     */
    200: AutoblogMigrateReplaceLinksResult;
};

export type ReplaceLinksAutoblogMigrationResponse = ReplaceLinksAutoblogMigrationResponses[keyof ReplaceLinksAutoblogMigrationResponses];

export type ReplaceTabLinksAutoblogMigrationData = {
    body?: never;
    path?: never;
    query?: {
        scope?: Scope;
    };
    url: '/autoblog-migration/replace-tab-links';
};

export type ReplaceTabLinksAutoblogMigrationResponses = {
    /**
     * No Content
     */
    204: void;
};

export type ReplaceTabLinksAutoblogMigrationResponse = ReplaceTabLinksAutoblogMigrationResponses[keyof ReplaceTabLinksAutoblogMigrationResponses];

export type FetchAutoblogImagesAutoblogMigrationData = {
    body?: never;
    path?: never;
    query: {
        batchSize: number;
        /**
         * For debugging: migrate the images of a specific post.
         */
        postID?: number;
        /**
         * For debugging: migrate the images of specific posts.
         */
        postIDs?: Array<number>;
    };
    url: '/autoblog-migration/image';
};

export type fetchAutoblogImagesAutoblogMigrationErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
    /**
     * Too Many Requests
     */
    429: TooManyRequests;
};

export type fetchAutoblogImagesAutoblogMigrationError = fetchAutoblogImagesAutoblogMigrationErrors[keyof fetchAutoblogImagesAutoblogMigrationErrors];

export type FetchAutoblogImagesAutoblogMigrationResponses = {
    /**
     * Success
     */
    200: AutoblogMigrateImagesBatchResult;
};

export type FetchAutoblogImagesAutoblogMigrationResponse = FetchAutoblogImagesAutoblogMigrationResponses[keyof FetchAutoblogImagesAutoblogMigrationResponses];

export type MigrateUserAutoblogMigrationData = {
    body?: never;
    path: {
        /**
         * The ID of the Autoblog user to migrate
         */
        id: number;
    };
    query?: {
        scope?: Scope;
    };
    url: '/autoblog-migration/user/{id}';
};

export type migrateUserAutoblogMigrationErrors = {
    /**
     * Too Many Requests
     */
    429: TooManyRequests;
};

export type migrateUserAutoblogMigrationError = migrateUserAutoblogMigrationErrors[keyof migrateUserAutoblogMigrationErrors];

export type MigrateUsersAutoblogMigrationData = {
    body: {
        batchSize: number;
        userType?: ABUserType;
    };
    path?: never;
    query?: never;
    url: '/autoblog-migration/users';
};

export type migrateUsersAutoblogMigrationErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
    /**
     * Too Many Requests
     */
    429: TooManyRequests;
};

export type migrateUsersAutoblogMigrationError = migrateUsersAutoblogMigrationErrors[keyof migrateUsersAutoblogMigrationErrors];

export type MigrateUsersAutoblogMigrationResponses = {
    /**
     * Success
     */
    200: AutoblogMigrateUsersBatchResult;
};

export type MigrateUsersAutoblogMigrationResponse = MigrateUsersAutoblogMigrationResponses[keyof MigrateUsersAutoblogMigrationResponses];

export type DeleteCorruptedUsersAutoblogMigrationData = {
    body?: never;
    path?: never;
    query: {
        dryRun: boolean;
        scope?: Scope;
    };
    url: '/autoblog-migration/delete-corrupted-users';
};

export type DeleteCorruptedUsersAutoblogMigrationResponses = {
    /**
     * Success
     */
    200: AutoblogDeleteCorruptedUsersResult;
};

export type DeleteCorruptedUsersAutoblogMigrationResponse = DeleteCorruptedUsersAutoblogMigrationResponses[keyof DeleteCorruptedUsersAutoblogMigrationResponses];

export type MigrateCarTagsAutoblogMigrationData = {
    body?: never;
    path?: never;
    query?: {
        scope?: Scope;
        dryRun?: boolean;
        ids?: Array<number>;
        skipImageImport?: boolean;
    };
    url: '/autoblog-migration/car-tags';
};

export type MigrateCarTagsAutoblogMigrationResponses = {
    /**
     * Success
     */
    200: AutoblogMigrateCarTagsResult;
};

export type MigrateCarTagsAutoblogMigrationResponse = MigrateCarTagsAutoblogMigrationResponses[keyof MigrateCarTagsAutoblogMigrationResponses];

export type MigratePostTermsAutoblogMigrationData = {
    body?: never;
    path?: never;
    query: {
        scope?: Scope;
        /**
         * Make sure to import the car brands before the car models
         */
        tagType: AutoblogTermMigrationTagType;
        /**
         * For debugging purposes, specify the maximum number of migration list entries to migrate.
         */
        maxAmount?: number;
    };
    url: '/autoblog-migration/terms';
};

export type MigratePostTermsAutoblogMigrationResponses = {
    /**
     * Success
     */
    200: AutoblogMigrateTermsResult;
};

export type MigratePostTermsAutoblogMigrationResponse = MigratePostTermsAutoblogMigrationResponses[keyof MigratePostTermsAutoblogMigrationResponses];

export type FetchAndStoreVideoIndexAutoblogMigrationData = {
    body?: never;
    path?: never;
    query?: {
        scope?: Scope;
    };
    url: '/autoblog-migration/video-index';
};

export type FetchAndStoreVideoIndexAutoblogMigrationResponses = {
    /**
     * Success
     */
    200: unknown;
};

export type ImportOriginalRedirectsAutoblogMigrationData = {
    body?: never;
    path?: never;
    query?: {
        scope?: Scope;
    };
    url: '/autoblog-migration/original-redirect';
};

export type ImportOriginalRedirectsAutoblogMigrationResponses = {
    /**
     * Success
     */
    200: AutoblogImportOriginalRedirectsResult;
};

export type ImportOriginalRedirectsAutoblogMigrationResponse = ImportOriginalRedirectsAutoblogMigrationResponses[keyof ImportOriginalRedirectsAutoblogMigrationResponses];

export type ImportOddsBetCityData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/betcity/import/odds';
};

export type importOddsBetCityErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type importOddsBetCityError = importOddsBetCityErrors[keyof importOddsBetCityErrors];

export type ImportOddsBetCityResponses = {
    /**
     * Success
     */
    200: KambiOddsImportResult;
};

export type ImportOddsBetCityResponse = ImportOddsBetCityResponses[keyof ImportOddsBetCityResponses];

export type ListBlockedDomainData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Search for a specific page
         */
        search?: string;
        /**
         * Current page
         */
        page?: number;
        /**
         * Amount of items per page
         */
        perPage?: number;
        cache?: boolean;
    };
    url: '/blocked-domain';
};

export type listBlockedDomainErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type listBlockedDomainError = listBlockedDomainErrors[keyof listBlockedDomainErrors];

export type ListBlockedDomainResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<BlockedDomain>;
    };
};

export type ListBlockedDomainResponse = ListBlockedDomainResponses[keyof ListBlockedDomainResponses];

export type CreateBlockedDomainData = {
    body: BlockedDomainActionCreate;
    path?: never;
    query?: never;
    url: '/blocked-domain';
};

export type createBlockedDomainErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createBlockedDomainError = createBlockedDomainErrors[keyof createBlockedDomainErrors];

export type CreateBlockedDomainResponses = {
    /**
     * Created
     */
    201: BlockedDomain;
};

export type CreateBlockedDomainResponse = CreateBlockedDomainResponses[keyof CreateBlockedDomainResponses];

export type CheckBlockedDomainData = {
    body?: never;
    path?: never;
    query: {
        email: string;
        cache?: boolean;
    };
    url: '/blocked-domain/check';
};

export type CheckBlockedDomainResponses = {
    /**
     * Success
     */
    200: BlockedDomain;
};

export type CheckBlockedDomainResponse = CheckBlockedDomainResponses[keyof CheckBlockedDomainResponses];

export type DeleteBlockedDomainData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/blocked-domain/{id}';
};

export type deleteBlockedDomainErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteBlockedDomainError = deleteBlockedDomainErrors[keyof deleteBlockedDomainErrors];

export type DeleteBlockedDomainResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteBlockedDomainResponse = DeleteBlockedDomainResponses[keyof DeleteBlockedDomainResponses];

export type ListBlockedIpData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Search for an ip
         */
        search?: string;
        /**
         * Current page
         */
        page?: number;
        /**
         * Amount of items per page
         */
        perPage?: number;
        cache?: boolean;
    };
    url: '/blocked-ip';
};

export type listBlockedIpErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type listBlockedIpError = listBlockedIpErrors[keyof listBlockedIpErrors];

export type ListBlockedIpResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<BlockedIp>;
    };
};

export type ListBlockedIpResponse = ListBlockedIpResponses[keyof ListBlockedIpResponses];

export type CreateBlockedIpData = {
    body: BlockedIp;
    path?: never;
    query?: never;
    url: '/blocked-ip';
};

export type createBlockedIpErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createBlockedIpError = createBlockedIpErrors[keyof createBlockedIpErrors];

export type CreateBlockedIpResponses = {
    /**
     * Created
     */
    201: BlockedIp;
};

export type CreateBlockedIpResponse = CreateBlockedIpResponses[keyof CreateBlockedIpResponses];

export type DeleteBlockedIpData = {
    body?: never;
    path: {
        ip: string;
    };
    query?: never;
    url: '/blocked-ip/{ip}';
};

export type deleteBlockedIpErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
    /**
     * Not Found
     */
    404: NotFound;
};

export type deleteBlockedIpError = deleteBlockedIpErrors[keyof deleteBlockedIpErrors];

export type DeleteBlockedIpResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteBlockedIpResponse = DeleteBlockedIpResponses[keyof DeleteBlockedIpResponses];

export type CheckBlockedIpData = {
    body?: never;
    path: {
        ip: string;
    };
    query?: {
        cache?: boolean;
    };
    url: '/blocked-ip/{ip}';
};

export type checkBlockedIpErrors = {
    /**
     * Not Found
     */
    404: NotFound;
};

export type checkBlockedIpError = checkBlockedIpErrors[keyof checkBlockedIpErrors];

export type CheckBlockedIpResponses = {
    /**
     * Success
     */
    200: BlockedIp;
};

export type CheckBlockedIpResponse = CheckBlockedIpResponses[keyof CheckBlockedIpResponses];

export type GetAllBookmakerData = {
    body?: never;
    path?: never;
    query?: {
        cache?: boolean;
    };
    url: '/bookmaker';
};

export type getAllBookmakerErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getAllBookmakerError = getAllBookmakerErrors[keyof getAllBookmakerErrors];

export type GetAllBookmakerResponses = {
    /**
     * Success
     */
    200: Array<Bookmaker>;
};

export type GetAllBookmakerResponse = GetAllBookmakerResponses[keyof GetAllBookmakerResponses];

export type CreateBookmakerData = {
    body: BookmakerBase;
    path?: never;
    query?: never;
    url: '/bookmaker';
};

export type createBookmakerErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createBookmakerError = createBookmakerErrors[keyof createBookmakerErrors];

export type CreateBookmakerResponses = {
    /**
     * Created
     */
    201: Bookmaker;
};

export type CreateBookmakerResponse = CreateBookmakerResponses[keyof CreateBookmakerResponses];

export type DeleteBookmakerData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/bookmaker/{id}';
};

export type deleteBookmakerErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteBookmakerError = deleteBookmakerErrors[keyof deleteBookmakerErrors];

export type DeleteBookmakerResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteBookmakerResponse = DeleteBookmakerResponses[keyof DeleteBookmakerResponses];

export type GetByIdBookmakerData = {
    body?: never;
    path: {
        id: number;
    };
    query?: {
        cache?: boolean;
    };
    url: '/bookmaker/{id}';
};

export type getByIdBookmakerErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getByIdBookmakerError = getByIdBookmakerErrors[keyof getByIdBookmakerErrors];

export type GetByIdBookmakerResponses = {
    /**
     * Success
     */
    200: Bookmaker;
};

export type GetByIdBookmakerResponse = GetByIdBookmakerResponses[keyof GetByIdBookmakerResponses];

export type PatchBookmakerData = {
    /**
     * will be used to update a specific bookmaker
     */
    body: BookmakerActionPatch;
    path: {
        /**
         * will be used to update a specific bookmaker
         */
        id: number;
    };
    query?: never;
    url: '/bookmaker/{id}';
};

export type patchBookmakerErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type patchBookmakerError = patchBookmakerErrors[keyof patchBookmakerErrors];

export type PatchBookmakerResponses = {
    /**
     * Success
     */
    200: Bookmaker;
};

export type PatchBookmakerResponse = PatchBookmakerResponses[keyof PatchBookmakerResponses];

export type FlushAllCacheData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/cache/flush-all';
};

export type flushAllCacheErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type flushAllCacheError = flushAllCacheErrors[keyof flushAllCacheErrors];

export type FlushAllCacheResponses = {
    /**
     * Success
     */
    200: string;
};

export type FlushAllCacheResponse = FlushAllCacheResponses[keyof FlushAllCacheResponses];

export type GetBannerByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
    };
    query?: {
        page?: number;
        perPage?: number;
        cache?: boolean;
    };
    url: '/domain/{contextID}/banner';
};

export type getBannerByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getBannerByDomainIdError = getBannerByDomainIdErrors[keyof getBannerByDomainIdErrors];

export type GetBannerByDomainIdResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<Banner>;
    };
};

export type GetBannerByDomainIdResponse = GetBannerByDomainIdResponses[keyof GetBannerByDomainIdResponses];

export type CreateBannerByDomainIdData = {
    body: BannerActionCreate;
    path: {
        contextID: number;
    };
    query?: never;
    url: '/domain/{contextID}/banner';
};

export type createBannerByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createBannerByDomainIdError = createBannerByDomainIdErrors[keyof createBannerByDomainIdErrors];

export type CreateBannerByDomainIdResponses = {
    /**
     * Success
     */
    200: Banner;
};

export type CreateBannerByDomainIdResponse = CreateBannerByDomainIdResponses[keyof CreateBannerByDomainIdResponses];

export type DeleteBannerByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
        bannerID: number;
    };
    query?: never;
    url: '/domain/{contextID}/banner/{bannerID}';
};

export type deleteBannerByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteBannerByDomainIdError = deleteBannerByDomainIdErrors[keyof deleteBannerByDomainIdErrors];

export type DeleteBannerByDomainIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteBannerByDomainIdResponse = DeleteBannerByDomainIdResponses[keyof DeleteBannerByDomainIdResponses];

export type UpdateBannerByDomainIdData = {
    body: BannerActionUpdate;
    path: {
        contextID: number;
        bannerID: number;
    };
    query?: never;
    url: '/domain/{contextID}/banner/{bannerID}';
};

export type updateBannerByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type updateBannerByDomainIdError = updateBannerByDomainIdErrors[keyof updateBannerByDomainIdErrors];

export type UpdateBannerByDomainIdResponses = {
    /**
     * Success
     */
    200: Banner;
};

export type UpdateBannerByDomainIdResponse = UpdateBannerByDomainIdResponses[keyof UpdateBannerByDomainIdResponses];

export type VoteBinaryPollByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
        /**
         * The newsID for the vote
         */
        newsID: number;
        /**
         * The "direction" of the vote (up/down)
         */
        direction: BinaryPollVote;
    };
    query?: never;
    url: '/domain/{contextID}/binary-poll/{newsID}/vote/{direction}';
};

export type VoteBinaryPollByDomainIdResponses = {
    /**
     * Created
     */
    201: NewsThumb;
};

export type VoteBinaryPollByDomainIdResponse = VoteBinaryPollByDomainIdResponses[keyof VoteBinaryPollByDomainIdResponses];

export type ListCommentByDomainIdData = {
    body?: never;
    path: {
        /**
         * will return items with contextID null or the current contextID
         */
        contextID: number;
    };
    query?: {
        scope?: Scope;
        status?: CommentStatusFilter;
        newsID?: number;
        startDateTime?: string;
        endDateTime?: string;
        nested?: boolean;
        orderBy?: CommentOrderByOption;
        order?: Order;
        /**
         * current page
         */
        page?: number;
        /**
         * amount of items per page
         */
        perPage?: number;
        cache?: boolean;
    };
    url: '/domain/{contextID}/comment';
};

export type ListCommentByDomainIdResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<CommentFull>;
    };
};

export type ListCommentByDomainIdResponse = ListCommentByDomainIdResponses[keyof ListCommentByDomainIdResponses];

export type UpdateMultipleCommentByDomainIdData = {
    body: CommentUpdateList;
    path: {
        contextID: number;
    };
    query?: never;
    url: '/domain/{contextID}/comment';
};

export type updateMultipleCommentByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type updateMultipleCommentByDomainIdError = updateMultipleCommentByDomainIdErrors[keyof updateMultipleCommentByDomainIdErrors];

export type UpdateMultipleCommentByDomainIdResponses = {
    /**
     * Success
     */
    200: CommentUpdateListResponse;
};

export type UpdateMultipleCommentByDomainIdResponse = UpdateMultipleCommentByDomainIdResponses[keyof UpdateMultipleCommentByDomainIdResponses];

export type CreateCommentByDomainIdData = {
    body: CommentActionCreate;
    path: {
        contextID: number;
    };
    query: {
        client: Client;
    };
    url: '/domain/{contextID}/comment';
};

export type createCommentByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createCommentByDomainIdError = createCommentByDomainIdErrors[keyof createCommentByDomainIdErrors];

export type CreateCommentByDomainIdResponses = {
    /**
     * Created
     */
    201: CommentScopePublic;
};

export type CreateCommentByDomainIdResponse = CreateCommentByDomainIdResponses[keyof CreateCommentByDomainIdResponses];

export type GetMostLikesCommentByDomainIdData = {
    body?: never;
    path: {
        /**
         * will return items with contextID null or the current contextID
         */
        contextID: number;
    };
    query?: {
        cache?: boolean;
    };
    url: '/domain/{contextID}/comment/most-likes';
};

export type GetMostLikesCommentByDomainIdResponses = {
    /**
     * Success
     */
    200: Array<Comment>;
};

export type GetMostLikesCommentByDomainIdResponse = GetMostLikesCommentByDomainIdResponses[keyof GetMostLikesCommentByDomainIdResponses];

export type DeleteCommentByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
        /**
         * Will be used to remove a comment
         */
        id: number;
    };
    query?: never;
    url: '/domain/{contextID}/comment/{id}';
};

export type deleteCommentByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteCommentByDomainIdError = deleteCommentByDomainIdErrors[keyof deleteCommentByDomainIdErrors];

export type DeleteCommentByDomainIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteCommentByDomainIdResponse = DeleteCommentByDomainIdResponses[keyof DeleteCommentByDomainIdResponses];

export type PatchCommentByDomainIdData = {
    body: CommentActionPatch;
    path: {
        contextID: number;
        id: number;
    };
    query: {
        scope: Scope;
    };
    url: '/domain/{contextID}/comment/{id}';
};

export type patchCommentByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type patchCommentByDomainIdError = patchCommentByDomainIdErrors[keyof patchCommentByDomainIdErrors];

export type PatchCommentByDomainIdResponses = {
    /**
     * Success
     */
    200: CommentFull;
};

export type PatchCommentByDomainIdResponse = PatchCommentByDomainIdResponses[keyof PatchCommentByDomainIdResponses];

export type ListFlaggedCommentByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
    };
    query: {
        scope?: Scope;
        newsID: number;
        userID: number;
    };
    url: '/domain/{contextID}/comment/flag';
};

export type listFlaggedCommentByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type listFlaggedCommentByDomainIdError = listFlaggedCommentByDomainIdErrors[keyof listFlaggedCommentByDomainIdErrors];

export type ListFlaggedCommentByDomainIdResponses = {
    /**
     * Success
     */
    200: Array<FlaggedComment>;
};

export type ListFlaggedCommentByDomainIdResponse = ListFlaggedCommentByDomainIdResponses[keyof ListFlaggedCommentByDomainIdResponses];

export type DeleteFlaggedCommentByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
        commentID: number;
    };
    query?: never;
    url: '/domain/{contextID}/comment/{commentID}/flag';
};

export type deleteFlaggedCommentByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteFlaggedCommentByDomainIdError = deleteFlaggedCommentByDomainIdErrors[keyof deleteFlaggedCommentByDomainIdErrors];

export type DeleteFlaggedCommentByDomainIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteFlaggedCommentByDomainIdResponse = DeleteFlaggedCommentByDomainIdResponses[keyof DeleteFlaggedCommentByDomainIdResponses];

export type CreateFlaggedCommentByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
        commentID: number;
    };
    query?: never;
    url: '/domain/{contextID}/comment/{commentID}/flag';
};

export type createFlaggedCommentByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createFlaggedCommentByDomainIdError = createFlaggedCommentByDomainIdErrors[keyof createFlaggedCommentByDomainIdErrors];

export type CreateFlaggedCommentByDomainIdResponses = {
    /**
     * Created
     */
    201: FlaggedComment;
};

export type CreateFlaggedCommentByDomainIdResponse = CreateFlaggedCommentByDomainIdResponses[keyof CreateFlaggedCommentByDomainIdResponses];

export type CreateLikeCommentByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
        /**
         * Will be used to create a like
         */
        commentID: number;
    };
    query?: never;
    url: '/domain/{contextID}/comment/{commentID}/like';
};

export type createLikeCommentByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createLikeCommentByDomainIdError = createLikeCommentByDomainIdErrors[keyof createLikeCommentByDomainIdErrors];

export type CreateLikeCommentByDomainIdResponses = {
    /**
     * Created
     */
    201: NewsThumb;
};

export type CreateLikeCommentByDomainIdResponse = CreateLikeCommentByDomainIdResponses[keyof CreateLikeCommentByDomainIdResponses];

export type DeleteLikeCommentByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
        /**
         * Will be used to remove a like
         */
        commentID: number;
    };
    query?: never;
    url: '/domain/{contextID}/comment/like/{commentID}';
};

export type deleteLikeCommentByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteLikeCommentByDomainIdError = deleteLikeCommentByDomainIdErrors[keyof deleteLikeCommentByDomainIdErrors];

export type DeleteLikeCommentByDomainIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteLikeCommentByDomainIdResponse = DeleteLikeCommentByDomainIdResponses[keyof DeleteLikeCommentByDomainIdResponses];

export type ListLikeCommentByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
        newsID: number;
        userID: number;
    };
    query?: {
        cache?: boolean;
    };
    url: '/domain/{contextID}/comment/{newsID}/{userID}/user-likes';
};

export type listLikeCommentByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type listLikeCommentByDomainIdError = listLikeCommentByDomainIdErrors[keyof listLikeCommentByDomainIdErrors];

export type ListLikeCommentByDomainIdResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<NewsThumb>;
    };
};

export type ListLikeCommentByDomainIdResponse = ListLikeCommentByDomainIdResponses[keyof ListLikeCommentByDomainIdResponses];

export type GetFeaturedCarouselByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
    };
    query?: {
        cache?: boolean;
    };
    url: '/domain/{contextID}/featured-carousel';
};

export type GetFeaturedCarouselByDomainIdResponses = {
    /**
     * Success
     */
    200: FeaturedCarousel;
};

export type GetFeaturedCarouselByDomainIdResponse = GetFeaturedCarouselByDomainIdResponses[keyof GetFeaturedCarouselByDomainIdResponses];

export type DeleteAllMatchTickerByDomainIdData = {
    body?: never;
    path: {
        /**
         * Selects match ticker item by contextID.
         */
        contextID: number;
    };
    query?: never;
    url: '/domain/{contextID}/match-ticker';
};

export type deleteAllMatchTickerByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteAllMatchTickerByDomainIdError = deleteAllMatchTickerByDomainIdErrors[keyof deleteAllMatchTickerByDomainIdErrors];

export type DeleteAllMatchTickerByDomainIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteAllMatchTickerByDomainIdResponse = DeleteAllMatchTickerByDomainIdResponses[keyof DeleteAllMatchTickerByDomainIdResponses];

export type ListMatchTickerByDomainIdData = {
    body?: never;
    path: {
        /**
         * Selects items by given contextID.
         */
        contextID: number;
    };
    query?: {
        /**
         * Orders items by given column name (ascending).
         */
        orderBy?: MatchTickerOrderByOption;
        /**
         * Selects items by page number.
         */
        page?: number;
        /**
         * Limits amount of items per page.
         */
        perPage?: number;
        cache?: boolean;
    };
    url: '/domain/{contextID}/match-ticker';
};

export type ListMatchTickerByDomainIdResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<MatchTickerItem>;
    };
};

export type ListMatchTickerByDomainIdResponse = ListMatchTickerByDomainIdResponses[keyof ListMatchTickerByDomainIdResponses];

export type CreateMatchTickerByDomainIdData = {
    body: MatchTickerItemActionCreate;
    path: {
        /**
         * Links new match ticker item to selected context.
         */
        contextID: number;
    };
    query?: never;
    url: '/domain/{contextID}/match-ticker';
};

export type createMatchTickerByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createMatchTickerByDomainIdError = createMatchTickerByDomainIdErrors[keyof createMatchTickerByDomainIdErrors];

export type CreateMatchTickerByDomainIdResponses = {
    /**
     * Created
     */
    201: MatchTickerItem;
};

export type CreateMatchTickerByDomainIdResponse = CreateMatchTickerByDomainIdResponses[keyof CreateMatchTickerByDomainIdResponses];

export type DeleteMatchTickerByDomainIdData = {
    body?: never;
    path: {
        /**
         * Selects match ticker item by contextID.
         */
        contextID: number;
        /**
         * Selects match ticker item by matchID.
         */
        matchID: string;
    };
    query?: never;
    url: '/domain/{contextID}/match-ticker/{matchID}';
};

export type deleteMatchTickerByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
    /**
     * Not Found
     */
    404: NotFound;
};

export type deleteMatchTickerByDomainIdError = deleteMatchTickerByDomainIdErrors[keyof deleteMatchTickerByDomainIdErrors];

export type DeleteMatchTickerByDomainIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteMatchTickerByDomainIdResponse = DeleteMatchTickerByDomainIdResponses[keyof DeleteMatchTickerByDomainIdResponses];

export type PatchMatchTickerByDomainIdData = {
    body: MatchTickerItemActionPatch;
    path: {
        /**
         * Selects match ticker item by contextID.
         */
        contextID: number;
        /**
         * Selects match ticker item by matchID.
         */
        matchID: string;
    };
    query?: never;
    url: '/domain/{contextID}/match-ticker/{matchID}';
};

export type patchMatchTickerByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type patchMatchTickerByDomainIdError = patchMatchTickerByDomainIdErrors[keyof patchMatchTickerByDomainIdErrors];

export type PatchMatchTickerByDomainIdResponses = {
    /**
     * Success
     */
    200: MatchTickerItem;
};

export type PatchMatchTickerByDomainIdResponse = PatchMatchTickerByDomainIdResponses[keyof PatchMatchTickerByDomainIdResponses];

export type ListModuleScheduleByDomainIdData = {
    body?: never;
    path: {
        /**
         * will return items with contextID null and the current contextID
         */
        contextID: number;
    };
    query?: {
        /**
         * filter specific on the module schedule items for a given module
         */
        section?: ModuleScheduleSection;
        /**
         * filter on module schedule items with a given tagID (module schedule items's with NULL as tagID will also be returned), if null for scope public we only return items with tagID === null
         */
        tagID?: number;
        /**
         * will return items ordered by a given column
         */
        orderBy?: ModuleScheduleOrderByOptions;
        /**
         * order results in either ascending or descending order
         */
        order?: Order;
        scope?: Scope;
        /**
         * Filter items by ModuleScheduleStatus
         */
        status?: Array<ModuleScheduleStatus>;
        page?: number;
        perPage?: number;
        cache?: boolean;
    };
    url: '/domain/{contextID}/module-schedule';
};

export type ListModuleScheduleByDomainIdResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<ModuleScheduleItem>;
    };
};

export type ListModuleScheduleByDomainIdResponse = ListModuleScheduleByDomainIdResponses[keyof ListModuleScheduleByDomainIdResponses];

export type CreateModuleScheduleByDomainIdData = {
    body: ModuleScheduleItemActionCreateActionCreate;
    path: {
        /**
         * will be used to set the contextID on the created module schedule item
         */
        contextID: number;
    };
    query?: never;
    url: '/domain/{contextID}/module-schedule';
};

export type createModuleScheduleByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createModuleScheduleByDomainIdError = createModuleScheduleByDomainIdErrors[keyof createModuleScheduleByDomainIdErrors];

export type CreateModuleScheduleByDomainIdResponses = {
    /**
     * Created
     */
    201: ModuleScheduleItem;
};

export type CreateModuleScheduleByDomainIdResponse = CreateModuleScheduleByDomainIdResponses[keyof CreateModuleScheduleByDomainIdResponses];

export type DeleteModuleScheduleByDomainIdData = {
    body?: never;
    path: {
        /**
         * will be used to remove a specific module schedule item
         */
        contextID: number;
        /**
         * will be used to remove a specific module schedule item
         */
        id: number;
    };
    query?: never;
    url: '/domain/{contextID}/module-schedule/{id}';
};

export type deleteModuleScheduleByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteModuleScheduleByDomainIdError = deleteModuleScheduleByDomainIdErrors[keyof deleteModuleScheduleByDomainIdErrors];

export type DeleteModuleScheduleByDomainIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteModuleScheduleByDomainIdResponse = DeleteModuleScheduleByDomainIdResponses[keyof DeleteModuleScheduleByDomainIdResponses];

export type PatchModuleScheduleByDomainIdData = {
    body: ModuleScheduleItemActionPatch;
    path: {
        /**
         * will be used to update a specific module schedule item
         */
        contextID: number;
        /**
         * will be used to update a specific module schedule item
         */
        id: number;
    };
    query?: never;
    url: '/domain/{contextID}/module-schedule/{id}';
};

export type patchModuleScheduleByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type patchModuleScheduleByDomainIdError = patchModuleScheduleByDomainIdErrors[keyof patchModuleScheduleByDomainIdErrors];

export type PatchModuleScheduleByDomainIdResponses = {
    /**
     * Success
     */
    200: ModuleScheduleItem;
};

export type PatchModuleScheduleByDomainIdResponse = PatchModuleScheduleByDomainIdResponses[keyof PatchModuleScheduleByDomainIdResponses];

export type ListNavItemByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
    };
    query?: {
        isMain?: boolean;
        parentID?: number;
        cache?: boolean;
    };
    url: '/domain/{contextID}/nav-item';
};

export type ListNavItemByDomainIdResponses = {
    /**
     * Success
     */
    200: Array<NavItem>;
};

export type ListNavItemByDomainIdResponse = ListNavItemByDomainIdResponses[keyof ListNavItemByDomainIdResponses];

export type CreateNavItemByDomainIdData = {
    body: NavItemActionCreate;
    path: {
        contextID: number;
    };
    query?: never;
    url: '/domain/{contextID}/nav-item';
};

export type createNavItemByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createNavItemByDomainIdError = createNavItemByDomainIdErrors[keyof createNavItemByDomainIdErrors];

export type CreateNavItemByDomainIdResponses = {
    /**
     * Created
     */
    201: NavItem;
};

export type CreateNavItemByDomainIdResponse = CreateNavItemByDomainIdResponses[keyof CreateNavItemByDomainIdResponses];

export type DeleteNavItemByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
        navItemID: number;
    };
    query?: never;
    url: '/domain/{contextID}/nav-item/{navItemID}';
};

export type deleteNavItemByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteNavItemByDomainIdError = deleteNavItemByDomainIdErrors[keyof deleteNavItemByDomainIdErrors];

export type DeleteNavItemByDomainIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteNavItemByDomainIdResponse = DeleteNavItemByDomainIdResponses[keyof DeleteNavItemByDomainIdResponses];

export type PatchNavItemByDomainIdData = {
    body: NavItemActionPatch;
    path: {
        contextID: number;
        navItemID: number;
    };
    query?: never;
    url: '/domain/{contextID}/nav-item/{navItemID}';
};

export type patchNavItemByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type patchNavItemByDomainIdError = patchNavItemByDomainIdErrors[keyof patchNavItemByDomainIdErrors];

export type PatchNavItemByDomainIdResponses = {
    /**
     * Success
     */
    200: NavItem;
};

export type PatchNavItemByDomainIdResponse = PatchNavItemByDomainIdResponses[keyof PatchNavItemByDomainIdResponses];

export type ListNewsCategoryByDomainIdData = {
    body?: never;
    path: {
        /**
         * will filter items by contextID
         */
        contextID: number;
    };
    query?: {
        /**
         * will filter categories by functionality
         */
        functionality?: NewsCategoryFunctionality;
        /**
         * will filter items by nameSlug
         */
        nameSlug?: string;
        /**
         * will filter newsCategories that are video categories or general categories
         */
        isMedia?: boolean;
        cache?: boolean;
    };
    url: '/domain/{contextID}/news-category';
};

export type ListNewsCategoryByDomainIdResponses = {
    /**
     * Success
     */
    200: Array<NewsCategory>;
};

export type ListNewsCategoryByDomainIdResponse = ListNewsCategoryByDomainIdResponses[keyof ListNewsCategoryByDomainIdResponses];

export type GetBySlugNewsCategoryByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
        /**
         * Get news categor by slug
         */
        slug: string;
    };
    query?: {
        /**
         * will filter newsCategories that are video categories or general categories
         */
        isMedia?: boolean;
        cache?: boolean;
    };
    url: '/domain/{contextID}/news-category/{slug}';
};

export type GetBySlugNewsCategoryByDomainIdResponses = {
    /**
     * Success
     */
    200: NewsCategory;
};

export type GetBySlugNewsCategoryByDomainIdResponse = GetBySlugNewsCategoryByDomainIdResponses[keyof GetBySlugNewsCategoryByDomainIdResponses];

export type GetByFunctionalityNewsCategoryByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
        /**
         * Get news category by functionality
         */
        functionality: string;
    };
    query?: {
        /**
         * Filter newsCategories by isMedia in addition to functionality
         */
        isMedia?: boolean;
        cache?: boolean;
    };
    url: '/domain/{contextID}/news-category/functionality/{functionality}';
};

export type GetByFunctionalityNewsCategoryByDomainIdResponses = {
    /**
     * Success
     */
    200: NewsCategory;
};

export type GetByFunctionalityNewsCategoryByDomainIdResponse = GetByFunctionalityNewsCategoryByDomainIdResponses[keyof GetByFunctionalityNewsCategoryByDomainIdResponses];

export type PatchNewsCategoryByDomainIdData = {
    /**
     * will be used to update a specific category
     */
    body: NewsCategoryActionPatch;
    path: {
        contextID: number;
        /**
         * will be used to update a specific category
         */
        id: number;
    };
    query?: never;
    url: '/domain/{contextID}/news-category/{id}';
};

export type patchNewsCategoryByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type patchNewsCategoryByDomainIdError = patchNewsCategoryByDomainIdErrors[keyof patchNewsCategoryByDomainIdErrors];

export type PatchNewsCategoryByDomainIdResponses = {
    /**
     * Success
     */
    200: NewsCategory;
};

export type PatchNewsCategoryByDomainIdResponse = PatchNewsCategoryByDomainIdResponses[keyof PatchNewsCategoryByDomainIdResponses];

export type ListNewsByDomainIdData = {
    body?: never;
    path: {
        /**
         * will filter items by contextID
         */
        contextID: number;
    };
    query?: {
        scope?: Scope;
        /**
         * will filter items by tagID
         */
        tagID?: number;
        /**
         * will filter items by optaMatchID
         */
        optaMatchID?: string;
        /**
         * will filter items by userID
         */
        userID?: number;
        /**
         * will filter items by authorUserID
         */
        authorUserID?: number;
        newsStatus?: NewsStatus;
        search?: string;
        isMedia?: boolean;
        vendor?: VideofeedVendor;
        newsCatID?: number;
        /**
         * will filter items by newsCat.functionality
         */
        functionality?: string;
        /**
         * will remove items by newsCat.functionality
         */
        excludedFunctionality?: Array<string>;
        title?: string;
        year?: number;
        month?: number;
        /**
         * current page
         */
        page?: number;
        /**
         * amount of items per page
         */
        perPage?: number;
        /**
         * Do not count the total number of items. Only check if there is a next page.
         */
        checkNextPage?: boolean;
        /**
         * Return only news articles that should be part of the news list
         */
        showOnlyHomepageItems?: boolean;
        /**
         * Exclude detailed fields that are not commonly used in lists like (e.g. newsText)
         */
        isCompactMode?: boolean;
        /**
         * Return authors for the requested news articles
         */
        includeAuthors?: boolean;
        /**
         * Return all tags for the requested news articles
         */
        includeTags?: boolean;
        /**
         * Return all binary poll info for the requested news articles
         */
        includeBinaryPolls?: boolean;
        experimentGroup?: ExperimentGroupOrRobots;
        /**
         * Array of news IDs to filter by
         */
        newsIDs?: Array<number>;
        /**
         * Return news articles older than 2 years
         */
        includeArchive?: boolean;
        cache?: boolean;
    };
    url: '/domain/{contextID}/news';
};

export type ListNewsByDomainIdResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<News>;
    };
};

export type ListNewsByDomainIdResponse = ListNewsByDomainIdResponses[keyof ListNewsByDomainIdResponses];

export type CreateNewsByDomainIdData = {
    body: NewsItemActionCreate;
    path: {
        /**
         * will be used to set the contextID of a newly created news article
         */
        contextID: number;
    };
    query?: never;
    url: '/domain/{contextID}/news';
};

export type createNewsByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createNewsByDomainIdError = createNewsByDomainIdErrors[keyof createNewsByDomainIdErrors];

export type CreateNewsByDomainIdResponses = {
    /**
     * Created
     */
    201: News;
};

export type CreateNewsByDomainIdResponse = CreateNewsByDomainIdResponses[keyof CreateNewsByDomainIdResponses];

export type GetMostCommentedNewsByDomainIdData = {
    body?: never;
    path: {
        /**
         * will filter items by contextID
         */
        contextID: number;
    };
    query?: {
        experimentGroup?: ExperimentGroupOrRobots;
        cache?: boolean;
    };
    url: '/domain/{contextID}/news/most-commented';
};

export type GetMostCommentedNewsByDomainIdResponses = {
    /**
     * Success
     */
    200: Array<News>;
};

export type GetMostCommentedNewsByDomainIdResponse = GetMostCommentedNewsByDomainIdResponses[keyof GetMostCommentedNewsByDomainIdResponses];

export type GetMatchNewsNewsByDomainIdData = {
    body?: never;
    path: {
        /**
         * Filter by contextID.
         */
        contextID: number;
        /**
         * Get news for this optamatch
         */
        id: string;
    };
    query?: {
        cache?: boolean;
    };
    url: '/domain/{contextID}/news/match/{id}';
};

export type GetMatchNewsNewsByDomainIdResponses = {
    /**
     * Success
     */
    200: Array<News>;
};

export type GetMatchNewsNewsByDomainIdResponse = GetMatchNewsNewsByDomainIdResponses[keyof GetMatchNewsNewsByDomainIdResponses];

export type GetMostReadNewsByDomainIdData = {
    body?: never;
    path: {
        /**
         * will filter items by contextID
         */
        contextID: number;
    };
    query?: {
        isMedia?: boolean;
        experimentGroup?: ExperimentGroupOrRobots;
        functionality?: string;
        newsCatID?: number;
        tagID?: number;
        cache?: boolean;
    };
    url: '/domain/{contextID}/news/most-read';
};

export type GetMostReadNewsByDomainIdResponses = {
    /**
     * Success
     */
    200: Array<News>;
};

export type GetMostReadNewsByDomainIdResponse = GetMostReadNewsByDomainIdResponses[keyof GetMostReadNewsByDomainIdResponses];

export type GetMostReadCrossEditionNewsByDomainIdData = {
    body?: never;
    path: {
        /**
         * will filter items by contextID
         */
        contextID: number;
    };
    query?: {
        isMedia?: boolean;
        experimentGroup?: ExperimentGroupOrRobots;
        cache?: boolean;
    };
    url: '/domain/{contextID}/news/most-read/cross-edition';
};

export type GetMostReadCrossEditionNewsByDomainIdResponses = {
    /**
     * Success
     */
    200: Array<News>;
};

export type GetMostReadCrossEditionNewsByDomainIdResponse = GetMostReadCrossEditionNewsByDomainIdResponses[keyof GetMostReadCrossEditionNewsByDomainIdResponses];

export type GetByPathNewsByDomainIdData = {
    body?: never;
    path: {
        /**
         * will filter items by contextID
         */
        contextID: number;
    };
    query: {
        /**
         * Get news item by path
         */
        path: string;
        scope?: Scope;
        experimentGroup?: ExperimentGroupOrRobots;
        /**
         * Preview hash, allows article to be shared before it is published
         */
        hash?: string;
        cache?: boolean;
    };
    url: '/domain/{contextID}/news/path';
};

export type GetByPathNewsByDomainIdResponses = {
    /**
     * Success
     */
    200: News;
};

export type GetByPathNewsByDomainIdResponse = GetByPathNewsByDomainIdResponses[keyof GetByPathNewsByDomainIdResponses];

export type PathHasTagNewsByDomainIdData = {
    body?: never;
    path: {
        /**
         * will filter items by contextID
         */
        contextID: number;
    };
    query: {
        path: string;
        tagID: number;
        cache?: boolean;
    };
    url: '/domain/{contextID}/news/path-has-tag';
};

export type PathHasTagNewsByDomainIdResponses = {
    /**
     * Success
     */
    200: NewsHasTagResult;
};

export type PathHasTagNewsByDomainIdResponse = PathHasTagNewsByDomainIdResponses[keyof PathHasTagNewsByDomainIdResponses];

export type DeleteNewsByDomainIdData = {
    body?: never;
    path: {
        /**
         * will be used to remove an existing news article
         */
        contextID: number;
        /**
         * will be used to remove an existing news article
         */
        id: number;
    };
    query?: never;
    url: '/domain/{contextID}/news/{id}';
};

export type deleteNewsByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteNewsByDomainIdError = deleteNewsByDomainIdErrors[keyof deleteNewsByDomainIdErrors];

export type DeleteNewsByDomainIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteNewsByDomainIdResponse = DeleteNewsByDomainIdResponses[keyof DeleteNewsByDomainIdResponses];

export type GetByIdNewsByDomainIdData = {
    body?: never;
    path: {
        /**
         * will filter items by contextID
         */
        contextID: number;
        /**
         * Get news item by id
         */
        id: number;
    };
    query?: {
        scope?: Scope;
        experimentGroup?: ExperimentGroupOrRobots;
        /**
         * Preview hash, allows article to be shared before it is published
         */
        hash?: string;
        cache?: boolean;
    };
    url: '/domain/{contextID}/news/{id}';
};

export type GetByIdNewsByDomainIdResponses = {
    /**
     * Success
     */
    200: News;
};

export type GetByIdNewsByDomainIdResponse = GetByIdNewsByDomainIdResponses[keyof GetByIdNewsByDomainIdResponses];

export type PatchNewsByDomainIdData = {
    body: NewsItemActionPatch;
    path: {
        contextID: number;
        id: number;
    };
    query?: never;
    url: '/domain/{contextID}/news/{id}';
};

export type patchNewsByDomainIdErrors = {
    /**
     * Bad Request
     */
    400: BadRequest;
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
    /**
     * Not Found
     */
    404: NotFound;
};

export type patchNewsByDomainIdError = patchNewsByDomainIdErrors[keyof patchNewsByDomainIdErrors];

export type PatchNewsByDomainIdResponses = {
    /**
     * Success
     */
    200: News;
};

export type PatchNewsByDomainIdResponse = PatchNewsByDomainIdResponses[keyof PatchNewsByDomainIdResponses];

export type GetByOriginalIdNewsByDomainIdData = {
    body?: never;
    path: {
        /**
         * Filter by contextID.
         */
        contextID: number;
        /**
         * Get news item by original ID.
         */
        originalID: string;
    };
    query?: {
        experimentGroup?: ExperimentGroupOrRobots;
        cache?: boolean;
    };
    url: '/domain/{contextID}/news/original/{originalID}';
};

export type GetByOriginalIdNewsByDomainIdResponses = {
    /**
     * Success
     */
    200: News;
};

export type GetByOriginalIdNewsByDomainIdResponse = GetByOriginalIdNewsByDomainIdResponses[keyof GetByOriginalIdNewsByDomainIdResponses];

export type GetBySlugNewsByDomainIdData = {
    body?: never;
    path: {
        /**
         * Filter by contextID.
         */
        contextID: number;
        /**
         * Get news item by slug
         */
        slug: string;
    };
    query?: {
        experimentGroup?: ExperimentGroupOrRobots;
        cache?: boolean;
    };
    url: '/domain/{contextID}/news/slug/{slug}';
};

export type GetBySlugNewsByDomainIdResponses = {
    /**
     * Success
     */
    200: News;
};

export type GetBySlugNewsByDomainIdResponse = GetBySlugNewsByDomainIdResponses[keyof GetBySlugNewsByDomainIdResponses];

export type GetNewsByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
    };
    query?: never;
    url: '/domain/{contextID}/newsimageSize';
};

export type GetNewsByDomainIdResponses = {
    /**
     * Success
     */
    200: Image;
};

export type GetNewsByDomainIdResponse = GetNewsByDomainIdResponses[keyof GetNewsByDomainIdResponses];

export type IncreaseVisitCountNewsByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
        newsID: number;
    };
    query?: {
        /**
         * Increase the visit count for the experiment.
         */
        experimentGroup?: ExperimentGroup;
    };
    url: '/domain/{contextID}/news/{newsID}/visit';
};

export type IncreaseVisitCountNewsByDomainIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type IncreaseVisitCountNewsByDomainIdResponse = IncreaseVisitCountNewsByDomainIdResponses[keyof IncreaseVisitCountNewsByDomainIdResponses];

export type LinkCleanupNewsByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
    };
    query?: {
        dryRun?: boolean;
        enforceHttps?: boolean;
        normalizeInternalLinks?: boolean;
    };
    url: '/domain/{contextID}/news/link-cleanup';
};

export type linkCleanupNewsByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type linkCleanupNewsByDomainIdError = linkCleanupNewsByDomainIdErrors[keyof linkCleanupNewsByDomainIdErrors];

export type LinkCleanupNewsByDomainIdResponses = {
    /**
     * Success
     */
    200: LinkCleanupResult;
};

export type LinkCleanupNewsByDomainIdResponse = LinkCleanupNewsByDomainIdResponses[keyof LinkCleanupNewsByDomainIdResponses];

export type SendPushNotificationsNewsByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
    };
    query?: never;
    url: '/domain/{contextID}/news/send-push-notifications';
};

export type sendPushNotificationsNewsByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
    /**
     * Too Many Requests
     */
    429: TooManyRequests;
};

export type sendPushNotificationsNewsByDomainIdError = sendPushNotificationsNewsByDomainIdErrors[keyof sendPushNotificationsNewsByDomainIdErrors];

export type SendPushNotificationsNewsByDomainIdResponses = {
    /**
     * Success
     */
    200: SendNewsPushNotificationsResult;
};

export type SendPushNotificationsNewsByDomainIdResponse = SendPushNotificationsNewsByDomainIdResponses[keyof SendPushNotificationsNewsByDomainIdResponses];

export type GenerateShortAndSearchableNewsByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
    };
    query?: {
        /**
         * the number of articles to be processed
         */
        amount?: number;
    };
    url: '/domain/{contextID}/news/generate-short-and-searchable';
};

export type generateShortAndSearchableNewsByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
    /**
     * Too Many Requests
     */
    429: TooManyRequests;
};

export type generateShortAndSearchableNewsByDomainIdError = generateShortAndSearchableNewsByDomainIdErrors[keyof generateShortAndSearchableNewsByDomainIdErrors];

export type GenerateShortAndSearchableNewsByDomainIdResponses = {
    /**
     * Success
     */
    200: SearchableCronResult;
};

export type GenerateShortAndSearchableNewsByDomainIdResponse = GenerateShortAndSearchableNewsByDomainIdResponses[keyof GenerateShortAndSearchableNewsByDomainIdResponses];

export type DeleteNewsMarketingBlockByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
    };
    query?: never;
    url: '/domain/{contextID}/news-marketing-block';
};

export type deleteNewsMarketingBlockByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteNewsMarketingBlockByDomainIdError = deleteNewsMarketingBlockByDomainIdErrors[keyof deleteNewsMarketingBlockByDomainIdErrors];

export type DeleteNewsMarketingBlockByDomainIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteNewsMarketingBlockByDomainIdResponse = DeleteNewsMarketingBlockByDomainIdResponses[keyof DeleteNewsMarketingBlockByDomainIdResponses];

export type GetNewsMarketingBlockByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
    };
    query?: {
        scope?: Scope;
        cache?: boolean;
    };
    url: '/domain/{contextID}/news-marketing-block';
};

export type GetNewsMarketingBlockByDomainIdResponses = {
    /**
     * Success
     */
    200: NewsMarketingBlock;
};

export type GetNewsMarketingBlockByDomainIdResponse = GetNewsMarketingBlockByDomainIdResponses[keyof GetNewsMarketingBlockByDomainIdResponses];

export type PatchNewsMarketingBlockByDomainIdData = {
    body: NewsMarketingBlock;
    path: {
        contextID: number;
    };
    query?: never;
    url: '/domain/{contextID}/news-marketing-block';
};

export type patchNewsMarketingBlockByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type patchNewsMarketingBlockByDomainIdError = patchNewsMarketingBlockByDomainIdErrors[keyof patchNewsMarketingBlockByDomainIdErrors];

export type PatchNewsMarketingBlockByDomainIdResponses = {
    /**
     * Success
     */
    200: NewsMarketingBlock;
};

export type PatchNewsMarketingBlockByDomainIdResponse = PatchNewsMarketingBlockByDomainIdResponses[keyof PatchNewsMarketingBlockByDomainIdResponses];

export type CreateNewsMarketingBlockByDomainIdData = {
    body: NewsMarketingBlock;
    path: {
        contextID: number;
    };
    query?: never;
    url: '/domain/{contextID}/news-marketing-block';
};

export type createNewsMarketingBlockByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createNewsMarketingBlockByDomainIdError = createNewsMarketingBlockByDomainIdErrors[keyof createNewsMarketingBlockByDomainIdErrors];

export type CreateNewsMarketingBlockByDomainIdResponses = {
    /**
     * Created
     */
    201: NewsMarketingBlock;
};

export type CreateNewsMarketingBlockByDomainIdResponse = CreateNewsMarketingBlockByDomainIdResponses[keyof CreateNewsMarketingBlockByDomainIdResponses];

export type ListNotificationBarByDomainIdData = {
    body?: never;
    path: {
        /**
         * will return items with contextID null or the current contextID
         */
        contextID: number;
    };
    query?: {
        scope?: Scope;
        /**
         * Order items by priority or startTime.
         */
        orderBy?: Array<NotificationBarOrderByOption>;
        active?: boolean;
        /**
         * current page
         */
        page?: number;
        /**
         * amount of items per page
         */
        perPage?: number;
        cache?: boolean;
    };
    url: '/domain/{contextID}/notification-bar';
};

export type ListNotificationBarByDomainIdResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<NotificationBar>;
    };
};

export type ListNotificationBarByDomainIdResponse = ListNotificationBarByDomainIdResponses[keyof ListNotificationBarByDomainIdResponses];

export type CreateNotificationBarByDomainIdData = {
    body: NotificationBarActionCreateActionCreate;
    path: {
        /**
         * will be used to set the contextID of a newly created notification bar
         */
        contextID: number;
    };
    query?: never;
    url: '/domain/{contextID}/notification-bar';
};

export type createNotificationBarByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createNotificationBarByDomainIdError = createNotificationBarByDomainIdErrors[keyof createNotificationBarByDomainIdErrors];

export type CreateNotificationBarByDomainIdResponses = {
    /**
     * Created
     */
    201: NotificationBar;
};

export type CreateNotificationBarByDomainIdResponse = CreateNotificationBarByDomainIdResponses[keyof CreateNotificationBarByDomainIdResponses];

export type DeleteNotificationBarByDomainIdData = {
    body?: never;
    path: {
        /**
         * will be used to remove an existing notification bar item
         */
        contextID: number;
        /**
         * will be used to remove an existing notification bar item
         */
        id: number;
    };
    query?: never;
    url: '/domain/{contextID}/notification-bar/{id}';
};

export type deleteNotificationBarByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteNotificationBarByDomainIdError = deleteNotificationBarByDomainIdErrors[keyof deleteNotificationBarByDomainIdErrors];

export type DeleteNotificationBarByDomainIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteNotificationBarByDomainIdResponse = DeleteNotificationBarByDomainIdResponses[keyof DeleteNotificationBarByDomainIdResponses];

export type PatchNotificationBarByDomainIdData = {
    body: NotificationBarActionPatch;
    path: {
        /**
         * will be used to update a specific notification bar item
         */
        contextID: number;
        /**
         * will be used to update a specific notification bar item
         */
        id: number;
    };
    query?: never;
    url: '/domain/{contextID}/notification-bar/{id}';
};

export type patchNotificationBarByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type patchNotificationBarByDomainIdError = patchNotificationBarByDomainIdErrors[keyof patchNotificationBarByDomainIdErrors];

export type PatchNotificationBarByDomainIdResponses = {
    /**
     * Success
     */
    200: NotificationBar;
};

export type PatchNotificationBarByDomainIdResponse = PatchNotificationBarByDomainIdResponses[keyof PatchNotificationBarByDomainIdResponses];

export type ListNotificationByDomainIdData = {
    body?: never;
    path: {
        /**
         * will return items with contextID null or the current contextID
         */
        contextID: number;
    };
    query?: {
        /**
         * current page
         */
        page?: number;
        /**
         * amount of items per page
         */
        perPage?: number;
    };
    url: '/domain/{contextID}/notification';
};

export type listNotificationByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type listNotificationByDomainIdError = listNotificationByDomainIdErrors[keyof listNotificationByDomainIdErrors];

export type ListNotificationByDomainIdResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<Notification>;
    };
};

export type ListNotificationByDomainIdResponse = ListNotificationByDomainIdResponses[keyof ListNotificationByDomainIdResponses];

export type MarkAllAsReadNotificationByDomainIdData = {
    body?: never;
    path: {
        /**
         * will return items with contextID null or the current contextID
         */
        contextID: number;
    };
    query?: never;
    url: '/domain/{contextID}/notification/mark-as-read';
};

export type markAllAsReadNotificationByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type markAllAsReadNotificationByDomainIdError = markAllAsReadNotificationByDomainIdErrors[keyof markAllAsReadNotificationByDomainIdErrors];

export type MarkAllAsReadNotificationByDomainIdResponses = {
    /**
     * Success
     */
    200: string;
};

export type MarkAllAsReadNotificationByDomainIdResponse = MarkAllAsReadNotificationByDomainIdResponses[keyof MarkAllAsReadNotificationByDomainIdResponses];

export type MarkAsReadNotificationByDomainIdData = {
    body?: never;
    path: {
        /**
         * will return items with contextID null or the current contextID
         */
        contextID: number;
        /**
         * ID of the notification
         */
        id: number;
    };
    query?: never;
    url: '/domain/{contextID}/notification/{id}/mark-as-read';
};

export type markAsReadNotificationByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type markAsReadNotificationByDomainIdError = markAsReadNotificationByDomainIdErrors[keyof markAsReadNotificationByDomainIdErrors];

export type MarkAsReadNotificationByDomainIdResponses = {
    /**
     * Success
     */
    200: Notification;
};

export type MarkAsReadNotificationByDomainIdResponse = MarkAsReadNotificationByDomainIdResponses[keyof MarkAsReadNotificationByDomainIdResponses];

export type MarkSelectedAsReadNotificationByDomainIdData = {
    body: NotificationUpdateList;
    path: {
        /**
         * will return items with contextID null or the current contextID
         */
        contextID: number;
    };
    query?: never;
    url: '/domain/{contextID}/notification/mark-selected-as-read';
};

export type markSelectedAsReadNotificationByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type markSelectedAsReadNotificationByDomainIdError = markSelectedAsReadNotificationByDomainIdErrors[keyof markSelectedAsReadNotificationByDomainIdErrors];

export type MarkSelectedAsReadNotificationByDomainIdResponses = {
    /**
     * Success
     */
    200: NotificationUpdateListResponse;
};

export type MarkSelectedAsReadNotificationByDomainIdResponse = MarkSelectedAsReadNotificationByDomainIdResponses[keyof MarkSelectedAsReadNotificationByDomainIdResponses];

export type GetUnreadNotificationsCountNotificationByDomainIdData = {
    body?: never;
    path: {
        /**
         * will return items with contextID null or the current contextID
         */
        contextID: number;
    };
    query?: never;
    url: '/domain/{contextID}/notification/unread-count';
};

export type getUnreadNotificationsCountNotificationByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getUnreadNotificationsCountNotificationByDomainIdError = getUnreadNotificationsCountNotificationByDomainIdErrors[keyof getUnreadNotificationsCountNotificationByDomainIdErrors];

export type GetUnreadNotificationsCountNotificationByDomainIdResponses = {
    /**
     * Success
     */
    200: NotificationCountContainer;
};

export type GetUnreadNotificationsCountNotificationByDomainIdResponse = GetUnreadNotificationsCountNotificationByDomainIdResponses[keyof GetUnreadNotificationsCountNotificationByDomainIdResponses];

export type DeletePollByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
        /**
         * will be used to remove an existing PollQuestion item
         */
        id: number;
    };
    query?: never;
    url: '/domain/{contextID}/poll/{id}';
};

export type deletePollByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deletePollByDomainIdError = deletePollByDomainIdErrors[keyof deletePollByDomainIdErrors];

export type DeletePollByDomainIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeletePollByDomainIdResponse = DeletePollByDomainIdResponses[keyof DeletePollByDomainIdResponses];

export type GetPollByIdPollByDomainIdData = {
    body?: never;
    path: {
        /**
         * will filter items by contextID
         */
        contextID: number;
        /**
         * will filter items by pollID
         */
        id: number;
    };
    query?: {
        includeAnswers?: boolean;
        cache?: boolean;
    };
    url: '/domain/{contextID}/poll/{id}';
};

export type GetPollByIdPollByDomainIdResponses = {
    /**
     * Success
     */
    200: Poll;
};

export type GetPollByIdPollByDomainIdResponse = GetPollByIdPollByDomainIdResponses[keyof GetPollByIdPollByDomainIdResponses];

export type PatchPollByDomainIdData = {
    body: PollActionPatch;
    path: {
        /**
         * will filter items by contextID
         */
        contextID: number;
        id: number;
    };
    query?: never;
    url: '/domain/{contextID}/poll/{id}';
};

export type patchPollByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type patchPollByDomainIdError = patchPollByDomainIdErrors[keyof patchPollByDomainIdErrors];

export type PatchPollByDomainIdResponses = {
    /**
     * Success
     */
    200: Poll;
};

export type PatchPollByDomainIdResponse = PatchPollByDomainIdResponses[keyof PatchPollByDomainIdResponses];

export type ListPollByDomainIdData = {
    body?: never;
    path: {
        /**
         * will filter items by contextID
         */
        contextID: number;
    };
    query?: {
        /**
         * will fuzzy search in the pollQuestion column
         */
        search?: string;
        /**
         * will filter items by newsID
         */
        newsID?: number;
        /**
         * will filter items by matchID
         */
        matchID?: string;
        includeAnswers?: boolean;
        page?: number;
        perPage?: number;
        cache?: boolean;
    };
    url: '/domain/{contextID}/poll';
};

export type ListPollByDomainIdResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<Poll>;
    };
};

export type ListPollByDomainIdResponse = ListPollByDomainIdResponses[keyof ListPollByDomainIdResponses];

export type CreatePollByDomainIdData = {
    body: PollActionCreate;
    path: {
        /**
         * will filter items by contextID
         */
        contextID: number;
    };
    query?: never;
    url: '/domain/{contextID}/poll';
};

export type createPollByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createPollByDomainIdError = createPollByDomainIdErrors[keyof createPollByDomainIdErrors];

export type CreatePollByDomainIdResponses = {
    /**
     * Created
     */
    201: Poll;
};

export type CreatePollByDomainIdResponse = CreatePollByDomainIdResponses[keyof CreatePollByDomainIdResponses];

export type VotePollByDomainIdData = {
    body?: never;
    path: {
        /**
         * will filter items by contextID
         */
        contextID: number;
        pollID: number;
        answerID: number;
    };
    query?: never;
    url: '/domain/{contextID}/poll/{pollID}/answer/{answerID}/vote';
};

export type votePollByDomainIdErrors = {
    /**
     * Bad Request
     */
    400: BadRequest;
    /**
     * Not Found
     */
    404: NotFound;
    /**
     * Conflict
     */
    409: Conflict;
};

export type votePollByDomainIdError = votePollByDomainIdErrors[keyof votePollByDomainIdErrors];

export type VotePollByDomainIdResponses = {
    /**
     * Success
     */
    200: boolean;
};

export type VotePollByDomainIdResponse = VotePollByDomainIdResponses[keyof VotePollByDomainIdResponses];

export type GetVotedAnswerIdPollByDomainIdData = {
    body?: never;
    path: {
        /**
         * will filter items by contextID
         */
        contextID: number;
        pollID: number;
    };
    query?: never;
    url: '/domain/{contextID}/poll/{pollID}/voted-answer';
};

export type GetVotedAnswerIdPollByDomainIdResponses = {
    /**
     * Success
     */
    200: PollAnswer;
};

export type GetVotedAnswerIdPollByDomainIdResponse = GetVotedAnswerIdPollByDomainIdResponses[keyof GetVotedAnswerIdPollByDomainIdResponses];

export type GetUserAccuracyPollByDomainIdData = {
    body?: never;
    path: {
        /**
         * will filter items by contextID
         */
        contextID: number;
        userID: number;
    };
    query?: {
        cache?: boolean;
    };
    url: '/domain/{contextID}/poll/user/{userID}/accuracy';
};

export type GetUserAccuracyPollByDomainIdResponses = {
    /**
     * Success
     */
    200: UserAccuracy;
};

export type GetUserAccuracyPollByDomainIdResponse = GetUserAccuracyPollByDomainIdResponses[keyof GetUserAccuracyPollByDomainIdResponses];

export type GetUserScorePollByDomainIdData = {
    body?: never;
    path: {
        /**
         * will filter items by contextID
         */
        contextID: number;
        userID: number;
    };
    query?: {
        cache?: boolean;
    };
    url: '/domain/{contextID}/poll/user/{userID}/score';
};

export type getUserScorePollByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getUserScorePollByDomainIdError = getUserScorePollByDomainIdErrors[keyof getUserScorePollByDomainIdErrors];

export type GetUserScorePollByDomainIdResponses = {
    /**
     * Success
     */
    200: UserScore;
};

export type GetUserScorePollByDomainIdResponse = GetUserScorePollByDomainIdResponses[keyof GetUserScorePollByDomainIdResponses];

export type NavigationSitemapByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
    };
    query?: {
        cache?: boolean;
    };
    url: '/domain/{contextID}/sitemap/navigation';
};

export type NavigationSitemapByDomainIdResponses = {
    /**
     * Success
     */
    200: Array<SitemapEntry>;
};

export type NavigationSitemapByDomainIdResponse = NavigationSitemapByDomainIdResponses[keyof NavigationSitemapByDomainIdResponses];

export type IndexSitemapByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
    };
    query?: {
        cache?: boolean;
    };
    url: '/domain/{contextID}/sitemap/index';
};

export type IndexSitemapByDomainIdResponses = {
    /**
     * Success
     */
    200: Array<SitemapIndexEntry>;
};

export type IndexSitemapByDomainIdResponse = IndexSitemapByDomainIdResponses[keyof IndexSitemapByDomainIdResponses];

export type NewsSitemapByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
    };
    query: {
        year: number;
        week?: number;
        quarter?: number;
        cache?: boolean;
    };
    url: '/domain/{contextID}/sitemap/news';
};

export type NewsSitemapByDomainIdResponses = {
    /**
     * Success
     */
    200: Array<SitemapEntry>;
};

export type NewsSitemapByDomainIdResponse = NewsSitemapByDomainIdResponses[keyof NewsSitemapByDomainIdResponses];

export type TagsSitemapByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
    };
    query: {
        tagType: string;
        from?: number;
        to?: number;
        cache?: boolean;
    };
    url: '/domain/{contextID}/sitemap/tag';
};

export type TagsSitemapByDomainIdResponses = {
    /**
     * Success
     */
    200: Array<SitemapEntry>;
};

export type TagsSitemapByDomainIdResponse = TagsSitemapByDomainIdResponses[keyof TagsSitemapByDomainIdResponses];

export type GoogleNewsSitemapByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
    };
    query?: {
        cache?: boolean;
    };
    url: '/domain/{contextID}/sitemap/google';
};

export type GoogleNewsSitemapByDomainIdResponses = {
    /**
     * Success
     */
    200: Array<SitemapGoogleEntry>;
};

export type GoogleNewsSitemapByDomainIdResponse = GoogleNewsSitemapByDomainIdResponses[keyof GoogleNewsSitemapByDomainIdResponses];

export type AuthorPagesSitemapByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
    };
    query?: {
        cache?: boolean;
    };
    url: '/domain/{contextID}/sitemap/authors';
};

export type AuthorPagesSitemapByDomainIdResponses = {
    /**
     * Success
     */
    200: Array<SitemapEntry>;
};

export type AuthorPagesSitemapByDomainIdResponse = AuthorPagesSitemapByDomainIdResponses[keyof AuthorPagesSitemapByDomainIdResponses];

export type MatchesSitemapByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
    };
    query?: {
        cache?: boolean;
    };
    url: '/domain/{contextID}/sitemap/matches';
};

export type MatchesSitemapByDomainIdResponses = {
    /**
     * Success
     */
    200: Array<SitemapEntry>;
};

export type MatchesSitemapByDomainIdResponse = MatchesSitemapByDomainIdResponses[keyof MatchesSitemapByDomainIdResponses];

export type ListTagByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
    };
    query?: {
        /**
         * Filter by the name of the tag
         */
        title?: string;
        /**
         * Filter tags by multiple optaIDs. Sorting the IDs and filtering duplicates will likely improve cache hit ratio and thus performance.
         */
        optaIDs?: Array<string>;
        /**
         * Do not include large properties like tagDescription and tagOutro
         */
        isCompactMode?: boolean;
        /**
         * Do not count the total number of items. Only check if there is a next page.
         */
        checkNextPage?: boolean;
        /**
         * Filter by the type of the tag. If scope='public' (the default value) and tagType='competition'|'competition_tournament', the tags with tagType='competition' and the tags with tagType='competition_tournament' will be returned.
         */
        tagType?: TagTypeAsString;
        /**
         * Use 'tagType' instead. Filter by the tag type id of the tag. If scope='public' (the default value) and tagTypeID=1|4, the tags with tagTypeID=1 and the tags with tagTypeID=4 will be returned.
         *
         * @deprecated
         */
        tagTypeID?: number;
        /**
         * Filter by if the tag is trending
         */
        isTrending?: boolean;
        /**
         * Filter by if the tag is a overview
         */
        showOverview?: boolean;
        /**
         * Show hidden tags
         */
        showHidden?: boolean;
        /**
         * Filter by if the tag is shown on Rss page
         */
        showOnRssIndex?: boolean;
        /**
         * Filter by if the tag has playerRatings
         */
        hasPlayerRatings?: boolean;
        /**
         * Filter by parent tag ID
         */
        parentTagID?: number;
        /**
         * Filter by child tag ID
         */
        childTagID?: number;
        /**
         * will return items ordered by a given column
         */
        orderBy?: string;
        /**
         * order results in either ascending or descending order
         */
        order?: Order;
        scope?: Scope;
        /**
         * Filter by isTopLevel tags
         */
        isTopLevel?: boolean;
        page?: number;
        perPage?: number;
        cache?: boolean;
    };
    url: '/domain/{contextID}/tag';
};

export type ListTagByDomainIdResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<Tag>;
    };
};

export type ListTagByDomainIdResponse = ListTagByDomainIdResponses[keyof ListTagByDomainIdResponses];

export type MergeTagByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
    };
    query?: {
        oldTagID?: number;
        targetTagID?: number;
        dryRun?: boolean;
    };
    url: '/domain/{contextID}/tag/merge';
};

export type mergeTagByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type mergeTagByDomainIdError = mergeTagByDomainIdErrors[keyof mergeTagByDomainIdErrors];

export type MergeTagByDomainIdResponses = {
    /**
     * Success
     */
    200: TagMergeResult;
};

export type MergeTagByDomainIdResponse = MergeTagByDomainIdResponses[keyof MergeTagByDomainIdResponses];

export type GetTagTypesTagByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
    };
    query?: {
        cache?: boolean;
    };
    url: '/domain/{contextID}/tag/types';
};

export type GetTagTypesTagByDomainIdResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<TagType>;
    };
};

export type GetTagTypesTagByDomainIdResponse = GetTagTypesTagByDomainIdResponses[keyof GetTagTypesTagByDomainIdResponses];

export type GetBySlugTagByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
        /**
         * Get tag by slug or ID
         */
        slugOrID: string;
    };
    query?: {
        /**
         * Filter by the type of the tag. If tagType='competition'|'competition_tournament', the tags with tagType='competition' and the tags with tagType='competition_tournament' will be returned.
         */
        tagType?: TagTypeAsString;
        cache?: boolean;
    };
    url: '/domain/{contextID}/tag/{slugOrID}';
};

export type GetBySlugTagByDomainIdResponses = {
    /**
     * Success
     */
    200: Tag;
};

export type GetBySlugTagByDomainIdResponse = GetBySlugTagByDomainIdResponses[keyof GetBySlugTagByDomainIdResponses];

export type DeleteTagByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
        /**
         * will be used to remove an existing tag item
         */
        tagID: number;
    };
    query?: never;
    url: '/domain/{contextID}/tag/{tagID}';
};

export type deleteTagByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteTagByDomainIdError = deleteTagByDomainIdErrors[keyof deleteTagByDomainIdErrors];

export type DeleteTagByDomainIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteTagByDomainIdResponse = DeleteTagByDomainIdResponses[keyof DeleteTagByDomainIdResponses];

export type GetVideofeedConfigByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
    };
    query?: {
        client?: VideofeedConfigClient;
        feedType?: VideofeedType;
        cache?: boolean;
    };
    url: '/domain/{contextID}/videofeed-config';
};

export type GetVideofeedConfigByDomainIdResponses = {
    /**
     * Success
     */
    200: VideofeedConfig;
};

export type GetVideofeedConfigByDomainIdResponse = GetVideofeedConfigByDomainIdResponses[keyof GetVideofeedConfigByDomainIdResponses];

export type UpsertVideofeedConfigByDomainIdData = {
    body: VideofeedConfig;
    path: {
        contextID: number;
    };
    query?: {
        client?: VideofeedConfigClient;
        feedType?: VideofeedType;
    };
    url: '/domain/{contextID}/videofeed-config';
};

export type upsertVideofeedConfigByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type upsertVideofeedConfigByDomainIdError = upsertVideofeedConfigByDomainIdErrors[keyof upsertVideofeedConfigByDomainIdErrors];

export type UpsertVideofeedConfigByDomainIdResponses = {
    /**
     * Success
     */
    200: VideofeedConfig;
    /**
     * Created
     */
    201: VideofeedConfig;
};

export type UpsertVideofeedConfigByDomainIdResponse = UpsertVideofeedConfigByDomainIdResponses[keyof UpsertVideofeedConfigByDomainIdResponses];

export type ListVideofeedByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
    };
    query?: {
        scope?: Scope;
        status?: VideofeedStatus;
        search?: string;
        orderBy?: VideofeedOrderBy;
        order?: Order;
        feedType?: VideofeedType;
        page?: number;
        perPage?: number;
        cache?: boolean;
    };
    url: '/domain/{contextID}/videofeed';
};

export type ListVideofeedByDomainIdResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<VideofeedItem>;
    };
};

export type ListVideofeedByDomainIdResponse = ListVideofeedByDomainIdResponses[keyof ListVideofeedByDomainIdResponses];

export type CreateVideofeedByDomainIdData = {
    body: VideofeedItemActionCreate;
    path: {
        contextID: number;
    };
    query?: never;
    url: '/domain/{contextID}/videofeed';
};

export type createVideofeedByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createVideofeedByDomainIdError = createVideofeedByDomainIdErrors[keyof createVideofeedByDomainIdErrors];

export type CreateVideofeedByDomainIdResponses = {
    /**
     * Created
     */
    201: VideofeedItemActionCreateResponseScopeAdmin;
};

export type CreateVideofeedByDomainIdResponse = CreateVideofeedByDomainIdResponses[keyof CreateVideofeedByDomainIdResponses];

export type PatchVideofeedByDomainIdData = {
    body: VideofeedItemActionPatch;
    path: {
        contextID: number;
        videofeedID: number;
    };
    query?: never;
    url: '/domain/{contextID}/videofeed/{videofeedID}';
};

export type patchVideofeedByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type patchVideofeedByDomainIdError = patchVideofeedByDomainIdErrors[keyof patchVideofeedByDomainIdErrors];

export type PatchVideofeedByDomainIdResponses = {
    /**
     * Success
     */
    200: VideofeedItemActionUpdateResponseScopeAdmin;
};

export type PatchVideofeedByDomainIdResponse = PatchVideofeedByDomainIdResponses[keyof PatchVideofeedByDomainIdResponses];

export type SyncDisassociateUserData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/disassociate-user/disassociate';
};

export type syncDisassociateUserErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type syncDisassociateUserError = syncDisassociateUserErrors[keyof syncDisassociateUserErrors];

export type SyncDisassociateUserResponses = {
    /**
     * Success
     */
    200: {
        [key: string]: unknown;
    };
};

export type SyncDisassociateUserResponse = SyncDisassociateUserResponses[keyof SyncDisassociateUserResponses];

export type SendContactFormContactFormData = {
    body: ContactForm;
    path: {
        editionID: number;
    };
    query: {
        client: Client;
    };
    url: '/edition/{editionID}/contact-form';
};

export type SendContactFormContactFormResponses = {
    /**
     * No Content
     */
    204: void;
};

export type SendContactFormContactFormResponse = SendContactFormContactFormResponses[keyof SendContactFormContactFormResponses];

export type GetDepartmentsByEditionContactFormData = {
    body?: never;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/contact-form/departments-by-edition';
};

export type getDepartmentsByEditionContactFormErrors = {
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getDepartmentsByEditionContactFormError = getDepartmentsByEditionContactFormErrors[keyof getDepartmentsByEditionContactFormErrors];

export type GetDepartmentsByEditionContactFormResponses = {
    /**
     * Success
     */
    200: DepartmentsByEdition;
};

export type GetDepartmentsByEditionContactFormResponse = GetDepartmentsByEditionContactFormResponses[keyof GetDepartmentsByEditionContactFormResponses];

export type DeleteCurationData = {
    body?: never;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/curation';
};

export type deleteCurationErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteCurationError = deleteCurationErrors[keyof deleteCurationErrors];

export type DeleteCurationResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteCurationResponse = DeleteCurationResponses[keyof DeleteCurationResponses];

export type GetCurationData = {
    body?: never;
    path: {
        editionID: number;
    };
    query?: {
        scope?: Scope;
        sections?: boolean;
        cache?: boolean;
    };
    url: '/edition/{editionID}/curation';
};

export type GetCurationResponses = {
    /**
     * Success
     */
    200: Curation;
};

export type GetCurationResponse = GetCurationResponses[keyof GetCurationResponses];

export type UpdateCurationData = {
    /**
     * Will be used to update curated news
     */
    body: CurationPatchActionUpdate;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/curation';
};

export type updateCurationErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type updateCurationError = updateCurationErrors[keyof updateCurationErrors];

export type UpdateCurationResponses = {
    /**
     * Success
     */
    200: Curation;
};

export type UpdateCurationResponse = UpdateCurationResponses[keyof UpdateCurationResponses];

export type CreateCurationData = {
    /**
     * Will be used to create a curated news
     */
    body: CurationPatchActionCreate;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/curation';
};

export type createCurationErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createCurationError = createCurationErrors[keyof createCurationErrors];

export type CreateCurationResponses = {
    /**
     * Created
     */
    201: Curation;
};

export type CreateCurationResponse = CreateCurationResponses[keyof CreateCurationResponses];

export type UpdateBulkCurationData = {
    body: CuratedItemBulkBodyActionUpdate;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/curation/bulk';
};

export type updateBulkCurationErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type updateBulkCurationError = updateBulkCurationErrors[keyof updateBulkCurationErrors];

export type UpdateBulkCurationResponses = {
    /**
     * Success
     */
    200: CuratedItemBulkUpdateResponse;
};

export type UpdateBulkCurationResponse = UpdateBulkCurationResponses[keyof UpdateBulkCurationResponses];

export type CreateBulkCurationData = {
    body: CuratedItemBulkBodyActionCreate;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/curation/bulk';
};

export type createBulkCurationErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createBulkCurationError = createBulkCurationErrors[keyof createBulkCurationErrors];

export type CreateBulkCurationResponses = {
    /**
     * Success
     */
    200: CuratedItemBulkUpdateResponse;
};

export type CreateBulkCurationResponse = CreateBulkCurationResponses[keyof CreateBulkCurationResponses];

export type RescheduleCurationData = {
    body?: never;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/curation/reschedule';
};

export type rescheduleCurationErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type rescheduleCurationError = rescheduleCurationErrors[keyof rescheduleCurationErrors];

export type RescheduleCurationResponses = {
    /**
     * Success
     */
    200: CurationScheduleCronResult;
};

export type RescheduleCurationResponse = RescheduleCurationResponses[keyof RescheduleCurationResponses];

export type DeleteCuratedExternalSnippetData = {
    body?: never;
    path: {
        editionID: number;
        id: number;
    };
    query?: never;
    url: '/edition/{editionID}/curation/external-snippet/{id}';
};

export type deleteCuratedExternalSnippetErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteCuratedExternalSnippetError = deleteCuratedExternalSnippetErrors[keyof deleteCuratedExternalSnippetErrors];

export type DeleteCuratedExternalSnippetResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteCuratedExternalSnippetResponse = DeleteCuratedExternalSnippetResponses[keyof DeleteCuratedExternalSnippetResponses];

export type GetCuratedExternalSnippetData = {
    body?: never;
    path: {
        editionID: number;
        id: number;
    };
    query?: {
        cache?: boolean;
    };
    url: '/edition/{editionID}/curation/external-snippet/{id}';
};

export type GetCuratedExternalSnippetResponses = {
    /**
     * Success
     */
    200: CuratedExternalSnippet;
};

export type GetCuratedExternalSnippetResponse = GetCuratedExternalSnippetResponses[keyof GetCuratedExternalSnippetResponses];

export type PatchCuratedExternalSnippetData = {
    body: CuratedExternalSnippetActionUpdate;
    path: {
        editionID: number;
        id: number;
    };
    query?: never;
    url: '/edition/{editionID}/curation/external-snippet/{id}';
};

export type patchCuratedExternalSnippetErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type patchCuratedExternalSnippetError = patchCuratedExternalSnippetErrors[keyof patchCuratedExternalSnippetErrors];

export type PatchCuratedExternalSnippetResponses = {
    /**
     * Success
     */
    200: CuratedExternalSnippet;
};

export type PatchCuratedExternalSnippetResponse = PatchCuratedExternalSnippetResponses[keyof PatchCuratedExternalSnippetResponses];

export type CreateCuratedExternalSnippetData = {
    body: CuratedExternalSnippetActionCreate;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/curation/external-snippet';
};

export type createCuratedExternalSnippetErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createCuratedExternalSnippetError = createCuratedExternalSnippetErrors[keyof createCuratedExternalSnippetErrors];

export type CreateCuratedExternalSnippetResponses = {
    /**
     * Created
     */
    201: CuratedExternalSnippet;
};

export type CreateCuratedExternalSnippetResponse = CreateCuratedExternalSnippetResponses[keyof CreateCuratedExternalSnippetResponses];

export type DeleteCuratedMarketingItemData = {
    body?: never;
    path: {
        editionID: number;
        /**
         * Will be used to delete a curated marketing item
         */
        id: number;
    };
    query?: never;
    url: '/edition/{editionID}/curation/marketing/{id}';
};

export type deleteCuratedMarketingItemErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteCuratedMarketingItemError = deleteCuratedMarketingItemErrors[keyof deleteCuratedMarketingItemErrors];

export type DeleteCuratedMarketingItemResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteCuratedMarketingItemResponse = DeleteCuratedMarketingItemResponses[keyof DeleteCuratedMarketingItemResponses];

export type GetCuratedMarketingItemData = {
    body?: never;
    path: {
        editionID: number;
        id: number;
    };
    query?: {
        cache?: boolean;
    };
    url: '/edition/{editionID}/curation/marketing/{id}';
};

export type GetCuratedMarketingItemResponses = {
    /**
     * Success
     */
    200: CuratedMarketingItem;
};

export type GetCuratedMarketingItemResponse = GetCuratedMarketingItemResponses[keyof GetCuratedMarketingItemResponses];

export type UpdateCuratedMarketingItemData = {
    /**
     * Will be used to update a curated marketing item
     */
    body: CuratedMarketingItemActionUpdate;
    path: {
        editionID: number;
        /**
         * Will be used to update a curated marketing item
         */
        id: number;
    };
    query?: never;
    url: '/edition/{editionID}/curation/marketing/{id}';
};

export type updateCuratedMarketingItemErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type updateCuratedMarketingItemError = updateCuratedMarketingItemErrors[keyof updateCuratedMarketingItemErrors];

export type UpdateCuratedMarketingItemResponses = {
    /**
     * Success
     */
    200: CuratedMarketingItem;
};

export type UpdateCuratedMarketingItemResponse = UpdateCuratedMarketingItemResponses[keyof UpdateCuratedMarketingItemResponses];

export type CreateCuratedMarketingItemData = {
    /**
     * Will be used to create a curated marketing item
     */
    body: CuratedMarketingItemActionCreate;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/curation/marketing';
};

export type createCuratedMarketingItemErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createCuratedMarketingItemError = createCuratedMarketingItemErrors[keyof createCuratedMarketingItemErrors];

export type CreateCuratedMarketingItemResponses = {
    /**
     * Created
     */
    201: CuratedMarketingItem;
};

export type CreateCuratedMarketingItemResponse = CreateCuratedMarketingItemResponses[keyof CreateCuratedMarketingItemResponses];

export type PatchCuratedMatchData = {
    /**
     * Will be used to patch a curated match
     */
    body: CuratedMatchPatchActionUpdate;
    path: {
        editionID: number;
        /**
         * Will be used to patch a curated match
         */
        id: number;
    };
    query?: never;
    url: '/edition/{editionID}/curation/match/{id}';
};

export type patchCuratedMatchErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type patchCuratedMatchError = patchCuratedMatchErrors[keyof patchCuratedMatchErrors];

export type PatchCuratedMatchResponses = {
    /**
     * Success
     */
    200: CuratedMatch;
};

export type PatchCuratedMatchResponse = PatchCuratedMatchResponses[keyof PatchCuratedMatchResponses];

export type DeleteCuratedNewsItemData = {
    body?: never;
    path: {
        editionID: number;
        /**
         * Will be used to delete a curated news item
         */
        id: number;
    };
    query?: never;
    url: '/edition/{editionID}/curation/news/{id}';
};

export type deleteCuratedNewsItemErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteCuratedNewsItemError = deleteCuratedNewsItemErrors[keyof deleteCuratedNewsItemErrors];

export type DeleteCuratedNewsItemResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteCuratedNewsItemResponse = DeleteCuratedNewsItemResponses[keyof DeleteCuratedNewsItemResponses];

export type GetCuratedNewsItemData = {
    body?: never;
    path: {
        editionID: number;
        id: number;
    };
    query?: {
        cache?: boolean;
    };
    url: '/edition/{editionID}/curation/news/{id}';
};

export type GetCuratedNewsItemResponses = {
    /**
     * Success
     */
    200: CuratedNewsItem;
};

export type GetCuratedNewsItemResponse = GetCuratedNewsItemResponses[keyof GetCuratedNewsItemResponses];

export type UpdateCuratedNewsItemData = {
    /**
     * Will be used to update a curated news item
     */
    body: CuratedNewsItemBaseActionUpdate;
    path: {
        editionID: number;
        /**
         * Will be used to update a curated news item
         */
        id: number;
    };
    query?: never;
    url: '/edition/{editionID}/curation/news/{id}';
};

export type updateCuratedNewsItemErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type updateCuratedNewsItemError = updateCuratedNewsItemErrors[keyof updateCuratedNewsItemErrors];

export type UpdateCuratedNewsItemResponses = {
    /**
     * Success
     */
    200: CuratedNewsItem;
};

export type UpdateCuratedNewsItemResponse = UpdateCuratedNewsItemResponses[keyof UpdateCuratedNewsItemResponses];

export type CreateCuratedNewsItemData = {
    /**
     * Will be used to create a curated news item
     */
    body: CuratedNewsItemBaseActionCreate;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/curation/news';
};

export type createCuratedNewsItemErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createCuratedNewsItemError = createCuratedNewsItemErrors[keyof createCuratedNewsItemErrors];

export type CreateCuratedNewsItemResponses = {
    /**
     * Created
     */
    201: CuratedNewsItem;
};

export type CreateCuratedNewsItemResponse = CreateCuratedNewsItemResponses[keyof CreateCuratedNewsItemResponses];

export type XPostEmbedEmbedHtmlData = {
    body?: never;
    path: {
        editionID: number;
    };
    query: {
        /**
         * X Post URL
         */
        postURL: string;
        cache?: boolean;
    };
    url: '/edition/{editionID}/embed-htmlxPost';
};

export type xPostEmbedEmbedHtmlErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type xPostEmbedEmbedHtmlError = xPostEmbedEmbedHtmlErrors[keyof xPostEmbedEmbedHtmlErrors];

export type XPostEmbedEmbedHtmlResponses = {
    /**
     * Success
     */
    200: EmbedHtml;
};

export type XPostEmbedEmbedHtmlResponse = XPostEmbedEmbedHtmlResponses[keyof XPostEmbedEmbedHtmlResponses];

export type LogEventData = {
    body: CapiEvent;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/event/log';
};

export type LogEventResponses = {
    /**
     * No Content
     */
    204: void;
};

export type LogEventResponse = LogEventResponses[keyof LogEventResponses];

export type BatchEventData = {
    body?: never;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/event/batch';
};

export type batchEventErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
    /**
     * Too Many Requests
     */
    429: TooManyRequests;
};

export type batchEventError = batchEventErrors[keyof batchEventErrors];

export type BatchEventResponses = {
    /**
     * Success
     */
    200: CapiBatchResult;
};

export type BatchEventResponse = BatchEventResponses[keyof BatchEventResponses];

export type DeleteTestTokenEventData = {
    body?: never;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/event/test-token';
};

export type deleteTestTokenEventErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteTestTokenEventError = deleteTestTokenEventErrors[keyof deleteTestTokenEventErrors];

export type DeleteTestTokenEventResponses = {
    /**
     * Success
     */
    200: CapiSetTestCodeResult;
};

export type DeleteTestTokenEventResponse = DeleteTestTokenEventResponses[keyof DeleteTestTokenEventResponses];

export type SetTestTokenEventData = {
    body?: never;
    path: {
        editionID: number;
    };
    query?: {
        /**
         * test_event_code from the CAPI Test Events Tool
         */
        code?: string;
    };
    url: '/edition/{editionID}/event/test-token';
};

export type setTestTokenEventErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type setTestTokenEventError = setTestTokenEventErrors[keyof setTestTokenEventErrors];

export type SetTestTokenEventResponses = {
    /**
     * Success
     */
    200: CapiSetTestCodeResult;
};

export type SetTestTokenEventResponse = SetTestTokenEventResponses[keyof SetTestTokenEventResponses];

export type ListFaqCategoryData = {
    body?: never;
    path: {
        editionID: number;
    };
    query?: {
        /**
         * current page
         */
        page?: number;
        /**
         * amount of items per page
         */
        perPage?: number;
        title?: string;
        cache?: boolean;
    };
    url: '/edition/{editionID}/faq-category';
};

export type listFaqCategoryErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type listFaqCategoryError = listFaqCategoryErrors[keyof listFaqCategoryErrors];

export type ListFaqCategoryResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<FaqCategory>;
    };
};

export type ListFaqCategoryResponse = ListFaqCategoryResponses[keyof ListFaqCategoryResponses];

export type CreateFaqCategoryData = {
    body: FaqCategoryActionCreate;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/faq-category';
};

export type createFaqCategoryErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createFaqCategoryError = createFaqCategoryErrors[keyof createFaqCategoryErrors];

export type CreateFaqCategoryResponses = {
    /**
     * Created
     */
    201: FaqCategory;
};

export type CreateFaqCategoryResponse = CreateFaqCategoryResponses[keyof CreateFaqCategoryResponses];

export type DeleteByIdFaqCategoryData = {
    body?: never;
    path: {
        editionID: number;
        faqCategoryID: number;
    };
    query?: never;
    url: '/edition/{editionID}/faq-category/{faqCategoryID}';
};

export type deleteByIdFaqCategoryErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteByIdFaqCategoryError = deleteByIdFaqCategoryErrors[keyof deleteByIdFaqCategoryErrors];

export type DeleteByIdFaqCategoryResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteByIdFaqCategoryResponse = DeleteByIdFaqCategoryResponses[keyof DeleteByIdFaqCategoryResponses];

export type GetByIdFaqCategoryData = {
    body?: never;
    path: {
        editionID: number;
        faqCategoryID: number;
    };
    query?: {
        cache?: boolean;
    };
    url: '/edition/{editionID}/faq-category/{faqCategoryID}';
};

export type getByIdFaqCategoryErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getByIdFaqCategoryError = getByIdFaqCategoryErrors[keyof getByIdFaqCategoryErrors];

export type GetByIdFaqCategoryResponses = {
    /**
     * Success
     */
    200: FaqCategory;
};

export type GetByIdFaqCategoryResponse = GetByIdFaqCategoryResponses[keyof GetByIdFaqCategoryResponses];

export type PatchFaqCategoryData = {
    body: FaqCategoryActionPatch;
    path: {
        editionID: number;
        faqCategoryID: number;
    };
    query?: never;
    url: '/edition/{editionID}/faq-category/{faqCategoryID}';
};

export type patchFaqCategoryErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type patchFaqCategoryError = patchFaqCategoryErrors[keyof patchFaqCategoryErrors];

export type PatchFaqCategoryResponses = {
    /**
     * Created
     */
    201: FaqCategory;
};

export type PatchFaqCategoryResponse = PatchFaqCategoryResponses[keyof PatchFaqCategoryResponses];

export type ListFaqData = {
    body?: never;
    path: {
        editionID: number;
    };
    query?: {
        /**
         * current page
         */
        page?: number;
        /**
         * amount of items per page
         */
        perPage?: number;
        faqCategoryID?: number;
        cache?: boolean;
    };
    url: '/edition/{editionID}/faq';
};

export type ListFaqResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<Faq>;
    };
};

export type ListFaqResponse = ListFaqResponses[keyof ListFaqResponses];

export type CreateFaqData = {
    body: FaqActionCreate;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/faq';
};

export type createFaqErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createFaqError = createFaqErrors[keyof createFaqErrors];

export type CreateFaqResponses = {
    /**
     * Created
     */
    201: Faq;
};

export type CreateFaqResponse = CreateFaqResponses[keyof CreateFaqResponses];

export type DeleteByIdFaqData = {
    body?: never;
    path: {
        editionID: number;
        faqID: number;
    };
    query?: never;
    url: '/edition/{editionID}/faq/{faqID}';
};

export type deleteByIdFaqErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteByIdFaqError = deleteByIdFaqErrors[keyof deleteByIdFaqErrors];

export type DeleteByIdFaqResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteByIdFaqResponse = DeleteByIdFaqResponses[keyof DeleteByIdFaqResponses];

export type GetByIdFaqData = {
    body?: never;
    path: {
        editionID: number;
        faqID: number;
    };
    query?: {
        cache?: boolean;
    };
    url: '/edition/{editionID}/faq/{faqID}';
};

export type getByIdFaqErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getByIdFaqError = getByIdFaqErrors[keyof getByIdFaqErrors];

export type GetByIdFaqResponses = {
    /**
     * Success
     */
    200: Faq;
};

export type GetByIdFaqResponse = GetByIdFaqResponses[keyof GetByIdFaqResponses];

export type PatchFaqData = {
    body: FaqActionPatch;
    path: {
        editionID: number;
        faqID: number;
    };
    query?: never;
    url: '/edition/{editionID}/faq/{faqID}';
};

export type patchFaqErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type patchFaqError = patchFaqErrors[keyof patchFaqErrors];

export type PatchFaqResponses = {
    /**
     * Created
     */
    201: Faq;
};

export type PatchFaqResponse = PatchFaqResponses[keyof PatchFaqResponses];

export type ListFeatureFlagData = {
    body?: never;
    path: {
        /**
         * scope items by editionID
         */
        editionID: number;
    };
    query?: {
        /**
         * current page
         */
        page?: number;
        /**
         * amount of items per page
         */
        perPage?: number;
        cache?: boolean;
    };
    url: '/edition/{editionID}/featureFlag';
};

export type ListFeatureFlagResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<FeatureFlag>;
    };
};

export type ListFeatureFlagResponse = ListFeatureFlagResponses[keyof ListFeatureFlagResponses];

export type ImportHearstArticlesHearstMigrationData = {
    body: {
        hearstArticlesXml: Blob | File;
    };
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/hearst-migration/import';
};

export type importHearstArticlesHearstMigrationErrors = {
    /**
     * <File too long | Too many parts | Too many files | Field name too long | Field value too long | Too many fields | Unexpected field>  [fieldName] Example: File too long file1
     */
    400: BadRequest;
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type importHearstArticlesHearstMigrationError = importHearstArticlesHearstMigrationErrors[keyof importHearstArticlesHearstMigrationErrors];

export type ImportHearstArticlesHearstMigrationResponses = {
    /**
     * No Content
     */
    204: void;
};

export type ImportHearstArticlesHearstMigrationResponse = ImportHearstArticlesHearstMigrationResponses[keyof ImportHearstArticlesHearstMigrationResponses];

export type ReplaceLinksHearstMigrationData = {
    body?: never;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/hearst-migration/replace-links';
};

export type replaceLinksHearstMigrationErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type replaceLinksHearstMigrationError = replaceLinksHearstMigrationErrors[keyof replaceLinksHearstMigrationErrors];

export type ReplaceLinksHearstMigrationResponses = {
    /**
     * No Content
     */
    204: void;
};

export type ReplaceLinksHearstMigrationResponse = ReplaceLinksHearstMigrationResponses[keyof ReplaceLinksHearstMigrationResponses];

export type ReplaceAffiliateLinksHearstMigrationData = {
    body: {
        linksJson: Blob | File;
    };
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/hearst-migration/replace-affiliate-links';
};

export type replaceAffiliateLinksHearstMigrationErrors = {
    /**
     * <File too long | Too many parts | Too many files | Field name too long | Field value too long | Too many fields | Unexpected field>  [fieldName] Example: File too long file1
     */
    400: BadRequest;
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type replaceAffiliateLinksHearstMigrationError = replaceAffiliateLinksHearstMigrationErrors[keyof replaceAffiliateLinksHearstMigrationErrors];

export type ReplaceAffiliateLinksHearstMigrationResponses = {
    /**
     * No Content
     */
    204: void;
};

export type ReplaceAffiliateLinksHearstMigrationResponse = ReplaceAffiliateLinksHearstMigrationResponses[keyof ReplaceAffiliateLinksHearstMigrationResponses];

export type ExportAffiliateLinksHearstMigrationData = {
    body: {
        hearstArticlesXml: Blob | File;
    };
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/hearst-migration/affiliate-links';
};

export type exportAffiliateLinksHearstMigrationErrors = {
    /**
     * <File too long | Too many parts | Too many files | Field name too long | Field value too long | Too many fields | Unexpected field>  [fieldName] Example: File too long file1
     */
    400: BadRequest;
};

export type exportAffiliateLinksHearstMigrationError = exportAffiliateLinksHearstMigrationErrors[keyof exportAffiliateLinksHearstMigrationErrors];

export type ImportAuthorsHearstMigrationData = {
    body: {
        authorsJson: Array<Blob | File>;
    };
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/hearst-migration/authors';
};

export type importAuthorsHearstMigrationErrors = {
    /**
     * <File too long | Too many parts | Too many files | Field name too long | Field value too long | Too many fields | Unexpected field>  [fieldName] Example: File too long file1
     */
    400: BadRequest;
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type importAuthorsHearstMigrationError = importAuthorsHearstMigrationErrors[keyof importAuthorsHearstMigrationErrors];

export type ImportAuthorsHearstMigrationResponses = {
    /**
     * No Content
     */
    204: void;
};

export type ImportAuthorsHearstMigrationResponse = ImportAuthorsHearstMigrationResponses[keyof ImportAuthorsHearstMigrationResponses];

export type CreateSupertokensUsersHearstMigrationData = {
    body?: never;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/hearst-migration/supertokens';
};

export type createSupertokensUsersHearstMigrationErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createSupertokensUsersHearstMigrationError = createSupertokensUsersHearstMigrationErrors[keyof createSupertokensUsersHearstMigrationErrors];

export type CreateSupertokensUsersHearstMigrationResponses = {
    /**
     * No Content
     */
    204: void;
};

export type CreateSupertokensUsersHearstMigrationResponse = CreateSupertokensUsersHearstMigrationResponses[keyof CreateSupertokensUsersHearstMigrationResponses];

export type ReformatListicleBlocksHearstMigrationData = {
    body?: {
        limit?: number;
        offset?: number;
    };
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/hearst-migration/reformat-listicle-blocks';
};

export type reformatListicleBlocksHearstMigrationErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type reformatListicleBlocksHearstMigrationError = reformatListicleBlocksHearstMigrationErrors[keyof reformatListicleBlocksHearstMigrationErrors];

export type ReformatListicleBlocksHearstMigrationResponses = {
    /**
     * Success
     */
    200: ReformatResult;
};

export type ReformatListicleBlocksHearstMigrationResponse = ReformatListicleBlocksHearstMigrationResponses[keyof ReformatListicleBlocksHearstMigrationResponses];

export type ListMenuData = {
    body?: never;
    path: {
        /**
         * scope items by editionID
         */
        editionID: number;
    };
    query?: {
        cache?: boolean;
    };
    url: '/edition/{editionID}/menu';
};

export type listMenuErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type listMenuError = listMenuErrors[keyof listMenuErrors];

export type ListMenuResponses = {
    /**
     * Success
     */
    200: Array<MenuItem>;
};

export type ListMenuResponse = ListMenuResponses[keyof ListMenuResponses];

export type GetMobileConfigData = {
    body?: never;
    path: {
        editionID: number;
        client: MobileConfigClient;
    };
    query?: {
        cache?: boolean;
    };
    url: '/edition/{editionID}/mobile-config/{client}';
};

export type GetMobileConfigResponses = {
    /**
     * Success
     */
    200: MobileConfig;
};

export type GetMobileConfigResponse = GetMobileConfigResponses[keyof GetMobileConfigResponses];

export type PutMobileConfigData = {
    body: MobileConfig;
    path: {
        editionID: number;
        client: MobileConfigClient;
    };
    query?: never;
    url: '/edition/{editionID}/mobile-config/{client}';
};

export type putMobileConfigErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type putMobileConfigError = putMobileConfigErrors[keyof putMobileConfigErrors];

export type PutMobileConfigResponses = {
    /**
     * Success
     */
    200: MobileConfig;
    /**
     * Created
     */
    201: MobileConfig;
};

export type PutMobileConfigResponse = PutMobileConfigResponses[keyof PutMobileConfigResponses];

export type ListExternalSnippetData = {
    body?: never;
    path: {
        editionID: number;
    };
    query?: {
        scope?: Scope;
        cache?: boolean;
    };
    url: '/edition/{editionID}/external-snippet';
};

export type ListExternalSnippetResponses = {
    /**
     * Success
     */
    200: Array<ExternalSnippet>;
};

export type ListExternalSnippetResponse = ListExternalSnippetResponses[keyof ListExternalSnippetResponses];

export type ListGroupedByPlacementExternalSnippetData = {
    body?: never;
    path: {
        editionID: number;
    };
    query?: {
        scope?: Scope;
        cache?: boolean;
    };
    url: '/edition/{editionID}/external-snippet/grouped-by-placement';
};

export type ListGroupedByPlacementExternalSnippetResponses = {
    /**
     * Success
     */
    200: PlacementList;
};

export type ListGroupedByPlacementExternalSnippetResponse = ListGroupedByPlacementExternalSnippetResponses[keyof ListGroupedByPlacementExternalSnippetResponses];

export type UpdateExternalSnippetData = {
    body: ExternalSnippetActionPatch;
    path: {
        editionID: number;
        placement: ExternalSnippetPlacement;
    };
    query?: never;
    url: '/edition/{editionID}/external-snippet/{placement}';
};

export type updateExternalSnippetErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type updateExternalSnippetError = updateExternalSnippetErrors[keyof updateExternalSnippetErrors];

export type UpdateExternalSnippetResponses = {
    /**
     * Success
     */
    200: ExternalSnippet;
};

export type UpdateExternalSnippetResponse = UpdateExternalSnippetResponses[keyof UpdateExternalSnippetResponses];

export type ListNewsBookmarkData = {
    body?: never;
    path: {
        editionID: number;
    };
    query?: {
        /**
         * current page
         */
        page?: number;
        /**
         * amount of items per page
         */
        perPage?: number;
    };
    url: '/edition/{editionID}/news-bookmark';
};

export type listNewsBookmarkErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type listNewsBookmarkError = listNewsBookmarkErrors[keyof listNewsBookmarkErrors];

export type ListNewsBookmarkResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<News>;
    };
};

export type ListNewsBookmarkResponse = ListNewsBookmarkResponses[keyof ListNewsBookmarkResponses];

export type ListIdsNewsBookmarkData = {
    body?: never;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/news-bookmark/ids';
};

export type listIdsNewsBookmarkErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type listIdsNewsBookmarkError = listIdsNewsBookmarkErrors[keyof listIdsNewsBookmarkErrors];

export type ListIdsNewsBookmarkResponses = {
    /**
     * Success
     */
    200: Array<number>;
};

export type ListIdsNewsBookmarkResponse = ListIdsNewsBookmarkResponses[keyof ListIdsNewsBookmarkResponses];

export type DeleteNewsBookmarkData = {
    body?: never;
    path: {
        editionID: number;
        /**
         * NewsID to be un-bookmarked
         */
        newsID: number;
    };
    query?: never;
    url: '/edition/{editionID}/news-bookmark/{newsID}';
};

export type deleteNewsBookmarkErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
    /**
     * Not Found
     */
    404: NotFound;
};

export type deleteNewsBookmarkError = deleteNewsBookmarkErrors[keyof deleteNewsBookmarkErrors];

export type DeleteNewsBookmarkResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteNewsBookmarkResponse = DeleteNewsBookmarkResponses[keyof DeleteNewsBookmarkResponses];

export type PostNewsBookmarkData = {
    body?: never;
    path: {
        editionID: number;
        /**
         * NewsID to be bookmarked
         */
        newsID: number;
    };
    query?: never;
    url: '/edition/{editionID}/news-bookmark/{newsID}';
};

export type postNewsBookmarkErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type postNewsBookmarkError = postNewsBookmarkErrors[keyof postNewsBookmarkErrors];

export type PostNewsBookmarkResponses = {
    /**
     * Created
     */
    201: {
        [key: string]: unknown;
    };
    /**
     * No Content
     */
    204: void;
};

export type PostNewsBookmarkResponse = PostNewsBookmarkResponses[keyof PostNewsBookmarkResponses];

export type GetOriginalRedirectData = {
    body?: never;
    path: {
        /**
         * scope items by editionID
         */
        editionID: number;
        path: string;
    };
    query?: {
        cache?: boolean;
    };
    url: '/edition/{editionID}/original-redirect/{path}';
};

export type GetOriginalRedirectResponses = {
    /**
     * Success
     */
    200: OriginalRedirect;
};

export type GetOriginalRedirectResponse = GetOriginalRedirectResponses[keyof GetOriginalRedirectResponses];

export type ListPageData = {
    body?: never;
    path: {
        editionID: number;
    };
    query?: {
        /**
         * Page number
         */
        page?: number;
        /**
         * Amount of items per page
         */
        perPage?: number;
        /**
         * Search on title
         */
        search?: string;
        cache?: boolean;
    };
    url: '/edition/{editionID}/page';
};

export type listPageErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type listPageError = listPageErrors[keyof listPageErrors];

export type ListPageResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<Page>;
    };
};

export type ListPageResponse = ListPageResponses[keyof ListPageResponses];

export type CreatePageData = {
    body: PageCreateActionCreate;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/page';
};

export type createPageErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createPageError = createPageErrors[keyof createPageErrors];

export type CreatePageResponses = {
    /**
     * Created
     */
    201: Page;
};

export type CreatePageResponse = CreatePageResponses[keyof CreatePageResponses];

export type GetByPathPageData = {
    body?: never;
    path: {
        editionID: number;
    };
    query: {
        /**
         * Get page by path
         */
        path: string;
        cache?: boolean;
    };
    url: '/edition/{editionID}/page/by-path';
};

export type GetByPathPageResponses = {
    /**
     * Success
     */
    200: Page;
};

export type GetByPathPageResponse = GetByPathPageResponses[keyof GetByPathPageResponses];

export type GetPageData = {
    body?: never;
    path: {
        editionID: number;
        /**
         * Get page by slug
         */
        slug: string;
    };
    query?: {
        cache?: boolean;
    };
    url: '/edition/{editionID}/page/{slug}';
};

export type GetPageResponses = {
    /**
     * Success
     */
    200: Page;
};

export type GetPageResponse = GetPageResponses[keyof GetPageResponses];

export type DeletePageData = {
    body?: never;
    path: {
        editionID: number;
        /**
         * Get page by id
         */
        id: number;
    };
    query?: never;
    url: '/edition/{editionID}/page/{id}';
};

export type deletePageErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deletePageError = deletePageErrors[keyof deletePageErrors];

export type DeletePageResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeletePageResponse = DeletePageResponses[keyof DeletePageResponses];

export type PatchPageData = {
    body: PagePatchActionPatch;
    path: {
        editionID: number;
        id: number;
    };
    query?: never;
    url: '/edition/{editionID}/page/{id}';
};

export type patchPageErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type patchPageError = patchPageErrors[keyof patchPageErrors];

export type PatchPageResponses = {
    /**
     * Success
     */
    200: Page;
};

export type PatchPageResponse = PatchPageResponses[keyof PatchPageResponses];

export type ListPlayerRatingData = {
    body?: never;
    path: {
        editionID: number;
    };
    query?: {
        /**
         * match that ratings should be returned from.
         */
        optaMatchID?: string;
        /**
         * player that ratings should be returned from.
         */
        playerID?: string;
        /**
         * Tournament that ratings should be returned from.
         */
        tournamentID?: string;
        /**
         * Competition that ratings should be returned from.
         */
        competitionID?: string;
        /**
         * Ratings should be filtered by ratingType
         */
        ratingType?: RatingType;
        /**
         * Ratings should be filtered by week
         */
        week?: number;
        /**
         * current page
         */
        page?: number;
        /**
         * amount of items per page
         */
        perPage?: number;
        cache?: boolean;
    };
    url: '/edition/{editionID}/player-rating';
};

export type listPlayerRatingErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type listPlayerRatingError = listPlayerRatingErrors[keyof listPlayerRatingErrors];

export type ListPlayerRatingResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<PlayerRating>;
    };
};

export type ListPlayerRatingResponse = ListPlayerRatingResponses[keyof ListPlayerRatingResponses];

export type PatchPlayerRatingData = {
    body: PlayerRatingPatch;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/player-rating';
};

export type patchPlayerRatingErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type patchPlayerRatingError = patchPlayerRatingErrors[keyof patchPlayerRatingErrors];

export type PatchPlayerRatingResponses = {
    /**
     * Created
     */
    201: PlayerRating;
};

export type PatchPlayerRatingResponse = PatchPlayerRatingResponses[keyof PatchPlayerRatingResponses];

export type GetOptaRatingsPlayerRatingData = {
    body?: never;
    path: {
        editionID: number;
        optaID: string;
    };
    query?: never;
    url: '/edition/{editionID}/player-rating/opta/{optaID}';
};

export type getOptaRatingsPlayerRatingErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getOptaRatingsPlayerRatingError = getOptaRatingsPlayerRatingErrors[keyof getOptaRatingsPlayerRatingErrors];

export type GetOptaRatingsPlayerRatingResponses = {
    /**
     * Success
     */
    200: Array<PlayerRatingPatch>;
};

export type GetOptaRatingsPlayerRatingResponse = GetOptaRatingsPlayerRatingResponses[keyof GetOptaRatingsPlayerRatingResponses];

export type AuthenticateWithUsernameAndPasswordPrenlyData = {
    body: AuthenticateWithUsernameAndPasswordBody;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/prenly/authenticate-with-username-and-password';
};

export type authenticateWithUsernameAndPasswordPrenlyErrors = {
    /**
     * Unauthorized
     */
    401: PrenlyErrorResponse;
    /**
     * Forbidden
     */
    403: PrenlyErrorResponse;
    /**
     * Precondition Failed
     */
    412: PrenlyErrorResponse;
};

export type authenticateWithUsernameAndPasswordPrenlyError = authenticateWithUsernameAndPasswordPrenlyErrors[keyof authenticateWithUsernameAndPasswordPrenlyErrors];

export type AuthenticateWithUsernameAndPasswordPrenlyResponses = {
    /**
     * Success
     */
    200: UserIdentification;
};

export type AuthenticateWithUsernameAndPasswordPrenlyResponse = AuthenticateWithUsernameAndPasswordPrenlyResponses[keyof AuthenticateWithUsernameAndPasswordPrenlyResponses];

export type GetUserPrenlyData = {
    body: GetUserBody;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/prenly/get-user';
};

export type getUserPrenlyErrors = {
    /**
     * Unauthorized
     */
    401: PrenlyErrorResponse;
    /**
     * Forbidden
     */
    403: PrenlyErrorResponse;
    /**
     * Not Found
     */
    404: PrenlyErrorResponse;
    /**
     * Precondition Failed
     */
    412: PrenlyErrorResponse;
};

export type getUserPrenlyError = getUserPrenlyErrors[keyof getUserPrenlyErrors];

export type GetUserPrenlyResponses = {
    /**
     * Success
     */
    200: UserSummary;
};

export type GetUserPrenlyResponse = GetUserPrenlyResponses[keyof GetUserPrenlyResponses];

export type ListSubscriptionData = {
    body?: never;
    path: {
        editionID: number;
    };
    query?: {
        cache?: boolean;
    };
    url: '/edition/{editionID}/subscription/propositions';
};

export type listSubscriptionErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type listSubscriptionError = listSubscriptionErrors[keyof listSubscriptionErrors];

export type ListSubscriptionResponses = {
    /**
     * Success
     */
    200: Array<Proposition>;
};

export type ListSubscriptionResponse = ListSubscriptionResponses[keyof ListSubscriptionResponses];

export type GetSubscriptionDetailsSubscriptionData = {
    body?: never;
    path: {
        editionID: number;
        /**
         * relationID of the user
         */
        relationID: number;
    };
    query?: {
        cache?: boolean;
    };
    url: '/edition/{editionID}/subscription/detail/{relationID}';
};

export type getSubscriptionDetailsSubscriptionErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getSubscriptionDetailsSubscriptionError = getSubscriptionDetailsSubscriptionErrors[keyof getSubscriptionDetailsSubscriptionErrors];

export type GetSubscriptionDetailsSubscriptionResponses = {
    /**
     * Success
     */
    200: Array<SubscriptionDetails>;
};

export type GetSubscriptionDetailsSubscriptionResponse = GetSubscriptionDetailsSubscriptionResponses[keyof GetSubscriptionDetailsSubscriptionResponses];

export type GetPaymentMethodsSubscriptionData = {
    body?: never;
    path: {
        editionID: number;
    };
    query?: {
        cache?: boolean;
    };
    url: '/edition/{editionID}/subscription/payment-methods';
};

export type GetPaymentMethodsSubscriptionResponses = {
    /**
     * Success
     */
    200: Array<PaymentMethod>;
};

export type GetPaymentMethodsSubscriptionResponse = GetPaymentMethodsSubscriptionResponses[keyof GetPaymentMethodsSubscriptionResponses];

export type UpdateUserSubscriptionData = {
    body: SubscriptionUpdate;
    path: {
        editionID: number;
        userID: number;
        relationNumber: number;
    };
    query?: never;
    url: '/edition/{editionID}/subscription/update/{userID}/{relationNumber}';
};

export type updateUserSubscriptionErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type updateUserSubscriptionError = updateUserSubscriptionErrors[keyof updateUserSubscriptionErrors];

export type UpdateUserSubscriptionResponses = {
    /**
     * Success
     */
    200: {
        [key: string]: unknown;
    };
};

export type UpdateUserSubscriptionResponse = UpdateUserSubscriptionResponses[keyof UpdateUserSubscriptionResponses];

export type GetInfoSubscriptionData = {
    body?: never;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/subscription/info';
};

export type getInfoSubscriptionErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getInfoSubscriptionError = getInfoSubscriptionErrors[keyof getInfoSubscriptionErrors];

export type GetInfoSubscriptionResponses = {
    /**
     * Success
     */
    200: Array<SubscriptionDetails>;
};

export type GetInfoSubscriptionResponse = GetInfoSubscriptionResponses[keyof GetInfoSubscriptionResponses];

export type ShouldSwitchSubscriptionData = {
    body?: never;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/subscription/should-switch';
};

export type shouldSwitchSubscriptionErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type shouldSwitchSubscriptionError = shouldSwitchSubscriptionErrors[keyof shouldSwitchSubscriptionErrors];

export type ShouldSwitchSubscriptionResponses = {
    /**
     * Success
     */
    200: ShouldSwitchResponse;
};

export type ShouldSwitchSubscriptionResponse = ShouldSwitchSubscriptionResponses[keyof ShouldSwitchSubscriptionResponses];

export type CreateRelationSubscriptionData = {
    body: CreateRelationRequest;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/subscription/create-relation';
};

export type createRelationSubscriptionErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createRelationSubscriptionError = createRelationSubscriptionErrors[keyof createRelationSubscriptionErrors];

export type CreateRelationSubscriptionResponses = {
    /**
     * Success
     */
    200: ZenoResponse;
};

export type CreateRelationSubscriptionResponse = CreateRelationSubscriptionResponses[keyof CreateRelationSubscriptionResponses];

export type UpdateRelationAddressSubscriptionData = {
    body: UpdateRelationAddressRequest;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/subscription/update-relation-address';
};

export type updateRelationAddressSubscriptionErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type updateRelationAddressSubscriptionError = updateRelationAddressSubscriptionErrors[keyof updateRelationAddressSubscriptionErrors];

export type UpdateRelationAddressSubscriptionResponses = {
    /**
     * Created
     */
    201: ZenoResponse;
};

export type UpdateRelationAddressSubscriptionResponse = UpdateRelationAddressSubscriptionResponses[keyof UpdateRelationAddressSubscriptionResponses];

export type RequestPaymentLinkSubscriptionData = {
    body: PaymentLinkRequest;
    path: {
        editionID: number;
    };
    query?: {
        isProfile?: boolean;
    };
    url: '/edition/{editionID}/subscription/request-payment-link';
};

export type requestPaymentLinkSubscriptionErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type requestPaymentLinkSubscriptionError = requestPaymentLinkSubscriptionErrors[keyof requestPaymentLinkSubscriptionErrors];

export type RequestPaymentLinkSubscriptionResponses = {
    /**
     * Success
     */
    200: ZenoResponse;
};

export type RequestPaymentLinkSubscriptionResponse = RequestPaymentLinkSubscriptionResponses[keyof RequestPaymentLinkSubscriptionResponses];

export type AddSubscriptionSubscriptionData = {
    body: PartialAddSubscriptionRequest;
    path: {
        editionID: number;
        propositionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/subscription/add-subscription/{propositionID}';
};

export type addSubscriptionSubscriptionErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type addSubscriptionSubscriptionError = addSubscriptionSubscriptionErrors[keyof addSubscriptionSubscriptionErrors];

export type AddSubscriptionSubscriptionResponses = {
    /**
     * Success
     */
    200: ZenoResponse;
};

export type AddSubscriptionSubscriptionResponse = AddSubscriptionSubscriptionResponses[keyof AddSubscriptionSubscriptionResponses];

export type PaymentSucceededSubscriptionData = {
    body?: never;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/subscription/payment-succeeded';
};

export type paymentSucceededSubscriptionErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type paymentSucceededSubscriptionError = paymentSucceededSubscriptionErrors[keyof paymentSucceededSubscriptionErrors];

export type PaymentSucceededSubscriptionResponses = {
    /**
     * Success
     */
    200: ZenoResponse;
};

export type PaymentSucceededSubscriptionResponse = PaymentSucceededSubscriptionResponses[keyof PaymentSucceededSubscriptionResponses];

export type LookupAddressSubscriptionData = {
    body?: never;
    path: {
        editionID: number;
        postalCode: string;
        houseNumber: number;
    };
    query?: {
        cache?: boolean;
    };
    url: '/edition/{editionID}/subscription/lookup/{postalCode}/{houseNumber}';
};

export type lookupAddressSubscriptionErrors = {
    /**
     * Bad Request
     */
    400: BadRequest;
    /**
     * Not Found
     */
    404: NotFound;
};

export type lookupAddressSubscriptionError = lookupAddressSubscriptionErrors[keyof lookupAddressSubscriptionErrors];

export type LookupAddressSubscriptionResponses = {
    /**
     * Success
     */
    200: AddressResponse;
};

export type LookupAddressSubscriptionResponse = LookupAddressSubscriptionResponses[keyof LookupAddressSubscriptionResponses];

export type RedirectsSubscriptionData = {
    body: RedirectsRequest;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/subscription/redirects';
};

export type RedirectsSubscriptionResponses = {
    /**
     * Success
     */
    200: RedirectsResponse;
};

export type RedirectsSubscriptionResponse = RedirectsSubscriptionResponses[keyof RedirectsSubscriptionResponses];

export type CheckVoucherCodeSubscriptionData = {
    body: CheckVoucherCodeRequest;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/subscription/check-voucher-code';
};

export type CheckVoucherCodeSubscriptionResponses = {
    /**
     * Success
     */
    200: CheckVoucherCodeResponse;
};

export type CheckVoucherCodeSubscriptionResponse = CheckVoucherCodeSubscriptionResponses[keyof CheckVoucherCodeSubscriptionResponses];

export type ListGiftsGiftData = {
    body?: never;
    path: {
        editionID: number;
    };
    query?: {
        scope?: Scope;
        /**
         * current page
         */
        page?: number;
        /**
         * amount of items per page
         */
        perPage?: number;
        cache?: boolean;
    };
    url: '/edition/{editionID}/subscription/gift';
};

export type ListGiftsGiftResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<Gift>;
    };
};

export type ListGiftsGiftResponse = ListGiftsGiftResponses[keyof ListGiftsGiftResponses];

export type CreateGiftData = {
    body: GiftActionCreate;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/subscription/gift';
};

export type createGiftErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createGiftError = createGiftErrors[keyof createGiftErrors];

export type CreateGiftResponses = {
    /**
     * Created
     */
    201: Gift;
};

export type CreateGiftResponse = CreateGiftResponses[keyof CreateGiftResponses];

export type DeleteGiftData = {
    body?: never;
    path: {
        editionID: number;
        giftID: number;
    };
    query?: never;
    url: '/edition/{editionID}/subscription/gift/{giftID}';
};

export type deleteGiftErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteGiftError = deleteGiftErrors[keyof deleteGiftErrors];

export type DeleteGiftResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteGiftResponse = DeleteGiftResponses[keyof DeleteGiftResponses];

export type GetByIdGiftData = {
    body?: never;
    path: {
        editionID: number;
        giftID: number;
    };
    query?: {
        cache?: boolean;
    };
    url: '/edition/{editionID}/subscription/gift/{giftID}';
};

export type getByIdGiftErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getByIdGiftError = getByIdGiftErrors[keyof getByIdGiftErrors];

export type GetByIdGiftResponses = {
    /**
     * Success
     */
    200: Gift;
};

export type GetByIdGiftResponse = GetByIdGiftResponses[keyof GetByIdGiftResponses];

export type PatchGiftData = {
    body: Gift;
    path: {
        editionID: number;
        giftID: number;
    };
    query?: never;
    url: '/edition/{editionID}/subscription/gift/{giftID}';
};

export type patchGiftErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type patchGiftError = patchGiftErrors[keyof patchGiftErrors];

export type PatchGiftResponses = {
    /**
     * Created
     */
    201: Gift;
};

export type PatchGiftResponse = PatchGiftResponses[keyof PatchGiftResponses];

export type CreatePropositionData = {
    body: CreateProposition;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/subscription/proposition';
};

export type createPropositionErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createPropositionError = createPropositionErrors[keyof createPropositionErrors];

export type CreatePropositionResponses = {
    /**
     * Created
     */
    201: Proposition;
};

export type CreatePropositionResponse = CreatePropositionResponses[keyof CreatePropositionResponses];

export type DeleteByIdPropositionData = {
    body?: never;
    path: {
        editionID: number;
        propositionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/subscription/proposition/{propositionID}';
};

export type deleteByIdPropositionErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteByIdPropositionError = deleteByIdPropositionErrors[keyof deleteByIdPropositionErrors];

export type DeleteByIdPropositionResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteByIdPropositionResponse = DeleteByIdPropositionResponses[keyof DeleteByIdPropositionResponses];

export type GetByIdPropositionData = {
    body?: never;
    path: {
        editionID: number;
        propositionID: number;
    };
    query?: {
        cache?: boolean;
    };
    url: '/edition/{editionID}/subscription/proposition/{propositionID}';
};

export type getByIdPropositionErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getByIdPropositionError = getByIdPropositionErrors[keyof getByIdPropositionErrors];

export type GetByIdPropositionResponses = {
    /**
     * Success
     */
    200: Proposition;
};

export type GetByIdPropositionResponse = GetByIdPropositionResponses[keyof GetByIdPropositionResponses];

export type PatchPropositionData = {
    body: PatchProposition;
    path: {
        editionID: number;
        propositionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/subscription/proposition/{propositionID}';
};

export type patchPropositionErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type patchPropositionError = patchPropositionErrors[keyof patchPropositionErrors];

export type PatchPropositionResponses = {
    /**
     * Created
     */
    201: Proposition;
};

export type PatchPropositionResponse = PatchPropositionResponses[keyof PatchPropositionResponses];

export type ListTierData = {
    body?: never;
    path: {
        editionID: number;
    };
    query?: {
        /**
         * will be used to get tiers by tierGroupSlug
         */
        tierGroupSlug?: string;
        /**
         * will be used to get tiers by tierSlug
         */
        tierSlug?: string;
        scope?: Scope;
        includeUSPs?: boolean;
        includePropositions?: boolean;
        cache?: boolean;
    };
    url: '/edition/{editionID}/subscription/tier';
};

export type ListTierResponses = {
    /**
     * Success
     */
    200: Array<Tier>;
};

export type ListTierResponse = ListTierResponses[keyof ListTierResponses];

export type CreateTierData = {
    body: CreateTier;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/subscription/tier';
};

export type createTierErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createTierError = createTierErrors[keyof createTierErrors];

export type CreateTierResponses = {
    /**
     * Created
     */
    201: Tier;
};

export type CreateTierResponse = CreateTierResponses[keyof CreateTierResponses];

export type DeleteByIdTierData = {
    body?: never;
    path: {
        editionID: number;
        tierID: number;
    };
    query?: never;
    url: '/edition/{editionID}/subscription/tier/{tierID}';
};

export type deleteByIdTierErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteByIdTierError = deleteByIdTierErrors[keyof deleteByIdTierErrors];

export type DeleteByIdTierResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteByIdTierResponse = DeleteByIdTierResponses[keyof DeleteByIdTierResponses];

export type GetByIdTierData = {
    body?: never;
    path: {
        editionID: number;
        tierID: number;
    };
    query?: {
        includeUSPs?: boolean;
        includePropositions?: boolean;
        cache?: boolean;
    };
    url: '/edition/{editionID}/subscription/tier/{tierID}';
};

export type getByIdTierErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getByIdTierError = getByIdTierErrors[keyof getByIdTierErrors];

export type GetByIdTierResponses = {
    /**
     * Success
     */
    200: Tier;
};

export type GetByIdTierResponse = GetByIdTierResponses[keyof GetByIdTierResponses];

export type PatchTierData = {
    body: PatchTier;
    path: {
        editionID: number;
        tierID: number;
    };
    query?: {
        updateUsps?: boolean;
    };
    url: '/edition/{editionID}/subscription/tier/{tierID}';
};

export type patchTierErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type patchTierError = patchTierErrors[keyof patchTierErrors];

export type PatchTierResponses = {
    /**
     * Created
     */
    201: Tier;
};

export type PatchTierResponse = PatchTierResponses[keyof PatchTierResponses];

export type DuplicateTierData = {
    body: CreateTier;
    path: {
        editionID: number;
        /**
         * will be used to duplicate the tier from
         */
        originalTierID: number;
    };
    query?: never;
    url: '/edition/{editionID}/subscription/tier/duplicate/{originalTierID}';
};

export type duplicateTierErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type duplicateTierError = duplicateTierErrors[keyof duplicateTierErrors];

export type DuplicateTierResponses = {
    /**
     * Created
     */
    201: Tier;
};

export type DuplicateTierResponse = DuplicateTierResponses[keyof DuplicateTierResponses];

export type ListTierGroupData = {
    body?: never;
    path: {
        editionID: number;
    };
    query?: {
        /**
         * will be used to get tierGroup by slug
         */
        slug?: string;
        /**
         * will be used to filter by active
         */
        active?: boolean;
        cache?: boolean;
    };
    url: '/edition/{editionID}/subscription/tier-groups';
};

export type listTierGroupErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type listTierGroupError = listTierGroupErrors[keyof listTierGroupErrors];

export type ListTierGroupResponses = {
    /**
     * Success
     */
    200: Array<TierGroup>;
};

export type ListTierGroupResponse = ListTierGroupResponses[keyof ListTierGroupResponses];

export type CreateTierGroupData = {
    body: CreateTierGroup;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/subscription/tier-groups';
};

export type createTierGroupErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createTierGroupError = createTierGroupErrors[keyof createTierGroupErrors];

export type CreateTierGroupResponses = {
    /**
     * Created
     */
    201: TierGroup;
};

export type CreateTierGroupResponse = CreateTierGroupResponses[keyof CreateTierGroupResponses];

export type GetBySlugTierGroupData = {
    body?: never;
    path: {
        editionID: number;
    };
    query?: {
        /**
         * will be used to get tierGroup by slug
         */
        slug?: string;
        /**
         * will be used to get tierGroup by tierSlug
         */
        tierSlug?: string;
        /**
         * will be used to filter by active
         */
        active?: boolean;
        cache?: boolean;
    };
    url: '/edition/{editionID}/subscription/tier-groups/by-slug';
};

export type GetBySlugTierGroupResponses = {
    /**
     * Success
     */
    200: TierGroup;
};

export type GetBySlugTierGroupResponse = GetBySlugTierGroupResponses[keyof GetBySlugTierGroupResponses];

export type DeleteTierGroupData = {
    body?: never;
    path: {
        editionID: number;
        tierGroupID: number;
    };
    query?: never;
    url: '/edition/{editionID}/subscription/tier-groups/{tierGroupID}';
};

export type deleteTierGroupErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteTierGroupError = deleteTierGroupErrors[keyof deleteTierGroupErrors];

export type DeleteTierGroupResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteTierGroupResponse = DeleteTierGroupResponses[keyof DeleteTierGroupResponses];

export type GetByIdTierGroupData = {
    body?: never;
    path: {
        editionID: number;
        tierGroupID: number;
    };
    query?: {
        cache?: boolean;
    };
    url: '/edition/{editionID}/subscription/tier-groups/{tierGroupID}';
};

export type getByIdTierGroupErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getByIdTierGroupError = getByIdTierGroupErrors[keyof getByIdTierGroupErrors];

export type GetByIdTierGroupResponses = {
    /**
     * Success
     */
    200: TierGroup;
};

export type GetByIdTierGroupResponse = GetByIdTierGroupResponses[keyof GetByIdTierGroupResponses];

export type PatchTierGroupData = {
    body: PatchTierGroup;
    path: {
        editionID: number;
        tierGroupID: number;
    };
    query?: never;
    url: '/edition/{editionID}/subscription/tier-groups/{tierGroupID}';
};

export type patchTierGroupErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type patchTierGroupError = patchTierGroupErrors[keyof patchTierGroupErrors];

export type PatchTierGroupResponses = {
    /**
     * Created
     */
    201: TierGroup;
};

export type PatchTierGroupResponse = PatchTierGroupResponses[keyof PatchTierGroupResponses];

export type DuplicateTierGroupData = {
    body: CreateTierGroup;
    path: {
        editionID: number;
        /**
         * will be used to duplicate the tier group from
         */
        originalTierGroupID: number;
    };
    query?: never;
    url: '/edition/{editionID}/subscription/tier-groups/duplicate/{originalTierGroupID}';
};

export type duplicateTierGroupErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type duplicateTierGroupError = duplicateTierGroupErrors[keyof duplicateTierGroupErrors];

export type DuplicateTierGroupResponses = {
    /**
     * Created
     */
    201: TierGroup;
};

export type DuplicateTierGroupResponse = DuplicateTierGroupResponses[keyof DuplicateTierGroupResponses];

export type CreateUspData = {
    body: CreateUSP;
    path: {
        editionID: number;
        tierID: number;
    };
    query?: never;
    url: '/edition/{editionID}/subscription/usp/{tierID}';
};

export type createUspErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createUspError = createUspErrors[keyof createUspErrors];

export type CreateUspResponses = {
    /**
     * Created
     */
    201: USP;
};

export type CreateUspResponse = CreateUspResponses[keyof CreateUspResponses];

export type DeleteByIduspData = {
    body?: never;
    path: {
        editionID: number;
        uspID: number;
    };
    query?: never;
    url: '/edition/{editionID}/subscription/usp/{uspID}';
};

export type deleteByIduspErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteByIduspError = deleteByIduspErrors[keyof deleteByIduspErrors];

export type DeleteByIduspResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteByIduspResponse = DeleteByIduspResponses[keyof DeleteByIduspResponses];

export type GetByIduspData = {
    body?: never;
    path: {
        editionID: number;
        uspID: number;
    };
    query?: {
        cache?: boolean;
    };
    url: '/edition/{editionID}/subscription/usp/{uspID}';
};

export type getByIduspErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getByIduspError = getByIduspErrors[keyof getByIduspErrors];

export type GetByIduspResponses = {
    /**
     * Success
     */
    200: USP;
};

export type GetByIduspResponse = GetByIduspResponses[keyof GetByIduspResponses];

export type UpdateUspData = {
    body: PatchUSP;
    path: {
        editionID: number;
        uspID: number;
    };
    query?: never;
    url: '/edition/{editionID}/subscription/usp/{uspID}';
};

export type updateUspErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type updateUspError = updateUspErrors[keyof updateUspErrors];

export type UpdateUspResponses = {
    /**
     * Created
     */
    201: USP;
};

export type UpdateUspResponse = UpdateUspResponses[keyof UpdateUspResponses];

export type DeleteMultipleTagTabData = {
    body?: never;
    path: {
        editionID: number;
        tagID: number;
    };
    query?: never;
    url: '/edition/{editionID}/tag-tab/{tagID}';
};

export type deleteMultipleTagTabErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteMultipleTagTabError = deleteMultipleTagTabErrors[keyof deleteMultipleTagTabErrors];

export type DeleteMultipleTagTabResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteMultipleTagTabResponse = DeleteMultipleTagTabResponses[keyof DeleteMultipleTagTabResponses];

export type ListTagTabData = {
    body?: never;
    path: {
        editionID: number;
        tagID: number;
    };
    query?: {
        scope?: Scope;
        cache?: boolean;
    };
    url: '/edition/{editionID}/tag-tab/{tagID}';
};

export type ListTagTabResponses = {
    /**
     * Success
     */
    200: Array<TagTab>;
};

export type ListTagTabResponse = ListTagTabResponses[keyof ListTagTabResponses];

export type PatchMultipleTagTabData = {
    body: Array<TagTabPatch>;
    path: {
        editionID: number;
        tagID: number;
    };
    query?: never;
    url: '/edition/{editionID}/tag-tab/{tagID}';
};

export type patchMultipleTagTabErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
    /**
     * Not Found
     */
    404: NotFound;
};

export type patchMultipleTagTabError = patchMultipleTagTabErrors[keyof patchMultipleTagTabErrors];

export type PatchMultipleTagTabResponses = {
    /**
     * Success
     */
    200: Array<TagTab>;
};

export type PatchMultipleTagTabResponse = PatchMultipleTagTabResponses[keyof PatchMultipleTagTabResponses];

export type ListTagTemplateData = {
    body?: never;
    path: {
        editionID: number;
    };
    query?: never;
    url: '/edition/{editionID}/tag-template';
};

export type listTagTemplateErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type listTagTemplateError = listTagTemplateErrors[keyof listTagTemplateErrors];

export type ListTagTemplateResponses = {
    /**
     * Success
     */
    200: Array<TagTemplate>;
};

export type ListTagTemplateResponse = ListTagTemplateResponses[keyof ListTagTemplateResponses];

export type ListTabsTagTemplateData = {
    body?: never;
    path: {
        editionID: number;
        tagTemplateID: number;
    };
    query?: never;
    url: '/edition/{editionID}/tag-template/{tagTemplateID}/tab';
};

export type listTabsTagTemplateErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type listTabsTagTemplateError = listTabsTagTemplateErrors[keyof listTabsTagTemplateErrors];

export type ListTabsTagTemplateResponses = {
    /**
     * Success
     */
    200: Array<TagTemplateTab>;
};

export type ListTabsTagTemplateResponse = ListTabsTagTemplateResponses[keyof ListTabsTagTemplateResponses];

export type CreateUserGeneratedContentData = {
    body: UserGeneratedContentActionCreate;
    path: {
        editionID: number;
    };
    query: {
        client: Client;
    };
    url: '/edition/{editionID}/user-generated-content';
};

export type createUserGeneratedContentErrors = {
    /**
     * Bad Request
     */
    400: UserGeneratedContentValidationError;
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createUserGeneratedContentError = createUserGeneratedContentErrors[keyof createUserGeneratedContentErrors];

export type CreateUserGeneratedContentResponses = {
    /**
     * Success
     */
    200: News;
};

export type CreateUserGeneratedContentResponse = CreateUserGeneratedContentResponses[keyof CreateUserGeneratedContentResponses];

export type GeneralScoreboardUserMatchPredictionData = {
    body?: never;
    path: {
        editionID: number;
    };
    query?: {
        page?: number;
        perPage?: number;
        cache?: boolean;
    };
    url: '/edition/{editionID}/user-match-prediction/scoreboard';
};

export type GeneralScoreboardUserMatchPredictionResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<UserMatchPredictionScoreboardItem>;
    };
};

export type GeneralScoreboardUserMatchPredictionResponse = GeneralScoreboardUserMatchPredictionResponses[keyof GeneralScoreboardUserMatchPredictionResponses];

export type GeneralScoreboardWithUserUserMatchPredictionData = {
    body?: never;
    path: {
        editionID: number;
        userID: number;
    };
    query?: {
        page?: number;
        perPage?: number;
        cache?: boolean;
    };
    url: '/edition/{editionID}/user-match-prediction/scoreboard/{userID}';
};

export type GeneralScoreboardWithUserUserMatchPredictionResponses = {
    /**
     * Success
     */
    200: UserMatchPredictionScoreboardWithUser;
};

export type GeneralScoreboardWithUserUserMatchPredictionResponse = GeneralScoreboardWithUserUserMatchPredictionResponses[keyof GeneralScoreboardWithUserUserMatchPredictionResponses];

export type TournamentScoreboardUserMatchPredictionData = {
    body?: never;
    path: {
        editionID: number;
        tournamentID: string;
    };
    query?: {
        page?: number;
        perPage?: number;
        cache?: boolean;
    };
    url: '/edition/{editionID}/user-match-prediction/tournament/{tournamentID}/scoreboard';
};

export type TournamentScoreboardUserMatchPredictionResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<UserMatchPredictionScoreboardItem>;
    };
};

export type TournamentScoreboardUserMatchPredictionResponse = TournamentScoreboardUserMatchPredictionResponses[keyof TournamentScoreboardUserMatchPredictionResponses];

export type TournamentScoreboardWithUserUserMatchPredictionData = {
    body?: never;
    path: {
        editionID: number;
        tournamentID: string;
        userID: number;
    };
    query?: {
        page?: number;
        perPage?: number;
        cache?: boolean;
    };
    url: '/edition/{editionID}/user-match-prediction/tournament/{tournamentID}/scoreboard/{userID}';
};

export type TournamentScoreboardWithUserUserMatchPredictionResponses = {
    /**
     * Success
     */
    200: UserMatchPredictionScoreboardWithUser;
};

export type TournamentScoreboardWithUserUserMatchPredictionResponse = TournamentScoreboardWithUserUserMatchPredictionResponses[keyof TournamentScoreboardWithUserUserMatchPredictionResponses];

export type ListMatchesUserMatchPredictionData = {
    body?: never;
    path: {
        editionID: number;
        tournamentID: string;
    };
    query?: {
        /**
         * Start date of matches to be returned. String in format yyyy-MM-dd.
         */
        startDate?: string;
        /**
         * End date of matches to be returned. String in format yyyy-MM-dd.
         */
        endDate?: string;
        order?: Order;
        page?: number;
        perPage?: number;
    };
    url: '/edition/{editionID}/user-match-prediction/tournament/{tournamentID}/matches';
};

export type ListMatchesUserMatchPredictionResponses = {
    /**
     * Success
     */
    200: UserMatchPredictionListMatches;
};

export type ListMatchesUserMatchPredictionResponse = ListMatchesUserMatchPredictionResponses[keyof ListMatchesUserMatchPredictionResponses];

export type VoteDistributionForMatchUserMatchPredictionData = {
    body?: never;
    path: {
        editionID: number;
        optaID: string;
    };
    query?: never;
    url: '/edition/{editionID}/user-match-prediction/matches/{optaID}/vote-count';
};

export type VoteDistributionForMatchUserMatchPredictionResponses = {
    /**
     * Success
     */
    200: UserMatchPredictionMatchResults;
};

export type VoteDistributionForMatchUserMatchPredictionResponse = VoteDistributionForMatchUserMatchPredictionResponses[keyof VoteDistributionForMatchUserMatchPredictionResponses];

export type VotesForUserUserMatchPredictionData = {
    body?: never;
    path: {
        editionID: number;
    };
    query: {
        optaIDs: string;
    };
    url: '/edition/{editionID}/user-match-prediction/votes-for-user';
};

export type VotesForUserUserMatchPredictionResponses = {
    /**
     * Success
     */
    200: UserMatchPredictionVotesForUserResponse;
};

export type VotesForUserUserMatchPredictionResponse = VotesForUserUserMatchPredictionResponses[keyof VotesForUserUserMatchPredictionResponses];

export type VoteDeprecatedUserMatchPredictionData = {
    body: UserMatchPredictionVoteBody;
    path: {
        editionID: number;
        tournamentID: string;
        /**
         * @deprecated
         */
        matchID: number;
    };
    query?: never;
    url: '/edition/{editionID}/user-match-prediction/tournament/{tournamentID}/matches/{matchID}/vote';
};

export type voteDeprecatedUserMatchPredictionErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type voteDeprecatedUserMatchPredictionError = voteDeprecatedUserMatchPredictionErrors[keyof voteDeprecatedUserMatchPredictionErrors];

export type VoteDeprecatedUserMatchPredictionResponses = {
    /**
     * Success
     */
    200: UserMatchPredictionVote;
};

export type VoteDeprecatedUserMatchPredictionResponse = VoteDeprecatedUserMatchPredictionResponses[keyof VoteDeprecatedUserMatchPredictionResponses];

export type VoteUserMatchPredictionData = {
    body: UserMatchPredictionVoteBody;
    path: {
        editionID: number;
        tournamentID: string;
        optaID: string;
    };
    query?: never;
    url: '/edition/{editionID}/user-match-prediction/tournament/{tournamentID}/matches/{optaID}';
};

export type voteUserMatchPredictionErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type voteUserMatchPredictionError = voteUserMatchPredictionErrors[keyof voteUserMatchPredictionErrors];

export type VoteUserMatchPredictionResponses = {
    /**
     * Success
     */
    200: UserMatchPredictionVote;
};

export type VoteUserMatchPredictionResponse = VoteUserMatchPredictionResponses[keyof VoteUserMatchPredictionResponses];

export type FileUploadFileUploadData = {
    body: {
        file: Blob | File;
    };
    path?: never;
    query?: {
        isHashed?: boolean;
        scope?: Scope;
    };
    url: '/file-upload';
};

export type fileUploadFileUploadErrors = {
    /**
     * <File too long | Too many parts | Too many files | Field name too long | Field value too long | Too many fields | Unexpected field>  [fieldName] Example: File too long file1
     */
    400: BadRequest;
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type fileUploadFileUploadError = fileUploadFileUploadErrors[keyof fileUploadFileUploadErrors];

export type FileUploadFileUploadResponses = {
    /**
     * Success
     */
    200: TmpFile;
};

export type FileUploadFileUploadResponse = FileUploadFileUploadResponses[keyof FileUploadFileUploadResponses];

export type ProcessImageBlockFileUploadData = {
    body: ImageBlock;
    path?: never;
    query?: never;
    url: '/file-upload/process-image-block';
};

export type processImageBlockFileUploadErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type processImageBlockFileUploadError = processImageBlockFileUploadErrors[keyof processImageBlockFileUploadErrors];

export type ProcessImageBlockFileUploadResponses = {
    /**
     * Success
     */
    200: ImageBlock;
};

export type ProcessImageBlockFileUploadResponse = ProcessImageBlockFileUploadResponses[keyof ProcessImageBlockFileUploadResponses];

export type GetCompetitionData = {
    body?: never;
    path: {
        /**
         * OPTA ID of the competition or OPTA ID of the one of the tournaments from the competition.
         */
        id: string;
    };
    query?: {
        cache?: boolean;
    };
    url: '/football/competition/by-tag/{id}';
};

export type GetCompetitionResponses = {
    /**
     * Success
     */
    200: Competition;
};

export type GetCompetitionResponse = GetCompetitionResponses[keyof GetCompetitionResponses];

export type GetByIdPlayerData = {
    body?: never;
    path: {
        /**
         * OPTA ID of the requested player
         */
        id: string;
    };
    query?: {
        cache?: boolean;
    };
    url: '/football/player/{id}';
};

export type GetByIdPlayerResponses = {
    /**
     * Success
     */
    200: Player;
};

export type GetByIdPlayerResponse = GetByIdPlayerResponses[keyof GetByIdPlayerResponses];

export type GetCareerByIdPlayerData = {
    body?: never;
    path: {
        /**
         * OPTA ID of the requested player
         */
        id: string;
    };
    query?: {
        cache?: boolean;
    };
    url: '/football/player/{id}/career';
};

export type GetCareerByIdPlayerResponses = {
    /**
     * Success
     */
    200: Array<PlayerMembership>;
};

export type GetCareerByIdPlayerResponse = GetCareerByIdPlayerResponses[keyof GetCareerByIdPlayerResponses];

export type GetPassportByIdPlayerData = {
    body?: never;
    path: {
        /**
         * OPTA ID of the requested player
         */
        id: string;
    };
    query?: {
        cache?: boolean;
    };
    url: '/football/player/{id}/passport';
};

export type GetPassportByIdPlayerResponses = {
    /**
     * Success
     */
    200: PlayerPassport;
};

export type GetPassportByIdPlayerResponse = GetPassportByIdPlayerResponses[keyof GetPassportByIdPlayerResponses];

export type GetShirtsTeamData = {
    body?: never;
    path?: never;
    query?: {
        cache?: boolean;
    };
    url: '/football/team/shirt';
};

export type getShirtsTeamErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getShirtsTeamError = getShirtsTeamErrors[keyof getShirtsTeamErrors];

export type GetShirtsTeamResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<Shirt>;
    };
};

export type GetShirtsTeamResponse = GetShirtsTeamResponses[keyof GetShirtsTeamResponses];

export type GetShirtTeamData = {
    body?: never;
    path: {
        /**
         * OPTA ID of the requested team
         */
        id: string;
    };
    query?: {
        cache?: boolean;
    };
    url: '/football/team/{id}/shirt';
};

export type GetShirtTeamResponses = {
    /**
     * Success
     */
    200: Shirt;
};

export type GetShirtTeamResponse = GetShirtTeamResponses[keyof GetShirtTeamResponses];

export type GetTeamSelectionTeamData = {
    body?: never;
    path: {
        /**
         * OPTA ID of the requested team
         */
        id: string;
    };
    query?: {
        cache?: boolean;
    };
    url: '/football/team/{id}/selection';
};

export type GetTeamSelectionTeamResponses = {
    /**
     * Success
     */
    200: TeamSelection;
};

export type GetTeamSelectionTeamResponse = GetTeamSelectionTeamResponses[keyof GetTeamSelectionTeamResponses];

export type GetByIdTeamData = {
    body?: never;
    path: {
        /**
         * OPTA ID of the requested team
         */
        id: string;
    };
    query?: {
        cache?: boolean;
    };
    url: '/football/team/{id}';
};

export type GetByIdTeamResponses = {
    /**
     * Success
     */
    200: Team;
};

export type GetByIdTeamResponse = GetByIdTeamResponses[keyof GetByIdTeamResponses];

export type GetTournamentStandingsTournamentData = {
    body?: never;
    path: {
        /**
         * OPTA ID of the requested tournament
         */
        id: string;
    };
    query?: {
        cache?: boolean;
    };
    url: '/football/tournament/{id}/standings';
};

export type GetTournamentStandingsTournamentResponses = {
    /**
     * Success
     */
    200: TournamentStandings;
};

export type GetTournamentStandingsTournamentResponse = GetTournamentStandingsTournamentResponses[keyof GetTournamentStandingsTournamentResponses];

export type GetTournamentRankingsTournamentData = {
    body?: never;
    path: {
        /**
         * OPTA ID of the requested tournament
         */
        id: string;
    };
    query?: {
        limit?: number;
    };
    url: '/football/tournament/{id}/rankings';
};

export type GetTournamentRankingsTournamentResponses = {
    /**
     * Success
     */
    200: Array<TournamentRanking>;
};

export type GetTournamentRankingsTournamentResponse = GetTournamentRankingsTournamentResponses[keyof GetTournamentRankingsTournamentResponses];

export type GetTournamentBracketTournamentData = {
    body?: never;
    path: {
        /**
         * OPTA ID of the requested tournament
         */
        id: string;
    };
    query?: {
        cache?: boolean;
    };
    url: '/football/tournament/{id}/bracket';
};

export type getTournamentBracketTournamentErrors = {
    /**
     * Not Found
     */
    404: NotFound;
};

export type getTournamentBracketTournamentError = getTournamentBracketTournamentErrors[keyof getTournamentBracketTournamentErrors];

export type GetTournamentBracketTournamentResponses = {
    /**
     * Success
     */
    200: TournamentBracket;
};

export type GetTournamentBracketTournamentResponse = GetTournamentBracketTournamentResponses[keyof GetTournamentBracketTournamentResponses];

export type GetTournamentRoundsTournamentData = {
    body?: never;
    path: {
        /**
         * OPTA ID of the requested tournament
         */
        id: string;
    };
    query?: never;
    url: '/football/tournament/{id}/rounds';
};

export type getTournamentRoundsTournamentErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getTournamentRoundsTournamentError = getTournamentRoundsTournamentErrors[keyof getTournamentRoundsTournamentErrors];

export type GetTournamentRoundsTournamentResponses = {
    /**
     * Success
     */
    200: Array<number>;
};

export type GetTournamentRoundsTournamentResponse = GetTournamentRoundsTournamentResponses[keyof GetTournamentRoundsTournamentResponses];

export type GetForSpecifiedDatesMatchData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Start date of matches to be returned. String in format yyyy-MM-dd.
         */
        startDate?: string;
        /**
         * End date of matches to be returned. String in format yyyy-MM-dd.
         */
        endDate?: string;
        /**
         * Only include/exclude matches that are completed
         */
        isCompleted?: boolean;
        /**
         * Bookmaker ID
         */
        bookmakerID?: number;
        /**
         * Second bookmaker ID
         */
        secondBookmakerID?: number;
        order?: Order;
        /**
         * Filter on opta competition IDs
         */
        competitionIDs?: Array<string>;
        page?: number;
        perPage?: number;
        cache?: boolean;
    };
    url: '/football/match';
};

export type GetForSpecifiedDatesMatchResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<Match>;
    };
};

export type GetForSpecifiedDatesMatchResponse = GetForSpecifiedDatesMatchResponses[keyof GetForSpecifiedDatesMatchResponses];

export type GetBySlugMatchData = {
    body?: never;
    path: {
        /**
         * Kick off date of the requested match. String in format yyyy-MM-dd.
         */
        kickOffDate: string;
        /**
         * Slug of the requested match
         */
        slug: string;
    };
    query?: {
        /**
         * Bookmaker ID
         */
        bookmakerID?: number;
        /**
         * Second bookmaker ID
         */
        secondBookmakerID?: number;
        cache?: boolean;
    };
    url: '/football/match/slug/{kickOffDate}/{slug}';
};

export type GetBySlugMatchResponses = {
    /**
     * Success
     */
    200: Match;
};

export type GetBySlugMatchResponse = GetBySlugMatchResponses[keyof GetBySlugMatchResponses];

export type GetMatchDetailsMatchData = {
    body?: never;
    path: {
        /**
         * OPTA ID of the requested match
         */
        id: string;
    };
    query?: {
        /**
         * Bookmaker ID
         */
        bookmakerID?: number;
        /**
         * Second bookmaker ID
         */
        secondBookmakerID?: number;
        cache?: boolean;
    };
    url: '/football/match/{id}/detail';
};

export type GetMatchDetailsMatchResponses = {
    /**
     * Success
     */
    200: Match;
};

export type GetMatchDetailsMatchResponse = GetMatchDetailsMatchResponses[keyof GetMatchDetailsMatchResponses];

export type GetMatchDetailsBySlugMatchData = {
    body?: never;
    path: {
        /**
         * Kick off date of the requested match. String in format yyyy-MM-dd.
         */
        kickOffDate: string;
        /**
         * Slug of the requested match
         */
        slug: string;
    };
    query?: {
        /**
         * Bookmaker ID
         */
        bookmakerID?: number;
        /**
         * Second bookmaker ID
         */
        secondBookmakerID?: number;
        cache?: boolean;
    };
    url: '/football/match/slug/{kickOffDate}/{slug}/detail';
};

export type GetMatchDetailsBySlugMatchResponses = {
    /**
     * Success
     */
    200: Match;
};

export type GetMatchDetailsBySlugMatchResponse = GetMatchDetailsBySlugMatchResponses[keyof GetMatchDetailsBySlugMatchResponses];

export type SearchMatchData = {
    body?: never;
    path?: never;
    query: {
        search: string;
        cache?: boolean;
    };
    url: '/football/match/search';
};

export type searchMatchErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type searchMatchError = searchMatchErrors[keyof searchMatchErrors];

export type SearchMatchResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<Match>;
    };
};

export type SearchMatchResponse = SearchMatchResponses[keyof SearchMatchResponses];

export type GetForTournamentMatchData = {
    body?: never;
    path: {
        /**
         * Tournament that matches should be returned from.
         */
        tournamentID: string;
    };
    query?: {
        startDate?: string;
        endDate?: string;
        /**
         * Only include/exclude matches that are completed
         */
        isCompleted?: boolean;
        bookmakerID?: number;
        secondBookmakerID?: number;
        order?: Order;
        page?: number;
        perPage?: number;
        cache?: boolean;
    };
    url: '/football/match/tournament/{tournamentID}';
};

export type GetForTournamentMatchResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<Match>;
    };
};

export type GetForTournamentMatchResponse = GetForTournamentMatchResponses[keyof GetForTournamentMatchResponses];

export type GetForCompetitionMatchData = {
    body?: never;
    path: {
        /**
         * Tournament that matches should be returned from.
         */
        competitionID: string;
    };
    query?: {
        startDate?: string;
        endDate?: string;
        /**
         * Only include/exclude matches that are completed
         */
        isCompleted?: boolean;
        bookmakerID?: number;
        secondBookmakerID?: number;
        order?: Order;
        page?: number;
        perPage?: number;
        cache?: boolean;
    };
    url: '/football/match/competition/{competitionID}';
};

export type GetForCompetitionMatchResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<Match>;
    };
};

export type GetForCompetitionMatchResponse = GetForCompetitionMatchResponses[keyof GetForCompetitionMatchResponses];

export type GetForTeamMatchData = {
    body?: never;
    path: {
        /**
         * Team whose matches should be returned
         */
        teamID: string;
    };
    query?: {
        startDate?: string;
        endDate?: string;
        /**
         * Only include/exclude matches that are completed
         */
        isCompleted?: boolean;
        /**
         * Bookmaker ID
         */
        bookmakerID?: number;
        /**
         * Second bookmaker ID
         */
        secondBookmakerID?: number;
        order?: Order;
        page?: number;
        perPage?: number;
        cache?: boolean;
    };
    url: '/football/match/team/{teamID}';
};

export type GetForTeamMatchResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<Match>;
    };
};

export type GetForTeamMatchResponse = GetForTeamMatchResponses[keyof GetForTeamMatchResponses];

export type GetByIdsMatchData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * List of Opta match IDs
         */
        ids?: Array<string>;
        /**
         * Bookmaker ID
         */
        bookmakerID?: number;
        /**
         * Second bookmaker ID
         */
        secondBookmakerID?: number;
        cache?: boolean;
    };
    url: '/football/match/ids';
};

export type GetByIdsMatchResponses = {
    /**
     * Success
     */
    200: Array<Match>;
};

export type GetByIdsMatchResponse = GetByIdsMatchResponses[keyof GetByIdsMatchResponses];

export type GetMatchesWithOddsMatchData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Filter tags by multiple team optaIDs.
         */
        optaIDs?: Array<string>;
        /**
         * amount of matches
         */
        limit?: number;
        /**
         * Bookmaker ID
         */
        bookmakerID?: number;
        /**
         * Second bookmaker ID
         */
        secondBookmakerID?: number;
        cache?: boolean;
    };
    url: '/football/match/with-odds';
};

export type GetMatchesWithOddsMatchResponses = {
    /**
     * Success
     */
    200: Array<Match>;
};

export type GetMatchesWithOddsMatchResponse = GetMatchesWithOddsMatchResponses[keyof GetMatchesWithOddsMatchResponses];

export type GetByIdMatchData = {
    body?: never;
    path: {
        /**
         * OPTA ID of the requested match
         */
        id: string;
    };
    query?: {
        /**
         * Bookmaker ID
         */
        bookmakerID?: number;
        /**
         * Second bookmaker ID
         */
        secondBookmakerID?: number;
        cache?: boolean;
    };
    url: '/football/match/{id}';
};

export type GetByIdMatchResponses = {
    /**
     * Success
     */
    200: Match;
};

export type GetByIdMatchResponse = GetByIdMatchResponses[keyof GetByIdMatchResponses];

export type GetTeamExportOptaExportData = {
    body?: never;
    path: {
        /**
         * OPTA ID of the requested team
         */
        id: string;
    };
    query?: {
        /**
         * OPTA ID of the requested player
         */
        playerID?: string;
    };
    url: '/football/opta-export/team/{id}';
};

export type GetTeamExportOptaExportResponses = {
    /**
     * Success
     */
    200: MagazineExport;
};

export type GetTeamExportOptaExportResponse = GetTeamExportOptaExportResponses[keyof GetTeamExportOptaExportResponses];

export type GetStandingsExportOptaExportData = {
    body?: never;
    path: {
        /**
         * OPTA ID of the requested tournament
         */
        id: string;
    };
    query?: never;
    url: '/football/opta-export/standings/{id}';
};

export type getStandingsExportOptaExportErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getStandingsExportOptaExportError = getStandingsExportOptaExportErrors[keyof getStandingsExportOptaExportErrors];

export type GetStandingsExportOptaExportResponses = {
    /**
     * Success
     */
    200: MagazineExport;
};

export type GetStandingsExportOptaExportResponse = GetStandingsExportOptaExportResponses[keyof GetStandingsExportOptaExportResponses];

export type GetScheduleExportOptaExportData = {
    body?: never;
    path: {
        /**
         * OPTA ID of the requested tournament
         */
        id: string;
    };
    query?: {
        /**
         * # of days in the future
         */
        days?: number;
    };
    url: '/football/opta-export/schedule/{id}';
};

export type getScheduleExportOptaExportErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getScheduleExportOptaExportError = getScheduleExportOptaExportErrors[keyof getScheduleExportOptaExportErrors];

export type GetScheduleExportOptaExportResponses = {
    /**
     * Success
     */
    200: MagazineExport;
};

export type GetScheduleExportOptaExportResponse = GetScheduleExportOptaExportResponses[keyof GetScheduleExportOptaExportResponses];

export type GetRankingExportOptaExportData = {
    body?: never;
    path: {
        /**
         * OPTA ID of the requested tournament
         */
        id: string;
    };
    query: {
        type: ExportRankingType;
    };
    url: '/football/opta-export/rankings/{id}';
};

export type getRankingExportOptaExportErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getRankingExportOptaExportError = getRankingExportOptaExportErrors[keyof getRankingExportOptaExportErrors];

export type GetRankingExportOptaExportResponses = {
    /**
     * Success
     */
    200: MagazineExport;
};

export type GetRankingExportOptaExportResponse = GetRankingExportOptaExportResponses[keyof GetRankingExportOptaExportResponses];

export type GetRatingExportOptaExportData = {
    body?: never;
    path: {
        /**
         * OPTA ID of the requested tournament
         */
        id: string;
    };
    query: {
        type: RatingType;
        /**
         * Round for which the results will be filtered
         */
        round?: number;
        /**
         * length of the list
         */
        limit?: number;
    };
    url: '/football/opta-export/rating/{id}';
};

export type getRatingExportOptaExportErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getRatingExportOptaExportError = getRatingExportOptaExportErrors[keyof getRatingExportOptaExportErrors];

export type GetRatingExportOptaExportResponses = {
    /**
     * Success
     */
    200: MagazineExport;
};

export type GetRatingExportOptaExportResponse = GetRatingExportOptaExportResponses[keyof GetRatingExportOptaExportResponses];

export type GetCompetitionMatchesExportOptaExportData = {
    body?: never;
    path?: never;
    query: {
        /**
         * competition IDs of the requested matches
         */
        competitionIDs?: Array<string>;
        /**
         * Start date of matches to be returned. String in format yyyy-MM-dd.
         */
        startDate: string;
        /**
         * End date of matches to be returned. String in format yyyy-MM-dd.
         */
        endDate: string;
        /**
         * opta IDs of the requested matches
         */
        matchIDs?: Array<string>;
    };
    url: '/football/opta-export/competition/matches';
};

export type getCompetitionMatchesExportOptaExportErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getCompetitionMatchesExportOptaExportError = getCompetitionMatchesExportOptaExportErrors[keyof getCompetitionMatchesExportOptaExportErrors];

export type GetCompetitionMatchesExportOptaExportResponses = {
    /**
     * Success
     */
    200: MagazineExport;
};

export type GetCompetitionMatchesExportOptaExportResponse = GetCompetitionMatchesExportOptaExportResponses[keyof GetCompetitionMatchesExportOptaExportResponses];

export type GetNationalMatchesExportOptaExportData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * opta IDs of the requested matches
         */
        matchIDs?: Array<string>;
    };
    url: '/football/opta-export/national/matches';
};

export type getNationalMatchesExportOptaExportErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getNationalMatchesExportOptaExportError = getNationalMatchesExportOptaExportErrors[keyof getNationalMatchesExportOptaExportErrors];

export type GetNationalMatchesExportOptaExportResponses = {
    /**
     * Success
     */
    200: Array<MagazineExport>;
};

export type GetNationalMatchesExportOptaExportResponse = GetNationalMatchesExportOptaExportResponses[keyof GetNationalMatchesExportOptaExportResponses];

export type ImportTournamentsOptaImportData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/football/import/tournaments';
};

export type importTournamentsOptaImportErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type importTournamentsOptaImportError = importTournamentsOptaImportErrors[keyof importTournamentsOptaImportErrors];

export type ImportTournamentsOptaImportResponses = {
    /**
     * Success
     */
    200: {
        [key: string]: unknown;
    };
};

export type ImportTournamentsOptaImportResponse = ImportTournamentsOptaImportResponses[keyof ImportTournamentsOptaImportResponses];

export type ImportTeamsOptaImportData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/football/import/teams';
};

export type importTeamsOptaImportErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type importTeamsOptaImportError = importTeamsOptaImportErrors[keyof importTeamsOptaImportErrors];

export type ImportTeamsOptaImportResponses = {
    /**
     * Success
     */
    200: {
        [key: string]: unknown;
    };
};

export type ImportTeamsOptaImportResponse = ImportTeamsOptaImportResponses[keyof ImportTeamsOptaImportResponses];

export type ImportMatchesOptaImportData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Import a single competition, replaces normal fetch competitions logic
         */
        optaID?: string;
        /**
         * Start date of import. Only applied with single competition (optaID). String in format yyyy-MM-dd.
         */
        startDate?: string;
    };
    url: '/football/import/matches';
};

export type importMatchesOptaImportErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type importMatchesOptaImportError = importMatchesOptaImportErrors[keyof importMatchesOptaImportErrors];

export type ImportMatchesOptaImportResponses = {
    /**
     * Success
     */
    200: {
        [key: string]: unknown;
    };
};

export type ImportMatchesOptaImportResponse = ImportMatchesOptaImportResponses[keyof ImportMatchesOptaImportResponses];

export type EmitMatchEventsOptaImportData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/football/import/matches/events';
};

export type emitMatchEventsOptaImportErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type emitMatchEventsOptaImportError = emitMatchEventsOptaImportErrors[keyof emitMatchEventsOptaImportErrors];

export type EmitMatchEventsOptaImportResponses = {
    /**
     * Success
     */
    200: {
        [key: string]: unknown;
    };
};

export type EmitMatchEventsOptaImportResponse = EmitMatchEventsOptaImportResponses[keyof EmitMatchEventsOptaImportResponses];

export type UpdatePlayerTagsOptaImportData = {
    body?: never;
    path: {
        optaID: string;
    };
    query?: never;
    url: '/football/import/update-player-tags/{optaID}';
};

export type updatePlayerTagsOptaImportErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type updatePlayerTagsOptaImportError = updatePlayerTagsOptaImportErrors[keyof updatePlayerTagsOptaImportErrors];

export type UpdatePlayerTagsOptaImportResponses = {
    /**
     * Success
     */
    200: {
        [key: string]: unknown;
    };
};

export type UpdatePlayerTagsOptaImportResponse = UpdatePlayerTagsOptaImportResponses[keyof UpdatePlayerTagsOptaImportResponses];

export type ListResultsAiData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * current page
         */
        page?: number;
        /**
         * amount of items per page
         */
        perPage?: number;
        /**
         * filter by aiPromptID
         */
        aiPromptID?: number;
        cache?: boolean;
    };
    url: '/football/ai/result';
};

export type listResultsAiErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type listResultsAiError = listResultsAiErrors[keyof listResultsAiErrors];

export type ListResultsAiResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<AIResult>;
    };
};

export type ListResultsAiResponse = ListResultsAiResponses[keyof ListResultsAiResponses];

export type MatchReportsAiData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * current page
         */
        page?: number;
        /**
         * amount of items per page
         */
        perPage?: number;
        cache?: boolean;
    };
    url: '/football/ai/match-reports';
};

export type matchReportsAiErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type matchReportsAiError = matchReportsAiErrors[keyof matchReportsAiErrors];

export type MatchReportsAiResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<MatchReport>;
    };
};

export type MatchReportsAiResponse = MatchReportsAiResponses[keyof MatchReportsAiResponses];

export type LatestMatchReportsAiData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * current page
         */
        page?: number;
        /**
         * amount of items per page
         */
        perPage?: number;
        cache?: boolean;
    };
    url: '/football/ai/latest-match-reports';
};

export type LatestMatchReportsAiResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<MatchReport>;
    };
};

export type LatestMatchReportsAiResponse = LatestMatchReportsAiResponses[keyof LatestMatchReportsAiResponses];

export type GenerateMatchReportAiData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * optaID of the match to generate the report for
         */
        matchID?: string;
        /**
         * aiPromptID of the prompt to use
         */
        aiPromptID?: number;
    };
    url: '/football/ai/generate-match-report';
};

export type generateMatchReportAiErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type generateMatchReportAiError = generateMatchReportAiErrors[keyof generateMatchReportAiErrors];

export type GenerateMatchReportAiResponses = {
    /**
     * Success
     */
    200: MatchReport;
};

export type GenerateMatchReportAiResponse = GenerateMatchReportAiResponses[keyof GenerateMatchReportAiResponses];

export type GenerateMatchReportsAiData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/football/ai/import/reports';
};

export type generateMatchReportsAiErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type generateMatchReportsAiError = generateMatchReportsAiErrors[keyof generateMatchReportsAiErrors];

export type GenerateMatchReportsAiResponses = {
    /**
     * Success
     */
    200: {
        [key: string]: unknown;
    };
};

export type GenerateMatchReportsAiResponse = GenerateMatchReportsAiResponses[keyof GenerateMatchReportsAiResponses];

export type ListAiPromptData = {
    body?: never;
    path?: never;
    query?: {
        type?: AIPromptType;
        model?: AIPromptModel;
        /**
         * current page
         */
        page?: number;
        /**
         * amount of items per page
         */
        perPage?: number;
        cache?: boolean;
    };
    url: '/football/ai-prompts';
};

export type listAiPromptErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type listAiPromptError = listAiPromptErrors[keyof listAiPromptErrors];

export type ListAiPromptResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<AIPrompt>;
    };
};

export type ListAiPromptResponse = ListAiPromptResponses[keyof ListAiPromptResponses];

export type CreateAiPromptData = {
    /**
     * will be used to create an AI Prompt
     */
    body: AiPromptBaseActionCreate;
    path?: never;
    query?: never;
    url: '/football/ai-prompts/prompt';
};

export type createAiPromptErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createAiPromptError = createAiPromptErrors[keyof createAiPromptErrors];

export type CreateAiPromptResponses = {
    /**
     * Created
     */
    201: AIPrompt;
};

export type CreateAiPromptResponse = CreateAiPromptResponses[keyof CreateAiPromptResponses];

export type DeleteAiPromptData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/football/ai-prompts/{id}';
};

export type deleteAiPromptErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteAiPromptError = deleteAiPromptErrors[keyof deleteAiPromptErrors];

export type DeleteAiPromptResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteAiPromptResponse = DeleteAiPromptResponses[keyof DeleteAiPromptResponses];

export type UpdateAiPromptData = {
    /**
     * will be used to update a specific aiPrompt
     */
    body: AiPromptActionUpdate;
    path: {
        /**
         * will be used to update a specific aiPrompt
         */
        id: number;
    };
    query?: never;
    url: '/football/ai-prompts/{id}';
};

export type updateAiPromptErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type updateAiPromptError = updateAiPromptErrors[keyof updateAiPromptErrors];

export type UpdateAiPromptResponses = {
    /**
     * Success
     */
    200: AIPrompt;
};

export type UpdateAiPromptResponse = UpdateAiPromptResponses[keyof UpdateAiPromptResponses];

export type ListAuditLogByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
    };
    query?: {
        /**
         * Current page
         */
        page?: number;
        /**
         * Amount of items per page
         */
        perPage?: number;
        /**
         * Filter logs by the ID of a specific administrator
         */
        userID?: number;
        /**
         * Filter logs by the ID of the user subjected to the action
         */
        affectedUserID?: number;
        cache?: boolean;
    };
    url: '/domain/{contextID}/audit-log';
};

export type listAuditLogByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type listAuditLogByDomainIdError = listAuditLogByDomainIdErrors[keyof listAuditLogByDomainIdErrors];

export type ListAuditLogByDomainIdResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<AuditLog>;
    };
};

export type ListAuditLogByDomainIdResponse = ListAuditLogByDomainIdResponses[keyof ListAuditLogByDomainIdResponses];

export type ListExperimentByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
    };
    query?: {
        /**
         * Current page
         */
        page?: number;
        /**
         * Amount of items per page
         */
        perPage?: number;
        cache?: boolean;
    };
    url: '/domain/{contextID}/experiment';
};

export type listExperimentByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type listExperimentByDomainIdError = listExperimentByDomainIdErrors[keyof listExperimentByDomainIdErrors];

export type ListExperimentByDomainIdResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<Experiment>;
    };
};

export type ListExperimentByDomainIdResponse = ListExperimentByDomainIdResponses[keyof ListExperimentByDomainIdResponses];

export type ListFilteredCommentByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
    };
    query?: {
        /**
         * Current page
         */
        page?: number;
        /**
         * Amount of items per page
         */
        perPage?: number;
        search?: string;
        cache?: boolean;
    };
    url: '/domain/{contextID}/filtered-comment';
};

export type listFilteredCommentByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type listFilteredCommentByDomainIdError = listFilteredCommentByDomainIdErrors[keyof listFilteredCommentByDomainIdErrors];

export type ListFilteredCommentByDomainIdResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<FilteredComment>;
    };
};

export type ListFilteredCommentByDomainIdResponse = ListFilteredCommentByDomainIdResponses[keyof ListFilteredCommentByDomainIdResponses];

export type ListForbiddenWordByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
    };
    query?: {
        /**
         * Search for forbidden words that contain the given search term.
         */
        search?: string;
        page?: number;
        perPage?: number;
        cache?: boolean;
    };
    url: '/domain/{contextID}/forbidden-word';
};

export type listForbiddenWordByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type listForbiddenWordByDomainIdError = listForbiddenWordByDomainIdErrors[keyof listForbiddenWordByDomainIdErrors];

export type ListForbiddenWordByDomainIdResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<ForbiddenWord>;
    };
};

export type ListForbiddenWordByDomainIdResponse = ListForbiddenWordByDomainIdResponses[keyof ListForbiddenWordByDomainIdResponses];

export type CreateForbiddenWordByDomainIdData = {
    body: ForbiddenWordActionCreate;
    path: {
        contextID: number;
    };
    query?: never;
    url: '/domain/{contextID}/forbidden-word';
};

export type createForbiddenWordByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createForbiddenWordByDomainIdError = createForbiddenWordByDomainIdErrors[keyof createForbiddenWordByDomainIdErrors];

export type CreateForbiddenWordByDomainIdResponses = {
    /**
     * Created
     */
    201: ForbiddenWord;
};

export type CreateForbiddenWordByDomainIdResponse = CreateForbiddenWordByDomainIdResponses[keyof CreateForbiddenWordByDomainIdResponses];

export type DeleteForbiddenWordByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
        id: number;
    };
    query?: never;
    url: '/domain/{contextID}/forbidden-word/{id}';
};

export type deleteForbiddenWordByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteForbiddenWordByDomainIdError = deleteForbiddenWordByDomainIdErrors[keyof deleteForbiddenWordByDomainIdErrors];

export type DeleteForbiddenWordByDomainIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteForbiddenWordByDomainIdResponse = DeleteForbiddenWordByDomainIdResponses[keyof DeleteForbiddenWordByDomainIdResponses];

export type GetForbiddenWordByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
        /**
         * Get forbidden word by id
         */
        id: number;
    };
    query?: {
        cache?: boolean;
    };
    url: '/domain/{contextID}/forbidden-word/{id}';
};

export type GetForbiddenWordByDomainIdResponses = {
    /**
     * Success
     */
    200: ForbiddenWord;
};

export type GetForbiddenWordByDomainIdResponse = GetForbiddenWordByDomainIdResponses[keyof GetForbiddenWordByDomainIdResponses];

export type UpdateForbiddenWordByDomainIdData = {
    body: ForbiddenWordActionPatch;
    path: {
        contextID: number;
        id: number;
    };
    query?: never;
    url: '/domain/{contextID}/forbidden-word/{id}';
};

export type updateForbiddenWordByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type updateForbiddenWordByDomainIdError = updateForbiddenWordByDomainIdErrors[keyof updateForbiddenWordByDomainIdErrors];

export type UpdateForbiddenWordByDomainIdResponses = {
    /**
     * Success
     */
    200: ForbiddenWord;
};

export type UpdateForbiddenWordByDomainIdResponse = UpdateForbiddenWordByDomainIdResponses[keyof UpdateForbiddenWordByDomainIdResponses];

export type ListRedirectByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
    };
    query?: {
        /**
         * Current page
         */
        page?: number;
        /**
         * Amount of items per page
         */
        perPage?: number;
        /**
         * Filter on isRegex
         */
        isRegex?: boolean;
        cache?: boolean;
    };
    url: '/domain/{contextID}/redirect';
};

export type ListRedirectByDomainIdResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<Redirect>;
    };
};

export type ListRedirectByDomainIdResponse = ListRedirectByDomainIdResponses[keyof ListRedirectByDomainIdResponses];

export type CreateRedirectByDomainIdData = {
    body: RedirectCreate;
    path: {
        contextID: number;
    };
    query?: never;
    url: '/domain/{contextID}/redirect';
};

export type createRedirectByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createRedirectByDomainIdError = createRedirectByDomainIdErrors[keyof createRedirectByDomainIdErrors];

export type CreateRedirectByDomainIdResponses = {
    /**
     * Created
     */
    201: Redirect;
};

export type CreateRedirectByDomainIdResponse = CreateRedirectByDomainIdResponses[keyof CreateRedirectByDomainIdResponses];

export type DeleteRedirectByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
        /**
         * Get redirect by id
         */
        id: number;
    };
    query?: never;
    url: '/domain/{contextID}/redirect/{id}';
};

export type deleteRedirectByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteRedirectByDomainIdError = deleteRedirectByDomainIdErrors[keyof deleteRedirectByDomainIdErrors];

export type DeleteRedirectByDomainIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteRedirectByDomainIdResponse = DeleteRedirectByDomainIdResponses[keyof DeleteRedirectByDomainIdResponses];

export type GetRedirectByDomainIdData = {
    body?: never;
    path: {
        contextID: number;
        /**
         * Get redirect by id
         */
        id: number;
    };
    query?: {
        cache?: boolean;
    };
    url: '/domain/{contextID}/redirect/{id}';
};

export type getRedirectByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getRedirectByDomainIdError = getRedirectByDomainIdErrors[keyof getRedirectByDomainIdErrors];

export type GetRedirectByDomainIdResponses = {
    /**
     * Success
     */
    200: Redirect;
};

export type GetRedirectByDomainIdResponse = GetRedirectByDomainIdResponses[keyof GetRedirectByDomainIdResponses];

export type PutRedirectByDomainIdData = {
    body: RedirectUpdate;
    path: {
        contextID: number;
        /**
         * Get redirect by id
         */
        id: number;
    };
    query?: never;
    url: '/domain/{contextID}/redirect/{id}';
};

export type putRedirectByDomainIdErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type putRedirectByDomainIdError = putRedirectByDomainIdErrors[keyof putRedirectByDomainIdErrors];

export type PutRedirectByDomainIdResponses = {
    /**
     * Success
     */
    200: Redirect;
};

export type PutRedirectByDomainIdResponse = PutRedirectByDomainIdResponses[keyof PutRedirectByDomainIdResponses];

export type ListIgnoredUserData = {
    body?: never;
    path?: never;
    query?: {
        cache?: boolean;
    };
    url: '/user/ignore';
};

export type listIgnoredUserErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type listIgnoredUserError = listIgnoredUserErrors[keyof listIgnoredUserErrors];

export type ListIgnoredUserResponses = {
    /**
     * Success
     */
    200: Array<number>;
};

export type ListIgnoredUserResponse = ListIgnoredUserResponses[keyof ListIgnoredUserResponses];

export type AddIgnoredUserData = {
    body: Array<number>;
    path?: never;
    query?: never;
    url: '/user/ignore';
};

export type addIgnoredUserErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type addIgnoredUserError = addIgnoredUserErrors[keyof addIgnoredUserErrors];

export type AddIgnoredUserResponses = {
    /**
     * Created
     */
    201: Array<number>;
};

export type AddIgnoredUserResponse = AddIgnoredUserResponses[keyof AddIgnoredUserResponses];

export type DeleteIgnoredUserData = {
    body?: never;
    path: {
        /**
         * userID of the user that should be removed from the current user's ignored user list
         */
        userID: number;
    };
    query?: never;
    url: '/user/ignore/{userID}';
};

export type deleteIgnoredUserErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteIgnoredUserError = deleteIgnoredUserErrors[keyof deleteIgnoredUserErrors];

export type DeleteIgnoredUserResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteIgnoredUserResponse = DeleteIgnoredUserResponses[keyof DeleteIgnoredUserResponses];

export type SyncKambiData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/kambi/sync';
};

export type syncKambiErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type syncKambiError = syncKambiErrors[keyof syncKambiErrors];

export type SyncKambiResponses = {
    /**
     * Success
     */
    200: KambiSyncResult;
};

export type SyncKambiResponse = SyncKambiResponses[keyof SyncKambiResponses];

export type ListLocaleByLocaleData = {
    body?: never;
    path?: never;
    query?: {
        page?: number;
        perPage?: number;
        cache?: boolean;
    };
    url: '/locale';
};

export type listLocaleByLocaleErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type listLocaleByLocaleError = listLocaleByLocaleErrors[keyof listLocaleByLocaleErrors];

export type ListLocaleByLocaleResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<Locale>;
    };
};

export type ListLocaleByLocaleResponse = ListLocaleByLocaleResponses[keyof ListLocaleByLocaleResponses];

export type CreateLokaliseData = {
    body: LokaliseKey;
    path?: never;
    query?: never;
    url: '/lokalise/key';
};

export type CreateLokaliseResponses = {
    /**
     * Created
     */
    201: LokaliseKey;
};

export type CreateLokaliseResponse = CreateLokaliseResponses[keyof CreateLokaliseResponses];

export type DeleteOldMatchOddsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/match-odds';
};

export type deleteOldMatchOddsErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteOldMatchOddsError = deleteOldMatchOddsErrors[keyof deleteOldMatchOddsErrors];

export type DeleteOldMatchOddsResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteOldMatchOddsResponse = DeleteOldMatchOddsResponses[keyof DeleteOldMatchOddsResponses];

export type ListMatchOddsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * current page
         */
        page?: number;
        /**
         * amount of items per page
         */
        perPage?: number;
        cache?: boolean;
    };
    url: '/match-odds';
};

export type ListMatchOddsResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<MatchOdds>;
    };
};

export type ListMatchOddsResponse = ListMatchOddsResponses[keyof ListMatchOddsResponses];

export type GetDeprecatedMobileConfigData = {
    body?: never;
    path?: never;
    query: {
        client: MobileConfigClient;
        cache?: boolean;
    };
    url: '/mobile-config';
};

export type GetDeprecatedMobileConfigResponses = {
    /**
     * Success
     */
    200: DeprecatedMobileConfig;
};

export type GetDeprecatedMobileConfigResponse = GetDeprecatedMobileConfigResponses[keyof GetDeprecatedMobileConfigResponses];

export type GetMonitoringData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/monitoring/status';
};

export type GetMonitoringResponses = {
    /**
     * Success
     */
    200: string;
};

export type GetMonitoringResponse = GetMonitoringResponses[keyof GetMonitoringResponses];

export type GetMemoryUsageMonitoringData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/monitoring/memory';
};

export type GetMemoryUsageMonitoringResponses = {
    /**
     * Success
     */
    200: {
        [key: string]: unknown;
    };
};

export type GetMemoryUsageMonitoringResponse = GetMemoryUsageMonitoringResponses[keyof GetMemoryUsageMonitoringResponses];

export type GetMemorySnapshotMonitoringData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/monitoring/memory-snapshot';
};

export type getMemorySnapshotMonitoringErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getMemorySnapshotMonitoringError = getMemorySnapshotMonitoringErrors[keyof getMemorySnapshotMonitoringErrors];

export type GetMemorySnapshotMonitoringResponses = {
    /**
     * Success
     */
    200: {
        [key: string]: unknown;
    };
};

export type GetMemorySnapshotMonitoringResponse = GetMemorySnapshotMonitoringResponses[keyof GetMemorySnapshotMonitoringResponses];

export type GetPlatformByPlatformData = {
    body?: never;
    path: {
        platform: PlatformID;
    };
    query?: {
        cache?: boolean;
    };
    url: '/platform/{platform}';
};

export type GetPlatformByPlatformResponses = {
    /**
     * Success
     */
    200: Platform;
};

export type GetPlatformByPlatformResponse = GetPlatformByPlatformResponses[keyof GetPlatformByPlatformResponses];

export type GetContextsPlatformByPlatformData = {
    body?: never;
    path: {
        platform: PlatformID;
    };
    query?: {
        cache?: boolean;
    };
    url: '/platform/{platform}/contexts';
};

export type GetContextsPlatformByPlatformResponses = {
    /**
     * Success
     */
    200: Array<FullContext>;
};

export type GetContextsPlatformByPlatformResponse = GetContextsPlatformByPlatformResponses[keyof GetContextsPlatformByPlatformResponses];

export type GetAdsTxtByPlatformData = {
    body?: never;
    path: {
        platform: PlatformID;
    };
    query?: {
        cache?: boolean;
    };
    url: '/platform/{platform}/ads-txt';
};

export type GetAdsTxtByPlatformResponses = {
    /**
     * Success
     */
    200: AdsTxt;
};

export type GetAdsTxtByPlatformResponse = GetAdsTxtByPlatformResponses[keyof GetAdsTxtByPlatformResponses];

export type UpsertAdsTxtByPlatformData = {
    body: AdsTxtPatch;
    path: {
        platform: PlatformID;
    };
    query?: never;
    url: '/platform/{platform}/ads-txt';
};

export type upsertAdsTxtByPlatformErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type upsertAdsTxtByPlatformError = upsertAdsTxtByPlatformErrors[keyof upsertAdsTxtByPlatformErrors];

export type UpsertAdsTxtByPlatformResponses = {
    /**
     * Success
     */
    200: AdsTxt;
    /**
     * Created
     */
    201: AdsTxt;
};

export type UpsertAdsTxtByPlatformResponse = UpsertAdsTxtByPlatformResponses[keyof UpsertAdsTxtByPlatformResponses];

export type ListCommentByPlatformData = {
    body?: never;
    path: {
        /**
         * will return items for a specific platform
         */
        platform: PlatformID;
    };
    query?: {
        scope?: Scope;
        status?: CommentStatusFilter;
        newsID?: number;
        startDateTime?: string;
        endDateTime?: string;
        nested?: boolean;
        orderBy?: CommentOrderByOption;
        order?: Order;
        /**
         * current page
         */
        page?: number;
        /**
         * amount of items per page
         */
        perPage?: number;
        cache?: boolean;
    };
    url: '/platform/{platform}/comment';
};

export type ListCommentByPlatformResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<CommentFull>;
    };
};

export type ListCommentByPlatformResponse = ListCommentByPlatformResponses[keyof ListCommentByPlatformResponses];

export type UpdateMultipleCommentByPlatformData = {
    body: CommentUpdateList;
    path: {
        /**
         * will return items for a specific platform
         */
        platform: PlatformID;
    };
    query?: never;
    url: '/platform/{platform}/comment';
};

export type updateMultipleCommentByPlatformErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type updateMultipleCommentByPlatformError = updateMultipleCommentByPlatformErrors[keyof updateMultipleCommentByPlatformErrors];

export type UpdateMultipleCommentByPlatformResponses = {
    /**
     * Success
     */
    200: CommentUpdateListResponse;
};

export type UpdateMultipleCommentByPlatformResponse = UpdateMultipleCommentByPlatformResponses[keyof UpdateMultipleCommentByPlatformResponses];

export type CreateCommentByPlatformData = {
    body: CommentActionCreate;
    path: {
        /**
         * will return items for a specific platform
         */
        platform: PlatformID;
    };
    query: {
        client: Client;
    };
    url: '/platform/{platform}/comment';
};

export type createCommentByPlatformErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createCommentByPlatformError = createCommentByPlatformErrors[keyof createCommentByPlatformErrors];

export type CreateCommentByPlatformResponses = {
    /**
     * Created
     */
    201: CommentScopePublic;
};

export type CreateCommentByPlatformResponse = CreateCommentByPlatformResponses[keyof CreateCommentByPlatformResponses];

export type GetMostLikesCommentByPlatformData = {
    body?: never;
    path: {
        /**
         * will return items for a specific platform
         */
        platform: PlatformID;
    };
    query?: {
        cache?: boolean;
    };
    url: '/platform/{platform}/comment/most-likes';
};

export type GetMostLikesCommentByPlatformResponses = {
    /**
     * Success
     */
    200: Array<Comment>;
};

export type GetMostLikesCommentByPlatformResponse = GetMostLikesCommentByPlatformResponses[keyof GetMostLikesCommentByPlatformResponses];

export type DeleteCommentByPlatformData = {
    body?: never;
    path: {
        platform: PlatformID;
        /**
         * Will be used to remove a comment
         */
        id: number;
    };
    query?: never;
    url: '/platform/{platform}/comment/{id}';
};

export type deleteCommentByPlatformErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteCommentByPlatformError = deleteCommentByPlatformErrors[keyof deleteCommentByPlatformErrors];

export type DeleteCommentByPlatformResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteCommentByPlatformResponse = DeleteCommentByPlatformResponses[keyof DeleteCommentByPlatformResponses];

export type PatchCommentByPlatformData = {
    body: CommentActionPatch;
    path: {
        /**
         * will return items for a specific platform
         */
        platform: PlatformID;
        id: number;
    };
    query: {
        scope: Scope;
    };
    url: '/platform/{platform}/comment/{id}';
};

export type patchCommentByPlatformErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type patchCommentByPlatformError = patchCommentByPlatformErrors[keyof patchCommentByPlatformErrors];

export type PatchCommentByPlatformResponses = {
    /**
     * Success
     */
    200: CommentFull;
};

export type PatchCommentByPlatformResponse = PatchCommentByPlatformResponses[keyof PatchCommentByPlatformResponses];

export type ListFlaggedCommentByPlatformData = {
    body?: never;
    path: {
        platform: PlatformID;
    };
    query: {
        scope?: Scope;
        newsID: number;
        userID: number;
    };
    url: '/platform/{platform}/comment/flag';
};

export type listFlaggedCommentByPlatformErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type listFlaggedCommentByPlatformError = listFlaggedCommentByPlatformErrors[keyof listFlaggedCommentByPlatformErrors];

export type ListFlaggedCommentByPlatformResponses = {
    /**
     * Success
     */
    200: Array<FlaggedComment>;
};

export type ListFlaggedCommentByPlatformResponse = ListFlaggedCommentByPlatformResponses[keyof ListFlaggedCommentByPlatformResponses];

export type DeleteFlaggedCommentByPlatformData = {
    body?: never;
    path: {
        platform: PlatformID;
        commentID: number;
    };
    query?: never;
    url: '/platform/{platform}/comment/{commentID}/flag';
};

export type deleteFlaggedCommentByPlatformErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteFlaggedCommentByPlatformError = deleteFlaggedCommentByPlatformErrors[keyof deleteFlaggedCommentByPlatformErrors];

export type DeleteFlaggedCommentByPlatformResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteFlaggedCommentByPlatformResponse = DeleteFlaggedCommentByPlatformResponses[keyof DeleteFlaggedCommentByPlatformResponses];

export type CreateFlaggedCommentByPlatformData = {
    body?: never;
    path: {
        platform: PlatformID;
        commentID: number;
    };
    query?: never;
    url: '/platform/{platform}/comment/{commentID}/flag';
};

export type createFlaggedCommentByPlatformErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createFlaggedCommentByPlatformError = createFlaggedCommentByPlatformErrors[keyof createFlaggedCommentByPlatformErrors];

export type CreateFlaggedCommentByPlatformResponses = {
    /**
     * Created
     */
    201: FlaggedComment;
};

export type CreateFlaggedCommentByPlatformResponse = CreateFlaggedCommentByPlatformResponses[keyof CreateFlaggedCommentByPlatformResponses];

export type CreateLikeCommentByPlatformData = {
    body?: never;
    path: {
        platform: PlatformID;
        /**
         * Will be used to create a like
         */
        commentID: number;
    };
    query?: never;
    url: '/platform/{platform}/comment/{commentID}/like';
};

export type createLikeCommentByPlatformErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createLikeCommentByPlatformError = createLikeCommentByPlatformErrors[keyof createLikeCommentByPlatformErrors];

export type CreateLikeCommentByPlatformResponses = {
    /**
     * Created
     */
    201: NewsThumb;
};

export type CreateLikeCommentByPlatformResponse = CreateLikeCommentByPlatformResponses[keyof CreateLikeCommentByPlatformResponses];

export type DeleteLikeCommentByPlatformData = {
    body?: never;
    path: {
        platform: PlatformID;
        /**
         * Will be used to remove a like
         */
        commentID: number;
    };
    query?: never;
    url: '/platform/{platform}/comment/like/{commentID}';
};

export type deleteLikeCommentByPlatformErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteLikeCommentByPlatformError = deleteLikeCommentByPlatformErrors[keyof deleteLikeCommentByPlatformErrors];

export type DeleteLikeCommentByPlatformResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteLikeCommentByPlatformResponse = DeleteLikeCommentByPlatformResponses[keyof DeleteLikeCommentByPlatformResponses];

export type ListLikeCommentByPlatformData = {
    body?: never;
    path: {
        platform: PlatformID;
        newsID: number;
        userID: number;
    };
    query?: {
        cache?: boolean;
    };
    url: '/platform/{platform}/comment/{newsID}/{userID}/user-likes';
};

export type listLikeCommentByPlatformErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type listLikeCommentByPlatformError = listLikeCommentByPlatformErrors[keyof listLikeCommentByPlatformErrors];

export type ListLikeCommentByPlatformResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<NewsThumb>;
    };
};

export type ListLikeCommentByPlatformResponse = ListLikeCommentByPlatformResponses[keyof ListLikeCommentByPlatformResponses];

export type ListNotificationByPlatformData = {
    body?: never;
    path: {
        /**
         * will return items for a specific platform
         */
        platform: PlatformID;
    };
    query?: {
        /**
         * current page
         */
        page?: number;
        /**
         * amount of items per page
         */
        perPage?: number;
    };
    url: '/platform/{platform}/notification';
};

export type listNotificationByPlatformErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type listNotificationByPlatformError = listNotificationByPlatformErrors[keyof listNotificationByPlatformErrors];

export type ListNotificationByPlatformResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<Notification>;
    };
};

export type ListNotificationByPlatformResponse = ListNotificationByPlatformResponses[keyof ListNotificationByPlatformResponses];

export type MarkAllAsReadNotificationByPlatformData = {
    body?: never;
    path: {
        /**
         * will return items for a specific platform
         */
        platform: PlatformID;
    };
    query?: never;
    url: '/platform/{platform}/notification/mark-as-read';
};

export type markAllAsReadNotificationByPlatformErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type markAllAsReadNotificationByPlatformError = markAllAsReadNotificationByPlatformErrors[keyof markAllAsReadNotificationByPlatformErrors];

export type MarkAllAsReadNotificationByPlatformResponses = {
    /**
     * Success
     */
    200: string;
};

export type MarkAllAsReadNotificationByPlatformResponse = MarkAllAsReadNotificationByPlatformResponses[keyof MarkAllAsReadNotificationByPlatformResponses];

export type MarkAsReadNotificationByPlatformData = {
    body?: never;
    path: {
        /**
         * will return items for a specific platform
         */
        platform: PlatformID;
        /**
         * ID of the notification
         */
        id: number;
    };
    query?: never;
    url: '/platform/{platform}/notification/{id}/mark-as-read';
};

export type markAsReadNotificationByPlatformErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type markAsReadNotificationByPlatformError = markAsReadNotificationByPlatformErrors[keyof markAsReadNotificationByPlatformErrors];

export type MarkAsReadNotificationByPlatformResponses = {
    /**
     * Success
     */
    200: Notification;
};

export type MarkAsReadNotificationByPlatformResponse = MarkAsReadNotificationByPlatformResponses[keyof MarkAsReadNotificationByPlatformResponses];

export type MarkSelectedAsReadNotificationByPlatformData = {
    body: NotificationUpdateList;
    path: {
        /**
         * will return items for a specific platform
         */
        platform: PlatformID;
    };
    query?: never;
    url: '/platform/{platform}/notification/mark-selected-as-read';
};

export type markSelectedAsReadNotificationByPlatformErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type markSelectedAsReadNotificationByPlatformError = markSelectedAsReadNotificationByPlatformErrors[keyof markSelectedAsReadNotificationByPlatformErrors];

export type MarkSelectedAsReadNotificationByPlatformResponses = {
    /**
     * Success
     */
    200: NotificationUpdateListResponse;
};

export type MarkSelectedAsReadNotificationByPlatformResponse = MarkSelectedAsReadNotificationByPlatformResponses[keyof MarkSelectedAsReadNotificationByPlatformResponses];

export type GetUnreadNotificationsCountNotificationByPlatformData = {
    body?: never;
    path: {
        /**
         * will return items for a specific platform
         */
        platform: PlatformID;
    };
    query?: never;
    url: '/platform/{platform}/notification/unread-count';
};

export type getUnreadNotificationsCountNotificationByPlatformErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getUnreadNotificationsCountNotificationByPlatformError = getUnreadNotificationsCountNotificationByPlatformErrors[keyof getUnreadNotificationsCountNotificationByPlatformErrors];

export type GetUnreadNotificationsCountNotificationByPlatformResponses = {
    /**
     * Success
     */
    200: NotificationCountContainer;
};

export type GetUnreadNotificationsCountNotificationByPlatformResponse = GetUnreadNotificationsCountNotificationByPlatformResponses[keyof GetUnreadNotificationsCountNotificationByPlatformResponses];

export type NavigationSitemapByPlatformData = {
    body?: never;
    path: {
        platform: PlatformID;
    };
    query?: {
        cache?: boolean;
    };
    url: '/platform/{platform}/sitemap/navigation';
};

export type NavigationSitemapByPlatformResponses = {
    /**
     * Success
     */
    200: Array<SitemapEntry>;
};

export type NavigationSitemapByPlatformResponse = NavigationSitemapByPlatformResponses[keyof NavigationSitemapByPlatformResponses];

export type IndexSitemapByPlatformData = {
    body?: never;
    path: {
        platform: PlatformID;
    };
    query?: {
        cache?: boolean;
    };
    url: '/platform/{platform}/sitemap/index';
};

export type IndexSitemapByPlatformResponses = {
    /**
     * Success
     */
    200: Array<SitemapIndexEntry>;
};

export type IndexSitemapByPlatformResponse = IndexSitemapByPlatformResponses[keyof IndexSitemapByPlatformResponses];

export type NewsSitemapByPlatformData = {
    body?: never;
    path: {
        platform: PlatformID;
    };
    query: {
        year: number;
        week?: number;
        quarter?: number;
        cache?: boolean;
    };
    url: '/platform/{platform}/sitemap/news';
};

export type NewsSitemapByPlatformResponses = {
    /**
     * Success
     */
    200: Array<SitemapEntry>;
};

export type NewsSitemapByPlatformResponse = NewsSitemapByPlatformResponses[keyof NewsSitemapByPlatformResponses];

export type TagsSitemapByPlatformData = {
    body?: never;
    path: {
        platform: PlatformID;
    };
    query: {
        tagType: string;
        from?: number;
        to?: number;
        cache?: boolean;
    };
    url: '/platform/{platform}/sitemap/tag';
};

export type TagsSitemapByPlatformResponses = {
    /**
     * Success
     */
    200: Array<SitemapEntry>;
};

export type TagsSitemapByPlatformResponse = TagsSitemapByPlatformResponses[keyof TagsSitemapByPlatformResponses];

export type GoogleNewsSitemapByPlatformData = {
    body?: never;
    path: {
        platform: PlatformID;
    };
    query?: {
        cache?: boolean;
    };
    url: '/platform/{platform}/sitemap/google';
};

export type GoogleNewsSitemapByPlatformResponses = {
    /**
     * Success
     */
    200: Array<SitemapGoogleEntry>;
};

export type GoogleNewsSitemapByPlatformResponse = GoogleNewsSitemapByPlatformResponses[keyof GoogleNewsSitemapByPlatformResponses];

export type AuthorPagesSitemapByPlatformData = {
    body?: never;
    path: {
        platform: PlatformID;
    };
    query?: {
        cache?: boolean;
    };
    url: '/platform/{platform}/sitemap/authors';
};

export type AuthorPagesSitemapByPlatformResponses = {
    /**
     * Success
     */
    200: Array<SitemapEntry>;
};

export type AuthorPagesSitemapByPlatformResponse = AuthorPagesSitemapByPlatformResponses[keyof AuthorPagesSitemapByPlatformResponses];

export type MatchesSitemapByPlatformData = {
    body?: never;
    path: {
        platform: PlatformID;
    };
    query?: {
        cache?: boolean;
    };
    url: '/platform/{platform}/sitemap/matches';
};

export type MatchesSitemapByPlatformResponses = {
    /**
     * Success
     */
    200: Array<SitemapEntry>;
};

export type MatchesSitemapByPlatformResponse = MatchesSitemapByPlatformResponses[keyof MatchesSitemapByPlatformResponses];

export type WarmUpCacheWebpByPlatformData = {
    body: WarmUpCache;
    path: {
        platform: PlatformID;
    };
    query?: never;
    url: '/platform/{platform}/webp/warm-up-cache';
};

export type warmUpCacheWebpByPlatformErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type warmUpCacheWebpByPlatformError = warmUpCacheWebpByPlatformErrors[keyof warmUpCacheWebpByPlatformErrors];

export type ListModuleScheduleByPlatformLocaleData = {
    body?: never;
    path: {
        /**
         * will return items for a specific platform
         */
        platform: PlatformID;
        /**
         * will return items for a specific locale
         */
        locale: LocaleID;
    };
    query?: {
        /**
         * filter specific on the module schedule items for a given module
         */
        section?: ModuleScheduleSection;
        /**
         * filter on module schedule items with a given tagID (module schedule items's with NULL as tagID will also be returned), if null for scope public we only return items with tagID === null
         */
        tagID?: number;
        /**
         * will return items ordered by a given column
         */
        orderBy?: ModuleScheduleOrderByOptions;
        /**
         * order results in either ascending or descending order
         */
        order?: Order;
        scope?: Scope;
        /**
         * Filter items by ModuleScheduleStatus
         */
        status?: Array<ModuleScheduleStatus>;
        page?: number;
        perPage?: number;
        cache?: boolean;
    };
    url: '/platform/{platform}/locale/{locale}/module-schedule';
};

export type ListModuleScheduleByPlatformLocaleResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<ModuleScheduleItem>;
    };
};

export type ListModuleScheduleByPlatformLocaleResponse = ListModuleScheduleByPlatformLocaleResponses[keyof ListModuleScheduleByPlatformLocaleResponses];

export type CreateModuleScheduleByPlatformLocaleData = {
    body: ModuleScheduleItemActionCreateActionCreate;
    path: {
        platform: PlatformID;
        locale: LocaleID;
    };
    query?: never;
    url: '/platform/{platform}/locale/{locale}/module-schedule';
};

export type createModuleScheduleByPlatformLocaleErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createModuleScheduleByPlatformLocaleError = createModuleScheduleByPlatformLocaleErrors[keyof createModuleScheduleByPlatformLocaleErrors];

export type CreateModuleScheduleByPlatformLocaleResponses = {
    /**
     * Created
     */
    201: ModuleScheduleItem;
};

export type CreateModuleScheduleByPlatformLocaleResponse = CreateModuleScheduleByPlatformLocaleResponses[keyof CreateModuleScheduleByPlatformLocaleResponses];

export type DeleteModuleScheduleByPlatformLocaleData = {
    body?: never;
    path: {
        platform: PlatformID;
        locale: LocaleID;
        /**
         * will be used to remove a specific module schedule item
         */
        id: number;
    };
    query?: never;
    url: '/platform/{platform}/locale/{locale}/module-schedule/{id}';
};

export type deleteModuleScheduleByPlatformLocaleErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteModuleScheduleByPlatformLocaleError = deleteModuleScheduleByPlatformLocaleErrors[keyof deleteModuleScheduleByPlatformLocaleErrors];

export type DeleteModuleScheduleByPlatformLocaleResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteModuleScheduleByPlatformLocaleResponse = DeleteModuleScheduleByPlatformLocaleResponses[keyof DeleteModuleScheduleByPlatformLocaleResponses];

export type PatchModuleScheduleByPlatformLocaleData = {
    body: ModuleScheduleItemActionPatch;
    path: {
        platform: PlatformID;
        locale: LocaleID;
        /**
         * will be used to update a specific module schedule item
         */
        id: number;
    };
    query?: never;
    url: '/platform/{platform}/locale/{locale}/module-schedule/{id}';
};

export type patchModuleScheduleByPlatformLocaleErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type patchModuleScheduleByPlatformLocaleError = patchModuleScheduleByPlatformLocaleErrors[keyof patchModuleScheduleByPlatformLocaleErrors];

export type PatchModuleScheduleByPlatformLocaleResponses = {
    /**
     * Success
     */
    200: ModuleScheduleItem;
};

export type PatchModuleScheduleByPlatformLocaleResponse = PatchModuleScheduleByPlatformLocaleResponses[keyof PatchModuleScheduleByPlatformLocaleResponses];

export type ListNotificationBarByPlatformLocaleData = {
    body?: never;
    path: {
        /**
         * will return items for a specific platform
         */
        platform: PlatformID;
        /**
         * will return items for a specific locale
         */
        locale: LocaleID;
    };
    query?: {
        scope?: Scope;
        /**
         * Order items by priority or startTime.
         */
        orderBy?: Array<NotificationBarOrderByOption>;
        active?: boolean;
        /**
         * current page
         */
        page?: number;
        /**
         * amount of items per page
         */
        perPage?: number;
        cache?: boolean;
    };
    url: '/platform/{platform}/locale/{locale}/notification-bar';
};

export type ListNotificationBarByPlatformLocaleResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<NotificationBar>;
    };
};

export type ListNotificationBarByPlatformLocaleResponse = ListNotificationBarByPlatformLocaleResponses[keyof ListNotificationBarByPlatformLocaleResponses];

export type CreateNotificationBarByPlatformLocaleData = {
    body: NotificationBarActionCreateActionCreate;
    path: {
        platform: PlatformID;
        locale: LocaleID;
    };
    query?: never;
    url: '/platform/{platform}/locale/{locale}/notification-bar';
};

export type createNotificationBarByPlatformLocaleErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createNotificationBarByPlatformLocaleError = createNotificationBarByPlatformLocaleErrors[keyof createNotificationBarByPlatformLocaleErrors];

export type CreateNotificationBarByPlatformLocaleResponses = {
    /**
     * Created
     */
    201: NotificationBar;
};

export type CreateNotificationBarByPlatformLocaleResponse = CreateNotificationBarByPlatformLocaleResponses[keyof CreateNotificationBarByPlatformLocaleResponses];

export type DeleteNotificationBarByPlatformLocaleData = {
    body?: never;
    path: {
        platform: PlatformID;
        locale: LocaleID;
        /**
         * will be used to remove an existing notification bar item
         */
        id: number;
    };
    query?: never;
    url: '/platform/{platform}/locale/{locale}/notification-bar/{id}';
};

export type deleteNotificationBarByPlatformLocaleErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteNotificationBarByPlatformLocaleError = deleteNotificationBarByPlatformLocaleErrors[keyof deleteNotificationBarByPlatformLocaleErrors];

export type DeleteNotificationBarByPlatformLocaleResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteNotificationBarByPlatformLocaleResponse = DeleteNotificationBarByPlatformLocaleResponses[keyof DeleteNotificationBarByPlatformLocaleResponses];

export type PatchNotificationBarByPlatformLocaleData = {
    body: NotificationBarActionPatch;
    path: {
        platform: PlatformID;
        locale: LocaleID;
        /**
         * will be used to update a specific notification bar item
         */
        id: number;
    };
    query?: never;
    url: '/platform/{platform}/locale/{locale}/notification-bar/{id}';
};

export type patchNotificationBarByPlatformLocaleErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type patchNotificationBarByPlatformLocaleError = patchNotificationBarByPlatformLocaleErrors[keyof patchNotificationBarByPlatformLocaleErrors];

export type PatchNotificationBarByPlatformLocaleResponses = {
    /**
     * Success
     */
    200: NotificationBar;
};

export type PatchNotificationBarByPlatformLocaleResponse = PatchNotificationBarByPlatformLocaleResponses[keyof PatchNotificationBarByPlatformLocaleResponses];

export type GetOddsDossierByPlatformLocaleData = {
    body?: never;
    path: {
        platform: PlatformID;
        /**
         * will return odds dossier data for a specific locale
         */
        locale: LocaleID;
    };
    query?: {
        cache?: boolean;
    };
    url: '/platform/{platform}/locale/{locale}/odds-dossier';
};

export type GetOddsDossierByPlatformLocaleResponses = {
    /**
     * Success
     */
    200: OddsDossier;
};

export type GetOddsDossierByPlatformLocaleResponse = GetOddsDossierByPlatformLocaleResponses[keyof GetOddsDossierByPlatformLocaleResponses];

export type UpsertOddsDossierByPlatformLocaleData = {
    body: OddsDossierActionUpsert;
    path: {
        platform: PlatformID;
        /**
         * Specify which locale this odds dossier belongs to
         */
        locale: LocaleID;
    };
    query?: never;
    url: '/platform/{platform}/locale/{locale}/odds-dossier';
};

export type upsertOddsDossierByPlatformLocaleErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type upsertOddsDossierByPlatformLocaleError = upsertOddsDossierByPlatformLocaleErrors[keyof upsertOddsDossierByPlatformLocaleErrors];

export type UpsertOddsDossierByPlatformLocaleResponses = {
    /**
     * Success
     */
    200: OddsDossier;
    /**
     * Created
     */
    201: OddsDossier;
};

export type UpsertOddsDossierByPlatformLocaleResponse = UpsertOddsDossierByPlatformLocaleResponses[keyof UpsertOddsDossierByPlatformLocaleResponses];

export type GetConfigByPlatformLocaleData = {
    body?: never;
    path: {
        platform: PlatformID;
        locale: LocaleID;
    };
    query?: {
        key?: ConfigKey;
        cache?: boolean;
    };
    url: '/platform/{platform}/locale/{locale}/config';
};

export type GetConfigByPlatformLocaleResponses = {
    /**
     * Success
     */
    200: Config;
};

export type GetConfigByPlatformLocaleResponse = GetConfigByPlatformLocaleResponses[keyof GetConfigByPlatformLocaleResponses];

export type UpsertConfigByPlatformLocaleData = {
    body: Config;
    path: {
        platform: PlatformID;
        locale: LocaleID;
    };
    query?: never;
    url: '/platform/{platform}/locale/{locale}/config';
};

export type upsertConfigByPlatformLocaleErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type upsertConfigByPlatformLocaleError = upsertConfigByPlatformLocaleErrors[keyof upsertConfigByPlatformLocaleErrors];

export type UpsertConfigByPlatformLocaleResponses = {
    /**
     * Success
     */
    200: Config;
    /**
     * Created
     */
    201: Config;
};

export type UpsertConfigByPlatformLocaleResponse = UpsertConfigByPlatformLocaleResponses[keyof UpsertConfigByPlatformLocaleResponses];

export type SignInPasswordSecureData = {
    body: SignInPassword;
    headers?: {
        /**
         * `st-auth-mode` will be automatically set to the right value by the client Supertokens SDKs, so you don't need to set it manually. You only need to set it when doing requests directly to the API from an environment that doesn't use a Supertokens SDK. When doing requests from the Swagger docs page, it must be set to `cookie`, such that the access token and refresh token are returned as cookies (using the `Set-Cookie` header). See <https://supertokens.com/docs/emailpassword/common-customizations/sessions/token-transfer-method>.
         */
        'st-auth-mode'?: SupertokensAuthMode;
    };
    path?: never;
    query?: never;
    url: '/secure/sign-in-password';
};

export type signInPasswordSecureErrors = {
    /**
     * Bad Request
     */
    400: ValidationError;
};

export type signInPasswordSecureError = signInPasswordSecureErrors[keyof signInPasswordSecureErrors];

export type SignInPasswordSecureResponses = {
    /**
     * No Content
     */
    204: void;
};

export type SignInPasswordSecureResponse = SignInPasswordSecureResponses[keyof SignInPasswordSecureResponses];

export type LinkAndSignInPasswordSecureData = {
    body: LinkAndSignInPassword;
    headers?: {
        /**
         * `st-auth-mode` will be automatically set to the right value by the client Supertokens SDKs, so you don't need to set it manually. You only need to set it when doing requests directly to the API from an environment that doesn't use a Supertokens SDK. When doing requests from the Swagger docs page, it must be set to `cookie`, such that the access token and refresh token are returned as cookies (using the `Set-Cookie` header). See <https://supertokens.com/docs/emailpassword/common-customizations/sessions/token-transfer-method>.
         */
        'st-auth-mode'?: SupertokensAuthMode;
    };
    path?: never;
    query?: never;
    url: '/secure/link-and-sign-in-password';
};

export type linkAndSignInPasswordSecureErrors = {
    /**
     * Bad Request
     */
    400: ValidationError;
};

export type linkAndSignInPasswordSecureError = linkAndSignInPasswordSecureErrors[keyof linkAndSignInPasswordSecureErrors];

export type LinkAndSignInPasswordSecureResponses = {
    /**
     * No Content
     */
    204: void;
};

export type LinkAndSignInPasswordSecureResponse = LinkAndSignInPasswordSecureResponses[keyof LinkAndSignInPasswordSecureResponses];

export type SignUpPasswordSecureData = {
    body: SignUpPassword;
    headers?: {
        /**
         * `st-auth-mode` will be automatically set to the right value by the client Supertokens SDKs, so you don't need to set it manually. You only need to set it when doing requests directly to the API from an environment that doesn't use a Supertokens SDK. When doing requests from the Swagger docs page, it must be set to `cookie`, such that the access token and refresh token are returned as cookies (using the `Set-Cookie` header). See <https://supertokens.com/docs/emailpassword/common-customizations/sessions/token-transfer-method>.
         */
        'st-auth-mode'?: SupertokensAuthMode;
    };
    path?: never;
    query: {
        editionID: number;
        client: Client;
    };
    url: '/secure/sign-up-password';
};

export type signUpPasswordSecureErrors = {
    /**
     * Bad Request
     */
    400: ValidationError;
};

export type signUpPasswordSecureError = signUpPasswordSecureErrors[keyof signUpPasswordSecureErrors];

export type SignUpPasswordSecureResponses = {
    /**
     * No Content
     */
    204: void;
};

export type SignUpPasswordSecureResponse = SignUpPasswordSecureResponses[keyof SignUpPasswordSecureResponses];

export type DeleteSupertokensUsersNotLinkedToNextUserSecureData = {
    body?: never;
    path?: never;
    query?: {
        isDryRun?: boolean;
    };
    url: '/secure/supertokens-users-not-linked-to-next-user';
};

export type deleteSupertokensUsersNotLinkedToNextUserSecureErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteSupertokensUsersNotLinkedToNextUserSecureError = deleteSupertokensUsersNotLinkedToNextUserSecureErrors[keyof deleteSupertokensUsersNotLinkedToNextUserSecureErrors];

export type DeleteSupertokensUsersNotLinkedToNextUserSecureResponses = {
    /**
     * Success
     */
    200: DeleteSupertokensUsersNotLinkedToNextUserResult;
};

export type DeleteSupertokensUsersNotLinkedToNextUserSecureResponse = DeleteSupertokensUsersNotLinkedToNextUserSecureResponses[keyof DeleteSupertokensUsersNotLinkedToNextUserSecureResponses];

export type SendVerificationEmailSecureData = {
    body?: never;
    path?: never;
    query: {
        editionID: number;
    };
    url: '/secure/send-verification-email';
};

export type SendVerificationEmailSecureResponses = {
    /**
     * No Content
     */
    204: void;
};

export type SendVerificationEmailSecureResponse = SendVerificationEmailSecureResponses[keyof SendVerificationEmailSecureResponses];

export type VerifyEmailSecureData = {
    body: EmailVerify;
    path?: never;
    query?: never;
    url: '/secure/verify-email';
};

export type verifyEmailSecureErrors = {
    /**
     * Bad Request
     */
    400: BadRequest;
};

export type verifyEmailSecureError = verifyEmailSecureErrors[keyof verifyEmailSecureErrors];

export type VerifyEmailSecureResponses = {
    /**
     * No Content
     */
    204: void;
};

export type VerifyEmailSecureResponse = VerifyEmailSecureResponses[keyof VerifyEmailSecureResponses];

export type VerifyChangedEmailSecureData = {
    body: EmailVerify;
    path?: never;
    query?: never;
    url: '/secure/verify-changed-email';
};

export type verifyChangedEmailSecureErrors = {
    /**
     * Bad Request
     */
    400: BadRequest;
};

export type verifyChangedEmailSecureError = verifyChangedEmailSecureErrors[keyof verifyChangedEmailSecureErrors];

export type VerifyChangedEmailSecureResponses = {
    /**
     * No Content
     */
    204: void;
};

export type VerifyChangedEmailSecureResponse = VerifyChangedEmailSecureResponses[keyof VerifyChangedEmailSecureResponses];

export type SendPasswordResetEmailSecureData = {
    body: {
        email: string;
    };
    path?: never;
    query: {
        editionID: number;
    };
    url: '/secure/send-password-reset-email';
};

export type sendPasswordResetEmailSecureErrors = {
    /**
     * Bad Request
     */
    400: BadRequest;
    /**
     * Forbidden
     */
    403: Forbidden;
    /**
     * Not Found
     */
    404: NotFound;
};

export type sendPasswordResetEmailSecureError = sendPasswordResetEmailSecureErrors[keyof sendPasswordResetEmailSecureErrors];

export type SendPasswordResetEmailSecureResponses = {
    /**
     * No Content
     */
    204: void;
};

export type SendPasswordResetEmailSecureResponse = SendPasswordResetEmailSecureResponses[keyof SendPasswordResetEmailSecureResponses];

export type ResetPasswordSecureData = {
    body: PasswordReset;
    path?: never;
    query?: never;
    url: '/secure/reset-password';
};

export type resetPasswordSecureErrors = {
    /**
     * Bad Request
     */
    400: BadRequest;
};

export type resetPasswordSecureError = resetPasswordSecureErrors[keyof resetPasswordSecureErrors];

export type ResetPasswordSecureResponses = {
    /**
     * No Content
     */
    204: void;
};

export type ResetPasswordSecureResponse = ResetPasswordSecureResponses[keyof ResetPasswordSecureResponses];

export type UpdatePasswordSecureData = {
    body: PasswordUpdate;
    path?: never;
    query?: never;
    url: '/secure/update-password';
};

export type updatePasswordSecureErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type updatePasswordSecureError = updatePasswordSecureErrors[keyof updatePasswordSecureErrors];

export type UpdatePasswordSecureResponses = {
    /**
     * No Content
     */
    204: void;
};

export type UpdatePasswordSecureResponse = UpdatePasswordSecureResponses[keyof UpdatePasswordSecureResponses];

export type GetAccessTokenPayloadSecureData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/secure/access-token-payload';
};

export type getAccessTokenPayloadSecureErrors = {
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getAccessTokenPayloadSecureError = getAccessTokenPayloadSecureErrors[keyof getAccessTokenPayloadSecureErrors];

export type GetAccessTokenPayloadSecureResponses = {
    /**
     * Success
     */
    200: AccessTokenPayload;
};

export type GetAccessTokenPayloadSecureResponse = GetAccessTokenPayloadSecureResponses[keyof GetAccessTokenPayloadSecureResponses];

export type CreateMissingSupertokensUserSecureData = {
    body?: never;
    path: {
        userID: number;
    };
    query?: never;
    url: '/secure/create-missing-supertokens-user/{userID}';
};

export type createMissingSupertokensUserSecureErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createMissingSupertokensUserSecureError = createMissingSupertokensUserSecureErrors[keyof createMissingSupertokensUserSecureErrors];

export type CreateMissingSupertokensUserSecureResponses = {
    /**
     * No Content
     */
    204: void;
};

export type CreateMissingSupertokensUserSecureResponse = CreateMissingSupertokensUserSecureResponses[keyof CreateMissingSupertokensUserSecureResponses];

export type DeleteOrphanedSupertokensUserSecureData = {
    body?: never;
    path: {
        stUserID: string;
    };
    query?: never;
    url: '/secure/orphaned-supertokens-user/{stUserID}';
};

export type deleteOrphanedSupertokensUserSecureErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteOrphanedSupertokensUserSecureError = deleteOrphanedSupertokensUserSecureErrors[keyof deleteOrphanedSupertokensUserSecureErrors];

export type DeleteOrphanedSupertokensUserSecureResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteOrphanedSupertokensUserSecureResponse = DeleteOrphanedSupertokensUserSecureResponses[keyof DeleteOrphanedSupertokensUserSecureResponses];

export type GetStatusData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/status';
};

export type GetStatusResponses = {
    /**
     * Success
     */
    200: string;
};

export type GetStatusResponse = GetStatusResponses[keyof GetStatusResponses];

export type CreateTestEventData = {
    body: TestEventRequest;
    path?: never;
    query?: never;
    url: '/test/publishEvent';
};

export type createTestEventErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createTestEventError = createTestEventErrors[keyof createTestEventErrors];

export type CreateTestEventResponses = {
    /**
     * Success
     */
    200: boolean;
};

export type CreateTestEventResponse = CreateTestEventResponses[keyof CreateTestEventResponses];

export type SyncTotoData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/toto/sync';
};

export type syncTotoErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type syncTotoError = syncTotoErrors[keyof syncTotoErrors];

export type SyncTotoResponses = {
    /**
     * Success
     */
    200: TotoSyncResult;
};

export type SyncTotoResponse = SyncTotoResponses[keyof SyncTotoResponses];

export type ImportOddsTotoData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/toto/import/odds';
};

export type importOddsTotoErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type importOddsTotoError = importOddsTotoErrors[keyof importOddsTotoErrors];

export type ImportOddsTotoResponses = {
    /**
     * Success
     */
    200: TotoOddsImportResult;
};

export type ImportOddsTotoResponse = ImportOddsTotoResponses[keyof ImportOddsTotoResponses];

export type ImportOddsUnibetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/unibet/import/odds';
};

export type importOddsUnibetErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type importOddsUnibetError = importOddsUnibetErrors[keyof importOddsUnibetErrors];

export type ImportOddsUnibetResponses = {
    /**
     * Success
     */
    200: KambiOddsImportResult;
};

export type ImportOddsUnibetResponse = ImportOddsUnibetResponses[keyof ImportOddsUnibetResponses];

export type ListUserData = {
    body?: never;
    path?: never;
    query?: {
        search?: string;
        /**
         * current page
         */
        page?: number;
        /**
         * amount of items per page
         */
        perPage?: number;
        /**
         * filter on userRole
         */
        userRoles?: Array<UserRole>;
        cache?: boolean;
    };
    url: '/user';
};

export type listUserErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type listUserError = listUserErrors[keyof listUserErrors];

export type ListUserResponses = {
    /**
     * Success
     */
    200: {
        pagination?: Pagination;
        data?: Array<User>;
    };
};

export type ListUserResponse = ListUserResponses[keyof ListUserResponses];

export type GetAuthorByCustomSlugUserData = {
    body?: never;
    path: {
        /**
         * Get user by customSlug
         */
        slug: string;
    };
    query?: {
        editionID?: number;
        cache?: boolean;
    };
    url: '/user/author/{slug}';
};

export type GetAuthorByCustomSlugUserResponses = {
    /**
     * Success
     */
    200: Author;
};

export type GetAuthorByCustomSlugUserResponse = GetAuthorByCustomSlugUserResponses[keyof GetAuthorByCustomSlugUserResponses];

export type ListAuthorsUserData = {
    body?: never;
    path?: never;
    query: {
        contextID: number;
        /**
         * will filter authors that to show them on home page
         */
        showOnHome?: boolean;
        /**
         * will filter authors on the first name
         */
        firstName?: string;
        cache?: boolean;
    };
    url: '/user/authors';
};

export type ListAuthorsUserResponses = {
    /**
     * Success
     */
    200: Array<Author>;
};

export type ListAuthorsUserResponse = ListAuthorsUserResponses[keyof ListAuthorsUserResponses];

export type DeleteProfileUserData = {
    body: ProfileDelete;
    path?: never;
    query?: never;
    url: '/user/profile';
};

export type deleteProfileUserErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteProfileUserError = deleteProfileUserErrors[keyof deleteProfileUserErrors];

export type DeleteProfileUserResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteProfileUserResponse = DeleteProfileUserResponses[keyof DeleteProfileUserResponses];

export type GetProfileByIdUserData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Used to get the `author` property.
         */
        editionID?: number;
    };
    url: '/user/profile';
};

export type getProfileByIdUserErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getProfileByIdUserError = getProfileByIdUserErrors[keyof getProfileByIdUserErrors];

export type GetProfileByIdUserResponses = {
    /**
     * Success
     */
    200: User;
};

export type GetProfileByIdUserResponse = GetProfileByIdUserResponses[keyof GetProfileByIdUserResponses];

export type PatchProfileUserData = {
    body: ProfileActionPatch;
    path?: never;
    query?: {
        editionID?: number;
    };
    url: '/user/profile';
};

export type patchProfileUserErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
    /**
     * Not Found
     */
    404: NotFound;
};

export type patchProfileUserError = patchProfileUserErrors[keyof patchProfileUserErrors];

export type PatchProfileUserResponses = {
    /**
     * Success
     */
    200: User;
};

export type PatchProfileUserResponse = PatchProfileUserResponses[keyof PatchProfileUserResponses];

export type GetExtraInfoUserData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/user/extra-info';
};

export type getExtraInfoUserErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getExtraInfoUserError = getExtraInfoUserErrors[keyof getExtraInfoUserErrors];

export type GetExtraInfoUserResponses = {
    /**
     * Success
     */
    200: ExtraZenoData;
};

export type GetExtraInfoUserResponse = GetExtraInfoUserResponses[keyof GetExtraInfoUserResponses];

export type GetAdminAccessInfoUserData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/user/admin-access/info';
};

export type getAdminAccessInfoUserErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getAdminAccessInfoUserError = getAdminAccessInfoUserErrors[keyof getAdminAccessInfoUserErrors];

export type GetAdminAccessInfoUserResponses = {
    /**
     * Success
     */
    200: AdminAccessInfo;
};

export type GetAdminAccessInfoUserResponse = GetAdminAccessInfoUserResponses[keyof GetAdminAccessInfoUserResponses];

export type GetUserTenantsUserData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/user/tenant';
};

export type getUserTenantsUserErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getUserTenantsUserError = getUserTenantsUserErrors[keyof getUserTenantsUserErrors];

export type GetUserTenantsUserResponses = {
    /**
     * Success
     */
    200: Array<{
        [key: string]: unknown;
    }>;
};

export type GetUserTenantsUserResponse = GetUserTenantsUserResponses[keyof GetUserTenantsUserResponses];

export type DisassociateUserFromTenantUserData = {
    body: DisassociateUserFromTenant;
    path: {
        tenantID: PlatformID;
    };
    query?: never;
    url: '/user/tenant/{tenantID}';
};

export type disassociateUserFromTenantUserErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type disassociateUserFromTenantUserError = disassociateUserFromTenantUserErrors[keyof disassociateUserFromTenantUserErrors];

export type DisassociateUserFromTenantUserResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DisassociateUserFromTenantUserResponse = DisassociateUserFromTenantUserResponses[keyof DisassociateUserFromTenantUserResponses];

export type AssociateUserWithTenantUserData = {
    body?: NewsletterOptIn;
    path: {
        tenantID: PlatformID;
    };
    query?: never;
    url: '/user/tenant/{tenantID}';
};

export type associateUserWithTenantUserErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type associateUserWithTenantUserError = associateUserWithTenantUserErrors[keyof associateUserWithTenantUserErrors];

export type AssociateUserWithTenantUserResponses = {
    /**
     * No Content
     */
    204: void;
};

export type AssociateUserWithTenantUserResponse = AssociateUserWithTenantUserResponses[keyof AssociateUserWithTenantUserResponses];

export type DeleteUserData = {
    body?: never;
    path: {
        /**
         * Will be used to remove a user
         */
        userID: number;
    };
    query?: never;
    url: '/user/{userID}';
};

export type deleteUserErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteUserError = deleteUserErrors[keyof deleteUserErrors];

export type DeleteUserResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteUserResponse = DeleteUserResponses[keyof DeleteUserResponses];

export type GetByIdUserData = {
    body?: never;
    path: {
        /**
         * Get user by id
         */
        userID: number;
    };
    query?: {
        /**
         * Used to get the `author` property.
         */
        editionID?: number;
    };
    url: '/user/{userID}';
};

export type getByIdUserErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getByIdUserError = getByIdUserErrors[keyof getByIdUserErrors];

export type GetByIdUserResponses = {
    /**
     * Success
     */
    200: User;
};

export type GetByIdUserResponse = GetByIdUserResponses[keyof GetByIdUserResponses];

export type PatchUserData = {
    body: UserActionPatch;
    path: {
        userID: number;
    };
    query?: {
        /**
         * Required when patching the `author` property.
         */
        editionID?: number;
    };
    url: '/user/{userID}';
};

export type patchUserErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
    /**
     * Not Found
     */
    404: NotFound;
};

export type patchUserError = patchUserErrors[keyof patchUserErrors];

export type PatchUserResponses = {
    /**
     * Success
     */
    200: User;
};

export type PatchUserResponse = PatchUserResponses[keyof PatchUserResponses];

export type UsernameExistsUserData = {
    body?: never;
    path?: never;
    query: {
        username: string;
        cache?: boolean;
    };
    url: '/user/username/exists';
};

export type UsernameExistsUserResponses = {
    /**
     * Success
     */
    200: boolean;
};

export type UsernameExistsUserResponse = UsernameExistsUserResponses[keyof UsernameExistsUserResponses];

export type EmailExistsUserData = {
    body?: never;
    path?: never;
    query: {
        email: string;
        cache?: boolean;
    };
    url: '/user/email/exists';
};

export type EmailExistsUserResponses = {
    /**
     * Success
     */
    200: boolean;
};

export type EmailExistsUserResponse = EmailExistsUserResponses[keyof EmailExistsUserResponses];

export type EmailOrUsernameExistsUserData = {
    body?: never;
    path?: never;
    query: {
        emailOrUsername: string;
        editionID?: number;
        cache?: boolean;
    };
    url: '/user/email-or-username/exists';
};

export type EmailOrUsernameExistsUserResponses = {
    /**
     * Success
     */
    200: EmailOrUsernameExists;
};

export type EmailOrUsernameExistsUserResponse = EmailOrUsernameExistsUserResponses[keyof EmailOrUsernameExistsUserResponses];

export type ChangeEmailUserData = {
    body: EmailUpdate;
    path?: never;
    query: {
        editionID: number;
    };
    url: '/user/profile/email';
};

export type changeEmailUserErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type changeEmailUserError = changeEmailUserErrors[keyof changeEmailUserErrors];

export type ChangeEmailUserResponses = {
    /**
     * Success
     */
    200: EmailUpdateResponse;
};

export type ChangeEmailUserResponse = ChangeEmailUserResponses[keyof ChangeEmailUserResponses];

export type SetGeneratedPasswordUserData = {
    body?: never;
    path: {
        userID: number;
    };
    query?: never;
    url: '/user/{userID}/set-generated-password';
};

export type setGeneratedPasswordUserErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type setGeneratedPasswordUserError = setGeneratedPasswordUserErrors[keyof setGeneratedPasswordUserErrors];

export type SetGeneratedPasswordUserResponses = {
    /**
     * Success
     */
    200: GeneratedPassword;
};

export type SetGeneratedPasswordUserResponse = SetGeneratedPasswordUserResponses[keyof SetGeneratedPasswordUserResponses];

export type SyncStagingSupertokensUsersUserData = {
    body?: {
        passwordSuffix?: string;
    };
    path?: never;
    query?: never;
    url: '/user/sync-supertokens-users';
};

export type syncStagingSupertokensUsersUserErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type syncStagingSupertokensUsersUserError = syncStagingSupertokensUsersUserErrors[keyof syncStagingSupertokensUsersUserErrors];

export type RenewZenoStatusUserData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * the number of users to be processed
         */
        amount?: number;
    };
    url: '/user/renew-zeno-status';
};

export type renewZenoStatusUserErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
    /**
     * Too Many Requests
     */
    429: TooManyRequests;
};

export type renewZenoStatusUserError = renewZenoStatusUserErrors[keyof renewZenoStatusUserErrors];

export type RenewZenoStatusUserResponses = {
    /**
     * Success
     */
    200: ZenoRenewalCronResult;
};

export type RenewZenoStatusUserResponse = RenewZenoStatusUserResponses[keyof RenewZenoStatusUserResponses];

export type GetForThirdPartyUserData = {
    body?: never;
    path: {
        userID: number;
    };
    query?: never;
    url: '/user/third-party/{userID}';
};

export type getForThirdPartyUserErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type getForThirdPartyUserError = getForThirdPartyUserErrors[keyof getForThirdPartyUserErrors];

export type GetForThirdPartyUserResponses = {
    /**
     * Success
     */
    200: UserThirdPartyResponse;
};

export type GetForThirdPartyUserResponse = GetForThirdPartyUserResponses[keyof GetForThirdPartyUserResponses];

export type ImportViArticleViMigrationData = {
    body?: never;
    path: {
        /**
         * UUID ID of the magnolia article
         */
        uuid: string;
    };
    query?: {
        /**
         * is the article pro?
         */
        pro?: boolean;
    };
    url: '/vi-migration/import/{uuid}';
};

export type importViArticleViMigrationErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type importViArticleViMigrationError = importViArticleViMigrationErrors[keyof importViArticleViMigrationErrors];

export type ImportViArticleViMigrationResponses = {
    /**
     * Success
     */
    200: {
        [key: string]: unknown;
    };
};

export type ImportViArticleViMigrationResponse = ImportViArticleViMigrationResponses[keyof ImportViArticleViMigrationResponses];

export type CreateSupertokensUsersViMigrationData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/vi-migration/link-authors-to-supertokens';
};

export type createSupertokensUsersViMigrationErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type createSupertokensUsersViMigrationError = createSupertokensUsersViMigrationErrors[keyof createSupertokensUsersViMigrationErrors];

export type CreateSupertokensUsersViMigrationResponses = {
    /**
     * No Content
     */
    204: void;
};

export type CreateSupertokensUsersViMigrationResponse = CreateSupertokensUsersViMigrationResponses[keyof CreateSupertokensUsersViMigrationResponses];

export type ScheduleRecentViMigrationData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * the number of articles to be scheduled
         */
        amount?: number;
    };
    url: '/vi-migration/schedule-recent';
};

export type scheduleRecentViMigrationErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type scheduleRecentViMigrationError = scheduleRecentViMigrationErrors[keyof scheduleRecentViMigrationErrors];

export type ScheduleRecentViMigrationResponses = {
    /**
     * Success
     */
    200: {
        [key: string]: unknown;
    };
};

export type ScheduleRecentViMigrationResponse = ScheduleRecentViMigrationResponses[keyof ScheduleRecentViMigrationResponses];

export type NextViMigrationData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * the number of articles to be imported
         */
        amount?: number;
    };
    url: '/vi-migration/next';
};

export type nextViMigrationErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type nextViMigrationError = nextViMigrationErrors[keyof nextViMigrationErrors];

export type NextViMigrationResponses = {
    /**
     * Success
     */
    200: {
        [key: string]: unknown;
    };
};

export type NextViMigrationResponse = NextViMigrationResponses[keyof NextViMigrationResponses];

export type ScheduleAllViMigrationData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/vi-migration/schedule-all';
};

export type scheduleAllViMigrationErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type scheduleAllViMigrationError = scheduleAllViMigrationErrors[keyof scheduleAllViMigrationErrors];

export type ScheduleAllViMigrationResponses = {
    /**
     * Success
     */
    200: {
        [key: string]: unknown;
    };
};

export type ScheduleAllViMigrationResponse = ScheduleAllViMigrationResponses[keyof ScheduleAllViMigrationResponses];

export type ImportUserViMigrationData = {
    body?: {
        allowRetryOfFailed?: boolean;
    };
    path: {
        /**
         * UUID of the Keycloak user.
         */
        uuid: string;
    };
    query?: never;
    url: '/vi-migration/import-user/{uuid}';
};

export type importUserViMigrationErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type importUserViMigrationError = importUserViMigrationErrors[keyof importUserViMigrationErrors];

export type ImportUserViMigrationResponses = {
    /**
     * Created
     */
    201: User;
};

export type ImportUserViMigrationResponse = ImportUserViMigrationResponses[keyof ImportUserViMigrationResponses];

export type ImportUsersBatchViMigrationData = {
    body: {
        batchSize: number;
        allowRetryOfFailed?: boolean;
        onlyVIEmailAddresses?: boolean;
    };
    path?: never;
    query?: never;
    url: '/vi-migration/import-users';
};

export type importUsersBatchViMigrationErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
    /**
     * Too Many Requests
     */
    429: TooManyRequests;
};

export type importUsersBatchViMigrationError = importUsersBatchViMigrationErrors[keyof importUsersBatchViMigrationErrors];

export type ImportUsersBatchViMigrationResponses = {
    /**
     * Success
     */
    200: VIImportUsersBatchResult;
};

export type ImportUsersBatchViMigrationResponse = ImportUsersBatchViMigrationResponses[keyof ImportUsersBatchViMigrationResponses];

export type DeleteCorruptedUsersViMigrationData = {
    body?: never;
    path?: never;
    query: {
        dryRun: boolean;
    };
    url: '/vi-migration/delete-corrupted-users';
};

export type deleteCorruptedUsersViMigrationErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type deleteCorruptedUsersViMigrationError = deleteCorruptedUsersViMigrationErrors[keyof deleteCorruptedUsersViMigrationErrors];

export type DeleteCorruptedUsersViMigrationResponses = {
    /**
     * Success
     */
    200: DeleteCorruptedUsersResult;
};

export type DeleteCorruptedUsersViMigrationResponse = DeleteCorruptedUsersViMigrationResponses[keyof DeleteCorruptedUsersViMigrationResponses];

export type PrepareViafouraCommentsViMigrationData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/vi-migration/prepare-viafoura-comments';
};

export type prepareViafouraCommentsViMigrationErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type prepareViafouraCommentsViMigrationError = prepareViafouraCommentsViMigrationErrors[keyof prepareViafouraCommentsViMigrationErrors];

export type PrepareViafouraCommentsViMigrationResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PrepareViafouraCommentsViMigrationResponse = PrepareViafouraCommentsViMigrationResponses[keyof PrepareViafouraCommentsViMigrationResponses];

export type ImportViafouraCommentsViMigrationData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/vi-migration/migrate-viafoura-comments';
};

export type importViafouraCommentsViMigrationErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type importViafouraCommentsViMigrationError = importViafouraCommentsViMigrationErrors[keyof importViafouraCommentsViMigrationErrors];

export type ImportViafouraCommentsViMigrationResponses = {
    /**
     * No Content
     */
    204: void;
};

export type ImportViafouraCommentsViMigrationResponse = ImportViafouraCommentsViMigrationResponses[keyof ImportViafouraCommentsViMigrationResponses];

export type ImportViBookmarksViMigrationData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/vi-migration/import-bookmarks';
};

export type importViBookmarksViMigrationErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type importViBookmarksViMigrationError = importViBookmarksViMigrationErrors[keyof importViBookmarksViMigrationErrors];

export type ImportViBookmarksViMigrationResponses = {
    /**
     * No Content
     */
    204: void;
};

export type ImportViBookmarksViMigrationResponse = ImportViBookmarksViMigrationResponses[keyof ImportViBookmarksViMigrationResponses];

export type MergeOptaTagsViMigrationData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/vi-migration/merge-opta-tags';
};

export type mergeOptaTagsViMigrationErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type mergeOptaTagsViMigrationError = mergeOptaTagsViMigrationErrors[keyof mergeOptaTagsViMigrationErrors];

export type ReplaceLinksViMigrationData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * offset the replace links should start from
         */
        offset?: number;
    };
    url: '/vi-migration/replace-links';
};

export type replaceLinksViMigrationErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type replaceLinksViMigrationError = replaceLinksViMigrationErrors[keyof replaceLinksViMigrationErrors];

export type ReplaceLinksViMigrationResponses = {
    /**
     * No Content
     */
    204: void;
};

export type ReplaceLinksViMigrationResponse = ReplaceLinksViMigrationResponses[keyof ReplaceLinksViMigrationResponses];

export type GetGeoBlockData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/geoBlock';
};

export type GetGeoBlockResponses = {
    /**
     * Success
     */
    200: boolean;
};

export type GetGeoBlockResponse = GetGeoBlockResponses[keyof GetGeoBlockResponses];

export type HubWebSubData = {
    body: HubBody;
    path?: never;
    query?: never;
    url: '/websub/hub';
};

export type HubWebSubResponses = {
    /**
     * Accepted
     */
    202: string;
};

export type HubWebSubResponse = HubWebSubResponses[keyof HubWebSubResponses];

export type PublishIfNeededWebSubData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/websub/publish-if-needed';
};

export type publishIfNeededWebSubErrors = {
    /**
     * Unauthorized
     */
    401: Unauthorized;
    /**
     * Forbidden
     */
    403: Forbidden;
};

export type publishIfNeededWebSubError = publishIfNeededWebSubErrors[keyof publishIfNeededWebSubErrors];

export type PublishIfNeededWebSubResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PublishIfNeededWebSubResponse = PublishIfNeededWebSubResponses[keyof PublishIfNeededWebSubResponses];
